import * as i1$3 from '@angular/cdk/overlay';
import { OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import * as i3 from '@angular/cdk/portal';
import { PortalModule } from '@angular/cdk/portal';
import * as i1$1 from '@angular/common';
import { DatePipe, DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Pipe, EventEmitter, TemplateRef, Component, Input, Output, Injectable, HostListener, ViewChild, ChangeDetectionStrategy, inject, Renderer2, ElementRef, Inject, ContentChildren, InjectionToken, NgModule, Injector, Optional } from '@angular/core';
import * as i2 from '@angular/forms';
import { FormGroup, UntypedFormGroup, UntypedFormArray, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i1$4 from '@angular/material/snack-bar';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i2$1 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import * as i1 from '@angular/platform-browser';
import { Subject, interval, Subscription, BehaviorSubject, filter as filter$1, fromEvent, map, tap, of, throwError } from 'rxjs';
import * as i1$2 from '@anb/ng-auth';
import { uniq } from 'lodash-es';
import { UAParser } from 'ua-parser-js';
import { AnbEnvironmentEnum } from '@anb/ng-core';
import { bootstrap, capture } from '@govflanders/vl-widget-client';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { filter, map as map$1, retryWhen, concatMap, catchError, finalize } from 'rxjs/operators';
import { v4 } from 'uuid';
import { SubSink } from 'subsink';
import { HttpResponse } from '@angular/common/http';
import { differenceInYears, parse } from 'date-fns';

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type = 'html') {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, name: "safe" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safe' }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class AnbAccordionItemComponent {
    constructor() {
        this.summary = '';
        this.open = false;
        this.toggle = new EventEmitter();
    }
    get isLabelTemplate() {
        return this.title instanceof TemplateRef;
    }
    onToggle() {
        this.open = !this.open;
        this.toggle.emit(this);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbAccordionItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbAccordionItemComponent, selector: "anb-accordion-item", inputs: { id: "id", title: "title", summary: "summary", open: "open", context: "context" }, outputs: { toggle: "toggle" }, ngImport: i0, template: "<li class=\"vl-accordion-list__item\" [class.js-vl-accordion--open]=\"open\">\n  <div data-vl-accordion class=\"vl-accordion\">\n    <div (click)=\"onToggle()\" class=\"anb-accordion__clickable\">\n      <button class=\"vl-toggle vl-link vl-link--bold\">\n        <i class=\"vl-link__icon vl-link__icon--before vl-toggle__icon vl-vi vl-vi-arrow-down-fat\" aria-hidden=\"true\"></i>\n        <ng-container *ngIf=\"isLabelTemplate\">\n          <ng-container [ngTemplateOutlet]=\"title\" [ngTemplateOutletContext]=\"{ item: this }\"> </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"!isLabelTemplate\"><span [innerHtml]=\"title\"></span></ng-container>\n      </button>\n      <div *ngIf=\"summary && !open\" class=\"anb-accordion__summary\">\n        <span [innerHtml]=\"summary | safe: 'html'\"></span>\n      </div>\n    </div>\n    <div class=\"vl-accordion__content js-vl-accordion__content\">\n      <div class=\"vl-accordion__panel\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</li>\n", styles: [".vl-accordion-list__item .vl-toggle{font-size:2.4rem;font-family:\"Flanders Art Serif\",serif;font-weight:500;margin-bottom:1.5rem;line-height:1.2;color:#333332;text-decoration:none;width:100%;display:flex}.vl-accordion-list__item{border-bottom:.1rem solid #d8dde3;margin-bottom:1.5rem}.vl-accordion-list__item .vl-toggle .vl-link__icon--before{padding-right:1.2rem}::ng-deep anb-accordion anb-accordion-item:first-child .vl-accordion-list__item{border-top:.1rem solid #d8dde3;padding-top:1.5rem}::ng-deep .js .js-vl-accordion--open .vl-toggle>.vl-vi:before{transform:rotate(180deg)}::ng-deep .js .js-vl-accordion--open .vl-accordion__content{visibility:visible;max-height:1000vh;overflow:visible;padding:1rem}::ng-deep a:focus,button:focus{outline:none}.anb-accordion__summary{padding-left:3.7rem;margin-top:-1rem;margin-bottom:1.5rem}.anb-accordion__clickable{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbAccordionItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-accordion-item', template: "<li class=\"vl-accordion-list__item\" [class.js-vl-accordion--open]=\"open\">\n  <div data-vl-accordion class=\"vl-accordion\">\n    <div (click)=\"onToggle()\" class=\"anb-accordion__clickable\">\n      <button class=\"vl-toggle vl-link vl-link--bold\">\n        <i class=\"vl-link__icon vl-link__icon--before vl-toggle__icon vl-vi vl-vi-arrow-down-fat\" aria-hidden=\"true\"></i>\n        <ng-container *ngIf=\"isLabelTemplate\">\n          <ng-container [ngTemplateOutlet]=\"title\" [ngTemplateOutletContext]=\"{ item: this }\"> </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"!isLabelTemplate\"><span [innerHtml]=\"title\"></span></ng-container>\n      </button>\n      <div *ngIf=\"summary && !open\" class=\"anb-accordion__summary\">\n        <span [innerHtml]=\"summary | safe: 'html'\"></span>\n      </div>\n    </div>\n    <div class=\"vl-accordion__content js-vl-accordion__content\">\n      <div class=\"vl-accordion__panel\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</li>\n", styles: [".vl-accordion-list__item .vl-toggle{font-size:2.4rem;font-family:\"Flanders Art Serif\",serif;font-weight:500;margin-bottom:1.5rem;line-height:1.2;color:#333332;text-decoration:none;width:100%;display:flex}.vl-accordion-list__item{border-bottom:.1rem solid #d8dde3;margin-bottom:1.5rem}.vl-accordion-list__item .vl-toggle .vl-link__icon--before{padding-right:1.2rem}::ng-deep anb-accordion anb-accordion-item:first-child .vl-accordion-list__item{border-top:.1rem solid #d8dde3;padding-top:1.5rem}::ng-deep .js .js-vl-accordion--open .vl-toggle>.vl-vi:before{transform:rotate(180deg)}::ng-deep .js .js-vl-accordion--open .vl-accordion__content{visibility:visible;max-height:1000vh;overflow:visible;padding:1rem}::ng-deep a:focus,button:focus{outline:none}.anb-accordion__summary{padding-left:3.7rem;margin-top:-1rem;margin-bottom:1.5rem}.anb-accordion__clickable{cursor:pointer}\n"] }]
        }], propDecorators: { id: [{
                type: Input
            }], title: [{
                type: Input
            }], summary: [{
                type: Input
            }], open: [{
                type: Input
            }], context: [{
                type: Input
            }], toggle: [{
                type: Output
            }] } });

class AnbAccordionComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbAccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbAccordionComponent, selector: "anb-accordion", ngImport: i0, template: "<ul class=\"js vl-accordion-list vl-accordion-list--bordered\">\n  <ng-content></ng-content>\n</ul>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-accordion', template: "<ul class=\"js vl-accordion-list vl-accordion-list--bordered\">\n  <ng-content></ng-content>\n</ul>\n" }]
        }] });

class Alert {
}
var AlertType;
(function (AlertType) {
    AlertType[AlertType["Success"] = 0] = "Success";
    AlertType[AlertType["Error"] = 1] = "Error";
    AlertType[AlertType["Info"] = 2] = "Info";
    AlertType[AlertType["Warning"] = 3] = "Warning";
})(AlertType || (AlertType = {}));

class AlertService {
    constructor() {
        this.subject = new Subject();
    }
    getAlert() {
        return this.subject.asObservable();
    }
    success(message, isModal, showIntervalSeconds) {
        this.alert(AlertType.Success, message, 'Succes!', isModal);
    }
    error(message, isModal, showIntervalSeconds) {
        this.alert(AlertType.Error, message, 'Fout!', isModal);
    }
    info(message, isModal, showIntervalSeconds) {
        this.alert(AlertType.Info, message, 'Informatie!', isModal);
    }
    warn(message, isModal, showIntervalSeconds) {
        this.alert(AlertType.Warning, message, 'Waarschuwing!', isModal);
    }
    alert(type, message, title, isModal, showIntervalSeconds, canClose) {
        this.subject.next({ type: type, message: message, title: title, isModal: isModal, canClose: canClose });
        if (!isModal && showIntervalSeconds && showIntervalSeconds > 0) {
            setTimeout(() => {
                this.clear();
            }, showIntervalSeconds * 1000);
        }
    }
    clear() {
        // clear alert
        this.subject.next(null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlertService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlertService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AlertService, decorators: [{
            type: Injectable
        }] });

class AnbAlertComponent {
    constructor(alertService) {
        this.alertService = alertService;
    }
    ngOnInit() {
        this.alertService.getAlert().subscribe((alert) => {
            if (!alert) {
                // clear alert
                this.alert = null;
                return;
            }
            // set alert
            this.alert = alert;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeAlert(alert) {
        this.alert = null;
    }
    cssClass(alert) {
        if (!alert) {
            return;
        }
        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return 'alert--success';
            case AlertType.Error:
                return 'alert--error';
            case AlertType.Info:
                return 'alert--info';
            case AlertType.Warning:
                return 'alert--warning';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbAlertComponent, deps: [{ token: AlertService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbAlertComponent, selector: "anb-alert", ngImport: i0, template: "<div class=\"overlay\" *ngIf=\"this.alert && this.alert.isModal\">\n  <div class=\"modal-dialog\" tabindex=\"-1\" role=\"document\" aria-hidden=\"true\">\n    <div class=\"modal-dialog__content\">\n      <div class=\"webuniversum alert\" [ngClass]=\"cssClass(this.alert)\">\n        <div class=\"alert__icon\" aria-hidden=\"true\"></div>\n        <div class=\"alert__content\">\n          <div class=\"alert__title\">{{ this.alert.title }}</div>\n          <div class=\"alert__message\" [innerHtml]=\"this.alert.message | safe: 'html'\"></div>\n          <!--<div *ngIf=\"this.alert.isStatic\" class=\"webuniversum loader\">\n                        <span class=\"u-visually-hidden\">Even geduld aub</span>\n                    </div>-->\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-dialog__buttons\" *ngIf=\"this.alert.canClose\">\n      <a href=\"javascript:void(0)\" role=\"button\" class=\"modal-dialog__button\" (click)=\"removeAlert(this.alert)\">\n        <i class=\"vi vi-cross vi-u-link\"></i>Sluiten</a\n      >\n    </div>\n  </div>\n</div>\n<div *ngIf=\"this.alert && !this.alert.isModal\">\n  <div class=\"webuniversum alert\" [ngClass]=\"cssClass(this.alert)\">\n    <div class=\"alert__icon\" aria-hidden=\"true\"></div>\n    <div class=\"alert__content\">\n      <div class=\"alert__title\">{{ this.alert.title }}</div>\n      <div class=\"alert__message\" [innerHtml]=\"this.alert.message | safe: 'html'\"></div>\n    </div>\n  </div>\n</div>\n", styles: [".modal-dialog{pointer-events:auto}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-alert', template: "<div class=\"overlay\" *ngIf=\"this.alert && this.alert.isModal\">\n  <div class=\"modal-dialog\" tabindex=\"-1\" role=\"document\" aria-hidden=\"true\">\n    <div class=\"modal-dialog__content\">\n      <div class=\"webuniversum alert\" [ngClass]=\"cssClass(this.alert)\">\n        <div class=\"alert__icon\" aria-hidden=\"true\"></div>\n        <div class=\"alert__content\">\n          <div class=\"alert__title\">{{ this.alert.title }}</div>\n          <div class=\"alert__message\" [innerHtml]=\"this.alert.message | safe: 'html'\"></div>\n          <!--<div *ngIf=\"this.alert.isStatic\" class=\"webuniversum loader\">\n                        <span class=\"u-visually-hidden\">Even geduld aub</span>\n                    </div>-->\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-dialog__buttons\" *ngIf=\"this.alert.canClose\">\n      <a href=\"javascript:void(0)\" role=\"button\" class=\"modal-dialog__button\" (click)=\"removeAlert(this.alert)\">\n        <i class=\"vi vi-cross vi-u-link\"></i>Sluiten</a\n      >\n    </div>\n  </div>\n</div>\n<div *ngIf=\"this.alert && !this.alert.isModal\">\n  <div class=\"webuniversum alert\" [ngClass]=\"cssClass(this.alert)\">\n    <div class=\"alert__icon\" aria-hidden=\"true\"></div>\n    <div class=\"alert__content\">\n      <div class=\"alert__title\">{{ this.alert.title }}</div>\n      <div class=\"alert__message\" [innerHtml]=\"this.alert.message | safe: 'html'\"></div>\n    </div>\n  </div>\n</div>\n", styles: [".modal-dialog{pointer-events:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: AlertService }]; } });

class AnbAppHeaderComponent {
    constructor(anbAuthService) {
        this.anbAuthService = anbAuthService;
        this.logoutLabel = 'Afmelden';
    }
    logout() {
        window.location.href = this.logoutUrl;
        this.anbAuthService.clear();
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbAppHeaderComponent, deps: [{ token: i1$2.AnbAuthenticationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbAppHeaderComponent, selector: "anb-app-header", inputs: { title: "title", logoutUrl: "logoutUrl", logoutLabel: "logoutLabel", primaryMenuTemplate: "primaryMenuTemplate", secondaryMenuTemplate: "secondaryMenuTemplate" }, ngImport: i0, template: "<header class=\"vl-functional-header vl-functional-header--has-actions\" role=\"banner\">\n  <div class=\"vl-layout vl-u-spacer\">\n    <div class=\"vl-functional-header__row\">\n      <div class=\"vl-functional-header__content\">\n        <img\n          height=\"35\"\n          width=\"140\"\n          src=\"assets/images/Entiteitslogo_ANB_zwartwit.png\"\n          alt=\"Agentschap Natuur & Bos\"\n          id=\"logonatuurenbos\"\n        />\n      </div>\n      <div class=\"vl-functional-header__actions\" *ngIf=\"anbAuthService.hasAuthenticatedSession\">\n        <ul>\n          <li class=\"vl-functional-header__action\">\n            <p>{{ anbAuthService.principalName }}</p>\n          </li>\n          <li class=\"vl-functional-header__action\">\n            <p>\n              <a class=\"pointer\" (click)=\"logout()\">{{ logoutLabel }}</a>\n            </p>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <div class=\"sub-header\">\n    <div class=\"vl-layout\">\n      <div class=\"vl-grid vl-grid--v-center\">\n        <div class=\"vl-col--12-12 vl-col--12-12--m vl-col--12-12--s vl-col--1-1--xs\">\n          <div class=\"wrapper\">\n            <div class=\"vl-title align-left\">\n              {{ title }}\n            </div>\n            <div class=\"vl-action-group vl-action-group--bordered vl-action-group--align-right\">\n              <ng-container [ngTemplateOutlet]=\"secondaryMenuTemplate\"> </ng-container>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n\n<div class=\"vl-layout vl-layout--wide vl-u-spacer--small\">\n  <div class=\"vl-grid\">\n    <div class=\"vl-col--12-12 vl-col--12-12--m vl-col--12-12--s vl-col--1-1--xs\">\n      <ng-container [ngTemplateOutlet]=\"primaryMenuTemplate\"> </ng-container>\n    </div>\n  </div>\n</div>\n", styles: [".sub-header{background-color:#30373e}.sub-header .vl-grid{color:#fff;padding:.5rem 0rem}::ng-deep .sub-header .vl-link,::ng-deep .sub-header .vl-link__icon{color:#fff;font-size:1.5rem}.sub-header .vl-title{margin-bottom:0rem}.vl-functional-header{padding-bottom:0rem;margin-bottom:3rem}.wrapper{display:flex}.wrapper .align-left{margin-right:auto}.wrapper :not(.align-left):first-child:before{content:\"\"}.wrapper :not(.align-left):first-child{margin-left:auto}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbAppHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-app-header', template: "<header class=\"vl-functional-header vl-functional-header--has-actions\" role=\"banner\">\n  <div class=\"vl-layout vl-u-spacer\">\n    <div class=\"vl-functional-header__row\">\n      <div class=\"vl-functional-header__content\">\n        <img\n          height=\"35\"\n          width=\"140\"\n          src=\"assets/images/Entiteitslogo_ANB_zwartwit.png\"\n          alt=\"Agentschap Natuur & Bos\"\n          id=\"logonatuurenbos\"\n        />\n      </div>\n      <div class=\"vl-functional-header__actions\" *ngIf=\"anbAuthService.hasAuthenticatedSession\">\n        <ul>\n          <li class=\"vl-functional-header__action\">\n            <p>{{ anbAuthService.principalName }}</p>\n          </li>\n          <li class=\"vl-functional-header__action\">\n            <p>\n              <a class=\"pointer\" (click)=\"logout()\">{{ logoutLabel }}</a>\n            </p>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <div class=\"sub-header\">\n    <div class=\"vl-layout\">\n      <div class=\"vl-grid vl-grid--v-center\">\n        <div class=\"vl-col--12-12 vl-col--12-12--m vl-col--12-12--s vl-col--1-1--xs\">\n          <div class=\"wrapper\">\n            <div class=\"vl-title align-left\">\n              {{ title }}\n            </div>\n            <div class=\"vl-action-group vl-action-group--bordered vl-action-group--align-right\">\n              <ng-container [ngTemplateOutlet]=\"secondaryMenuTemplate\"> </ng-container>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</header>\n\n<div class=\"vl-layout vl-layout--wide vl-u-spacer--small\">\n  <div class=\"vl-grid\">\n    <div class=\"vl-col--12-12 vl-col--12-12--m vl-col--12-12--s vl-col--1-1--xs\">\n      <ng-container [ngTemplateOutlet]=\"primaryMenuTemplate\"> </ng-container>\n    </div>\n  </div>\n</div>\n", styles: [".sub-header{background-color:#30373e}.sub-header .vl-grid{color:#fff;padding:.5rem 0rem}::ng-deep .sub-header .vl-link,::ng-deep .sub-header .vl-link__icon{color:#fff;font-size:1.5rem}.sub-header .vl-title{margin-bottom:0rem}.vl-functional-header{padding-bottom:0rem;margin-bottom:3rem}.wrapper{display:flex}.wrapper .align-left{margin-right:auto}.wrapper :not(.align-left):first-child:before{content:\"\"}.wrapper :not(.align-left):first-child{margin-left:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.AnbAuthenticationService }]; }, propDecorators: { title: [{
                type: Input
            }], logoutUrl: [{
                type: Input
            }], logoutLabel: [{
                type: Input
            }], primaryMenuTemplate: [{
                type: Input
            }], secondaryMenuTemplate: [{
                type: Input
            }] } });

var DeviceSizeEnum;
(function (DeviceSizeEnum) {
    DeviceSizeEnum[DeviceSizeEnum["ExtraSmall"] = 1] = "ExtraSmall";
    DeviceSizeEnum[DeviceSizeEnum["Small"] = 2] = "Small";
    DeviceSizeEnum[DeviceSizeEnum["Medium"] = 3] = "Medium";
    DeviceSizeEnum[DeviceSizeEnum["Large"] = 4] = "Large";
    DeviceSizeEnum[DeviceSizeEnum["ExtraLarge"] = 5] = "ExtraLarge";
})(DeviceSizeEnum || (DeviceSizeEnum = {}));

var BrowserEnum;
(function (BrowserEnum) {
    BrowserEnum["Chrome"] = "Chrome";
    BrowserEnum["Edge"] = "Edge";
    BrowserEnum["Safari"] = "Safari";
    BrowserEnum["MobileSafari"] = "Mobile Safari";
    BrowserEnum["Firefox"] = "Firefox";
})(BrowserEnum || (BrowserEnum = {}));

class UIConfiguration {
}

class AnbBrowserSupportedService {
    constructor(configuration) {
        this.supportedBrowsers = [BrowserEnum.Chrome, BrowserEnum.Edge, BrowserEnum.Firefox, BrowserEnum.Safari, BrowserEnum.MobileSafari];
        this.supportedDeviceSizes = [DeviceSizeEnum.ExtraSmall, DeviceSizeEnum.Small, DeviceSizeEnum.Medium, DeviceSizeEnum.Large, DeviceSizeEnum.ExtraLarge];
        this.canBeUsedWithUnsupportedDeviceSize = true;
        this.deviceDescription = "dit apparaat";
        this.initConfiguration(configuration);
    }
    isDeviceSizeSupported() {
        let isSupported = false;
        const screenWidth = window.innerWidth;
        // Extra small devices (portrait phones, less than 576px)
        if (screenWidth < 576) {
            isSupported = this.shouldDeviceSizeBeSupported(DeviceSizeEnum.ExtraSmall);
            this.deviceDescription = 'smartphones';
        }
        // Small devices (landscape phones, 576px and up)
        else if (screenWidth >= 576 && screenWidth < 768) {
            isSupported = this.shouldDeviceSizeBeSupported(DeviceSizeEnum.Small);
            this.deviceDescription = 'smartphones';
        }
        // Medium devices (tablets, 768px and up)
        else if (screenWidth >= 768 && screenWidth < 992) {
            isSupported = this.shouldDeviceSizeBeSupported(DeviceSizeEnum.Medium);
            this.deviceDescription = 'tablets';
        }
        // Large devices (desktops, 992px and up)
        else if (screenWidth >= 992 && screenWidth < 1200) {
            isSupported = this.shouldDeviceSizeBeSupported(DeviceSizeEnum.Large);
            this.deviceDescription = 'desktops';
        }
        // Extra large devices (large desktops, 1200px and up)
        else if (screenWidth >= 1200) {
            isSupported = this.shouldDeviceSizeBeSupported(DeviceSizeEnum.ExtraLarge);
            this.deviceDescription = 'desktops';
        }
        return isSupported;
    }
    isBrowserSupported() {
        const parser = new UAParser();
        const browserName = parser.getBrowser().name;
        const isSupported = this.supportedBrowsers.find(x => x === browserName) ? true : false;
        return isSupported;
    }
    initConfiguration(configuration) {
        if (configuration) {
            if (configuration.supportedBrowsers) {
                this.supportedBrowsers = configuration.supportedBrowsers;
            }
            if (configuration.supportedDeviceSizes) {
                this.supportedDeviceSizes = configuration.supportedDeviceSizes;
            }
            this.canBeUsedWithUnsupportedDeviceSize = configuration.canBeUsedWithUnsupportedDeviceSize ?? true;
        }
    }
    shouldDeviceSizeBeSupported(deviceSize) {
        const isSupported = this.supportedDeviceSizes.find(x => x === deviceSize) ? true : false;
        return isSupported;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserSupportedService, deps: [{ token: UIConfiguration }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserSupportedService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserSupportedService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: UIConfiguration }]; } });

class AnbBrowserSupportedComponent {
    constructor(browserSupportedService) {
        this.browserSupportedService = browserSupportedService;
        this.supportedBrowsers = this.browserSupportedService.supportedBrowsers;
        this.supportedDevices = this.browserSupportedService.supportedDeviceSizes;
        this.canBeUsedWithUnsupportedDeviceSize = this.browserSupportedService.canBeUsedWithUnsupportedDeviceSize;
        this.deviceDescription = this.browserSupportedService.deviceDescription;
        this.browserSupported = false;
        this.deviceSizeSupported = false;
        this.browserSupported = browserSupportedService.isBrowserSupported();
        this.deviceSizeSupported = browserSupportedService.isDeviceSizeSupported();
        this.deviceDescription = this.browserSupportedService.deviceDescription;
    }
    resizeWindow(event) {
        this.deviceSizeSupported = this.browserSupportedService.isDeviceSizeSupported();
    }
    getSupportedDevicesDescription() {
        const descriptions = [];
        this.supportedDevices?.forEach(d => descriptions.push(this.getDeviceDescription(d)));
        return uniq(descriptions).join(', ');
    }
    getDeviceDescription(deviceSize) {
        switch (deviceSize) {
            case DeviceSizeEnum.Small:
            case DeviceSizeEnum.ExtraSmall:
                return 'smartphone';
            case DeviceSizeEnum.Medium:
                return 'tablet';
            case DeviceSizeEnum.Large:
            case DeviceSizeEnum.ExtraLarge:
                return 'desktop/laptop';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserSupportedComponent, deps: [{ token: AnbBrowserSupportedService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbBrowserSupportedComponent, selector: "anb-browser-supported", host: { listeners: { "window:resize": "resizeWindow($event)" } }, ngImport: i0, template: "<ng-container *ngIf=\"browserSupported && !deviceSizeSupported && canBeUsedWithUnsupportedDeviceSize\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <div class=\"vl-alert vl-alert--warning\" role=\"alert\">\n      <div class=\"vl-alert__icon\">\n        <i class=\"vl-vi vl-vi-warning\" aria-hidden=\"true\" style=\"color: white; top: 0px\"></i>\n      </div>\n      <div class=\"vl-alert__content\">\n        <p class=\"vl-alert__title\">Waarschuwing</p>\n        <div class=\"vl-alert__message\">\n          <p>\n            Deze website wordt momenteel nog geoptimaliseerd voor gebruik op {{ deviceDescription }}. Dit betekent dat sommige\n            functionaliteiten binnen de website mogelijk nog niet goed werken.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"!deviceSizeSupported && !canBeUsedWithUnsupportedDeviceSize\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <div class=\"vl-alert vl-alert--warning\" role=\"alert\">\n      <div class=\"vl-alert__icon\">\n        <i class=\"vl-vi vl-vi-warning\" aria-hidden=\"true\" style=\"color: white; top: 0px\"></i>\n      </div>\n      <div class=\"vl-alert__content\">\n        <p class=\"vl-alert__title\">Uw apparaat wordt niet ondersteund</p>\n        <div class=\"vl-alert__message\">\n          <p>\n            U gebruikt een apparaat dat niet ondersteund is. Gebruik een van de volgende apparaten:\n            {{ getSupportedDevicesDescription() }}.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"!browserSupported && (deviceSizeSupported || canBeUsedWithUnsupportedDeviceSize)\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <div class=\"vl-alert vl-alert--warning\" role=\"alert\">\n      <div class=\"vl-alert__icon\">\n        <i class=\"vl-vi vl-vi-warning\" aria-hidden=\"true\" style=\"color: white; top: 0px\"></i>\n      </div>\n      <div class=\"vl-alert__content\">\n        <p class=\"vl-alert__title\">Uw browser wordt niet ondersteund</p>\n        <div class=\"vl-alert__message\">\n          <p>\n            U gebruikt een browser die niet ondersteund is. Gebruik een van de volgende browsers:\n            <ng-container *ngFor=\"let brower of supportedBrowsers; let last = last\"\n              >{{ brower }}<ng-container *ngIf=\"!last\">, </ng-container> </ng-container\n            >.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container\n  *ngIf=\"(browserSupported && deviceSizeSupported) || (browserSupported && !deviceSizeSupported && canBeUsedWithUnsupportedDeviceSize)\"\n>\n  <ng-content></ng-content>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserSupportedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-browser-supported', template: "<ng-container *ngIf=\"browserSupported && !deviceSizeSupported && canBeUsedWithUnsupportedDeviceSize\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <div class=\"vl-alert vl-alert--warning\" role=\"alert\">\n      <div class=\"vl-alert__icon\">\n        <i class=\"vl-vi vl-vi-warning\" aria-hidden=\"true\" style=\"color: white; top: 0px\"></i>\n      </div>\n      <div class=\"vl-alert__content\">\n        <p class=\"vl-alert__title\">Waarschuwing</p>\n        <div class=\"vl-alert__message\">\n          <p>\n            Deze website wordt momenteel nog geoptimaliseerd voor gebruik op {{ deviceDescription }}. Dit betekent dat sommige\n            functionaliteiten binnen de website mogelijk nog niet goed werken.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"!deviceSizeSupported && !canBeUsedWithUnsupportedDeviceSize\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <div class=\"vl-alert vl-alert--warning\" role=\"alert\">\n      <div class=\"vl-alert__icon\">\n        <i class=\"vl-vi vl-vi-warning\" aria-hidden=\"true\" style=\"color: white; top: 0px\"></i>\n      </div>\n      <div class=\"vl-alert__content\">\n        <p class=\"vl-alert__title\">Uw apparaat wordt niet ondersteund</p>\n        <div class=\"vl-alert__message\">\n          <p>\n            U gebruikt een apparaat dat niet ondersteund is. Gebruik een van de volgende apparaten:\n            {{ getSupportedDevicesDescription() }}.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"!browserSupported && (deviceSizeSupported || canBeUsedWithUnsupportedDeviceSize)\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <div class=\"vl-alert vl-alert--warning\" role=\"alert\">\n      <div class=\"vl-alert__icon\">\n        <i class=\"vl-vi vl-vi-warning\" aria-hidden=\"true\" style=\"color: white; top: 0px\"></i>\n      </div>\n      <div class=\"vl-alert__content\">\n        <p class=\"vl-alert__title\">Uw browser wordt niet ondersteund</p>\n        <div class=\"vl-alert__message\">\n          <p>\n            U gebruikt een browser die niet ondersteund is. Gebruik een van de volgende browsers:\n            <ng-container *ngFor=\"let brower of supportedBrowsers; let last = last\"\n              >{{ brower }}<ng-container *ngIf=\"!last\">, </ng-container> </ng-container\n            >.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container\n  *ngIf=\"(browserSupported && deviceSizeSupported) || (browserSupported && !deviceSizeSupported && canBeUsedWithUnsupportedDeviceSize)\"\n>\n  <ng-content></ng-content>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: AnbBrowserSupportedService }]; }, propDecorators: { resizeWindow: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class AnbBurgerprofielFooterComponent {
    constructor() {
        this.anbEnvironment = null;
        this.version = 1;
    }
    ngOnInit() {
        if (!this.anbEnvironment) {
            console.error('anb-burgerprofiel-footer: Input parameter anbEnvironment not defined');
        }
    }
    ngAfterViewInit() {
        this.initFooter();
    }
    getFooterIdV1() {
        let id = '306653cf-23d7-472f-9990-bc27ecc546bd';
        if (this.anbEnvironment === AnbEnvironmentEnum.prd) {
            id = '39d29696-8f1d-432a-951f-5f3805c57d2e';
        }
        else if (this.anbEnvironment === AnbEnvironmentEnum.acc) {
            id = 'c2e2a816-5924-4772-8780-5dca40799d57';
        }
        return id;
    }
    getFooterIdV2() {
        //same for dev/tst/acc
        let id = '1ca9f9c0-9b7e-4932-99ad-bb8207003c04';
        // for the moment we assume id in prd will be the same.
        if (this.anbEnvironment === AnbEnvironmentEnum.prd) {
            id = '87136f5c-30b5-4a34-89c8-a28f184daf0f';
        }
        return id;
    }
    get footerId() {
        const version = this.version ?? 1;
        if (version === 2)
            return this.getFooterIdV2();
        return this.getFooterIdV1();
    }
    get footerUrl() {
        return this.anbEnvironment === AnbEnvironmentEnum.prd
            ? 'https://prod.widgets.burgerprofiel.vlaanderen.be/api/v1/widget'
            : 'https://tni.widgets.burgerprofiel.dev-vlaanderen.be/api/v1/widget';
    }
    initFooter() {
        const footer_url = `${this.footerUrl}/${this.footerId}`;
        bootstrap(footer_url).then((widget) => {
            widget.setMountElement(this.vlFooter.nativeElement).mount();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBurgerprofielFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbBurgerprofielFooterComponent, selector: "anb-burgerprofiel-footer", inputs: { anbEnvironment: "anbEnvironment", version: "version" }, viewQueries: [{ propertyName: "vlFooter", first: true, predicate: ["vlfooter"], descendants: true }], ngImport: i0, template: "<div #vlfooter></div>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBurgerprofielFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-burgerprofiel-footer', template: "<div #vlfooter></div>\n" }]
        }], propDecorators: { anbEnvironment: [{
                type: Input
            }], version: [{
                type: Input
            }], vlFooter: [{
                type: ViewChild,
                args: ['vlfooter']
            }] } });

class TimerService {
    constructor() {
        this.timer = interval(1000);
        this.remainSecondsSrc = new Subject();
        /**
         * Observable to get remaining time (in seconds).
         *
         * Subscribers need to unsubscribe to it before hosting element is destroyed.
         *
         * @memberof SessionTimerService
         */
        this.remainSeconds$ = this.remainSecondsSrc.asObservable();
    }
    startTimer(totalMinutes) {
        this.stopTimer();
        this.count = totalMinutes * 60;
        this.timerSubscription = this.timer.subscribe(() => {
            if (this.count > 0) {
                this.count--;
                this.remainSeconds = this.count;
                this.remainSecondsSrc.next(this.count);
            }
            else {
                this.stopTimer();
            }
        });
    }
    stopTimer() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }
    resetTimer(totalMinutes) {
        this.count = totalMinutes * 60;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TimerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TimerService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TimerService, decorators: [{
            type: Injectable
        }] });

/* eslint-disable @typescript-eslint/no-explicit-any */
class AnbBurgerprofielHeaderComponent {
    constructor(inactivityTimerService) {
        this.inactivityTimerService = inactivityTimerService;
        this.anbEnvironment = null;
        this.hasAuthenticatedSession = false;
        this.inactivityTotalMinutes = 30;
        this.version = 1;
        // The version of the header for ANB (this is not the version of the flanders widget).  Default is 1 to avoid breaking changes
        // 1 is for natuuernbos.be domain.
        // 2 is for natuurenbos-{environment}.vlaanderen.be domain
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onLogout = new EventEmitter();
        this.remainSecondsSubscription = Subscription.EMPTY;
    }
    ngOnInit() {
        if (!this.anbEnvironment) {
            console.error('anb-burgerprofiel-header: Input parameter anbEnvironment not defined');
        }
        // Wanneer er na x aantal minuten geen activiteit is, loggen we de gebruiker uit.
        this.remainSecondsSubscription = this.inactivityTimerService.remainSeconds$.subscribe((remainSeconds) => {
            if (remainSeconds === 0) {
                this.logout();
            }
        });
    }
    ngOnDestroy() {
        if (this.remainSecondsSubscription) {
            this.remainSecondsSubscription.unsubscribe();
        }
        this.inactivityTimerService.stopTimer();
    }
    ngAfterViewInit() {
        this.initHeader();
    }
    ngOnChanges(changes) {
        if (changes.hasAuthenticatedSession) {
            this.loginComplete(changes.hasAuthenticatedSession.currentValue);
        }
    }
    getHeaderIdV1() {
        let id = '69713e66-89d5-4e5e-b48a-ba351a454e0e';
        if (this.anbEnvironment === AnbEnvironmentEnum.prd) {
            id = '5c4358f6-196f-4638-b520-369726d99ce3';
        }
        else if (this.anbEnvironment === AnbEnvironmentEnum.acc) {
            id = '27d60e5b-0f07-4137-8545-6e5022b640f8';
        }
        return id;
    }
    getHeaderIdV2() {
        // same for dev/tst/acc
        let id = '4ce80902-17c5-4889-94cb-f1e09c9bd43c';
        // for the moment we assume id in prd will be the same.
        if (this.anbEnvironment === AnbEnvironmentEnum.prd) {
            id = 'a3d3157c-abdd-4230-9f50-1efba3649ec0';
        }
        return id;
    }
    get headerId() {
        const version = this.version ?? 1;
        if (version === 2)
            return this.getHeaderIdV2();
        return this.getHeaderIdV1();
    }
    get headerUrl() {
        return this.anbEnvironment === AnbEnvironmentEnum.prd
            ? 'https://prod.widgets.burgerprofiel.vlaanderen.be/api/v1/widget'
            : 'https://tni.widgets.burgerprofiel.dev-vlaanderen.be/api/v1/widget';
    }
    initHeader() {
        const header_url = `${this.headerUrl}/${this.headerId}`;
        if (this.anbEnvironment != AnbEnvironmentEnum.loc) {
            bootstrap(header_url).then((widget) => {
                widget.setMountElement(this.vlHeader.nativeElement).mount();
            });
        }
        capture((widget) => {
            // Only process global header widgets.
            if (widget.getPluginTypeId() === 'global_header') {
                if (this.defaultContactOptions) {
                    widget.getExtension('contact').then((contact) => {
                        contact.setServicePoints({
                            defaults: this.defaultContactOptions,
                        });
                    });
                }
                const createSessionExtendThrottle = () => {
                    // Initialize variable to false as this indicates whether throttling is active.
                    let isThrottled = false;
                    // Build the throttled function.
                    return function () {
                        // Check whether throttling is not active.
                        if (!isThrottled) {
                            // Set the throttling flag.
                            isThrottled = true;
                            // Schedule timeout after our throttle period (5 seconds).
                            setTimeout(function () {
                                isThrottled = false;
                            }, 5000);
                        }
                    };
                };
                widget.getExtension('citizen_profile.session').then((session) => {
                    // Get informed about session extend request by the Citizen Profile Session extension.
                    // todo Rename this session.on('extend') once migration is performed.
                    widget.on('citizen_profile.session.extend', createSessionExtendThrottle());
                    /**
                     * Event handler which extends the session.
                     */
                    const extendEventHandler = () => {
                        // Extend the session if present as the user is still interactive.
                        session.extend();
                        // Wanneer er activiteit is resetten we de inactivity timer
                        this.inactivityTimerService.resetTimer(this.inactivityTotalMinutes);
                    };
                    // List of event names which are used to detect activity.
                    const eventNames = [
                        'mousedown',
                        'mousemove',
                        'mousewheel',
                        'DOMMouseScroll',
                        'scroll',
                        'wheel',
                        'keydown',
                        'keypress',
                        'touchmove',
                        'touchstart',
                    ];
                    // Iterate through the events names.
                    for (let i = 0; i < eventNames.length; i++) {
                        // Register our event handler given event name.
                        window.addEventListener(eventNames[i], extendEventHandler);
                    }
                    // This variable is purely to indicate which values are allowed (true / false).
                    let hasAuthenticatedSession = false;
                    if (this.hasAuthenticatedSession) {
                        hasAuthenticatedSession = true;
                    }
                    else if (session.activityManager.started) {
                        hasAuthenticatedSession = true;
                    }
                    if (hasAuthenticatedSession) {
                        // Start eigen inactivity timer
                        this.inactivityTimerService.startTimer(this.inactivityTotalMinutes);
                    }
                    // Inform the session extension about the current session state of the website. Keep in mind
                    // this operation can only be performed once on every page load.
                    session.configure({
                        active: hasAuthenticatedSession,
                        endpoints: {
                            loginUrl: this.loginUrl,
                            loginRedirectUrl: this.loginRedirectUrl,
                            logoutUrl: this.logoutUrl,
                        },
                    });
                });
                widget.on('citizen_profile.session.logout.request', (logoutRequest) => {
                    logoutRequest.acknowledge();
                    const reason = logoutRequest.getRequest().getReason();
                    switch (reason) {
                        case 'user': {
                            this.logout();
                            break;
                        }
                        default: {
                            logoutRequest.reject();
                        }
                    }
                });
            }
        });
    }
    loginComplete(hasAuthenticatedSession) {
        // Serialize the login complete message.
        if (hasAuthenticatedSession) {
            const message = JSON.stringify({
                type: 'vl.widget.global_header.citizen_profile.session.login.complete',
            });
            // Notify the top most window about our login progress.
            window.top.postMessage(message, '*');
        }
    }
    logout() {
        if (this.onLogout) {
            this.onLogout.emit();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBurgerprofielHeaderComponent, deps: [{ token: TimerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbBurgerprofielHeaderComponent, selector: "anb-burgerprofiel-header", inputs: { anbEnvironment: "anbEnvironment", hasAuthenticatedSession: "hasAuthenticatedSession", loginUrl: "loginUrl", loginRedirectUrl: "loginRedirectUrl", logoutUrl: "logoutUrl", inactivityTotalMinutes: "inactivityTotalMinutes", version: "version", defaultContactOptions: "defaultContactOptions" }, outputs: { onLogout: "onLogout" }, providers: [TimerService], viewQueries: [{ propertyName: "vlHeader", first: true, predicate: ["vlheader"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #vlheader></div>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBurgerprofielHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-burgerprofiel-header', providers: [TimerService], template: "<div #vlheader></div>\n" }]
        }], ctorParameters: function () { return [{ type: TimerService }]; }, propDecorators: { anbEnvironment: [{
                type: Input
            }], hasAuthenticatedSession: [{
                type: Input
            }], loginUrl: [{
                type: Input
            }], loginRedirectUrl: [{
                type: Input
            }], logoutUrl: [{
                type: Input
            }], inactivityTotalMinutes: [{
                type: Input
            }], version: [{
                type: Input
            }], defaultContactOptions: [{
                type: Input
            }], onLogout: [{
                type: Output
            }], vlHeader: [{
                type: ViewChild,
                args: ['vlheader']
            }] } });

class ColumnGroupHeader {
}

class ColumnSetting {
    constructor() {
        // for editing row
        this.editable = false;
    }
}
var ColumnEditType;
(function (ColumnEditType) {
    ColumnEditType[ColumnEditType["Textbox"] = 0] = "Textbox";
    ColumnEditType[ColumnEditType["Dropdown"] = 1] = "Dropdown";
    ColumnEditType[ColumnEditType["Checkbox"] = 2] = "Checkbox";
    ColumnEditType[ColumnEditType["Textarea"] = 3] = "Textarea";
})(ColumnEditType || (ColumnEditType = {}));

class AnbPaginationComponent {
    constructor() {
        this.page = 1;
        this.count = 10;
        this.resultStart = 1;
        this.resultEnd = 10;
        this.totaal = 10;
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
        this.onPaginate = new EventEmitter();
    }
    resetCounters() {
        this.page = 0;
        this.count = 0;
        this.resultStart = 0;
        this.resultEnd = 0;
        this.totaal = 0;
    }
    previousClick() {
        let page = this.page;
        if (page <= 1) {
            return;
        }
        else {
            page--;
        }
        this.onPaginate.emit({
            page: page,
            count: this.count,
        });
    }
    nextClick() {
        let page = this.page;
        page++;
        this.onPaginate.emit({
            page: page,
            count: this.count,
        });
    }
    firstClick() {
        this.onPaginate.emit({
            page: 1,
            count: this.count,
        });
    }
    lastClick() {
        const page = Math.ceil(this.totaal / this.count);
        this.onPaginate.emit({
            page: page,
            count: this.count,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbPaginationComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbPaginationComponent, selector: "anb-pagination", inputs: { page: "page", count: "count", resultStart: "resultStart", resultEnd: "resultEnd", totaal: "totaal" }, outputs: { onPaginate: "onPaginate" }, ngImport: i0, template: "<!-- component -->\n<div class=\"pager u-spacer--large\">\n  <ul class=\"pager__list\">\n    <li class=\"pager__element\" *ngIf=\"page > 1\">\n      <a href=\"javascript:void(0)\" (click)=\"firstClick()\"\n        ><i class=\"vi vi-double-arrow vi-u-180deg vi-u-s\" aria-hidden=\"true\"></i> eerste</a\n      >\n    </li>\n    <li class=\"pager__element\" *ngIf=\"page > 1\">\n      <a href=\"javascript:void(0)\" (click)=\"previousClick()\"\n        ><i class=\"vi vi-arrow vi-u-180deg vi-u-s\" aria-hidden=\"true\"></i> vorige<span class=\"u-visually-hidden\"> 10 rijen</span></a\n      >\n    </li>\n    <li class=\"pager__element\">\n      <span class=\"u-visually-hidden\">Rij </span><strong>{{ resultStart }} - {{ resultEnd }}</strong> van {{ totaal }}\n    </li>\n    <li class=\"pager__element\" *ngIf=\"page * count < totaal\">\n      <a href=\"javascript:void(0)\" (click)=\"nextClick()\"\n        >volgende <span class=\"u-visually-hidden\"> 10 rijen</span><i class=\"vi vi-arrow vi-u-s\" aria-hidden=\"true\"></i\n      ></a>\n    </li>\n    <li class=\"pager__element\" *ngIf=\"page * count < totaal\">\n      <a href=\"javascript:void(0)\" (click)=\"lastClick()\">laatste <i class=\"vi vi-double-arrow vi-u-s\" aria-hidden=\"true\"></i> </a>\n    </li>\n  </ul>\n</div>\n<!-- end component -->\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-pagination', template: "<!-- component -->\n<div class=\"pager u-spacer--large\">\n  <ul class=\"pager__list\">\n    <li class=\"pager__element\" *ngIf=\"page > 1\">\n      <a href=\"javascript:void(0)\" (click)=\"firstClick()\"\n        ><i class=\"vi vi-double-arrow vi-u-180deg vi-u-s\" aria-hidden=\"true\"></i> eerste</a\n      >\n    </li>\n    <li class=\"pager__element\" *ngIf=\"page > 1\">\n      <a href=\"javascript:void(0)\" (click)=\"previousClick()\"\n        ><i class=\"vi vi-arrow vi-u-180deg vi-u-s\" aria-hidden=\"true\"></i> vorige<span class=\"u-visually-hidden\"> 10 rijen</span></a\n      >\n    </li>\n    <li class=\"pager__element\">\n      <span class=\"u-visually-hidden\">Rij </span><strong>{{ resultStart }} - {{ resultEnd }}</strong> van {{ totaal }}\n    </li>\n    <li class=\"pager__element\" *ngIf=\"page * count < totaal\">\n      <a href=\"javascript:void(0)\" (click)=\"nextClick()\"\n        >volgende <span class=\"u-visually-hidden\"> 10 rijen</span><i class=\"vi vi-arrow vi-u-s\" aria-hidden=\"true\"></i\n      ></a>\n    </li>\n    <li class=\"pager__element\" *ngIf=\"page * count < totaal\">\n      <a href=\"javascript:void(0)\" (click)=\"lastClick()\">laatste <i class=\"vi vi-double-arrow vi-u-s\" aria-hidden=\"true\"></i> </a>\n    </li>\n  </ul>\n</div>\n<!-- end component -->\n" }]
        }], propDecorators: { page: [{
                type: Input
            }], count: [{
                type: Input
            }], resultStart: [{
                type: Input
            }], resultEnd: [{
                type: Input
            }], totaal: [{
                type: Input
            }], onPaginate: [{
                type: Output
            }] } });

class FormatCellPipe {
    constructor() {
        this.datePipe = new DatePipe('en-US');
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value, format) {
        if (value === undefined) {
            return 'not available';
        }
        if (format === 'date') {
            return this.datePipe.transform(value, 'dd/MM/yyyy');
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormatCellPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FormatCellPipe, name: "formatCell" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormatCellPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'formatCell' }]
        }], ctorParameters: function () { return []; } });

/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
* @deprecated Deze component niet meer gebruiken, maar gebruik maken van de Angular Material Table
*/
class AnbDataTableComponent {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.page = 1;
        this.pageSize = 10;
        this.resetPagination = true;
        this.noResultFoundText = 'Er zijn geen resultaten gevonden';
        this.selectionChanged = new EventEmitter();
        this.onPaginate = new EventEmitter();
        this.onRowSave = new EventEmitter();
        this.onMouseOverRow = new EventEmitter();
        this.onMouseLeaveRow = new EventEmitter();
        this.onCollapseDetail = new EventEmitter();
        this.onExpandDetail = new EventEmitter();
        this.selectAllChecked = false;
        this.selectedRecords = [];
        this.editMode = false;
        this.textbox = ColumnEditType.Textbox;
        this.dropdown = ColumnEditType.Dropdown;
        this.checkbox = ColumnEditType.Checkbox;
        this.textarea = ColumnEditType.Textarea;
        this.toggle = {};
    }
    ngAfterViewInit() {
        // Disable automatic change detection
        this.changeDetectorRef.detach();
    }
    ngOnChanges(changes) {
        if (changes.pageSize !== undefined) {
            this.pageSize = changes.pageSize.currentValue;
        }
        if (this.settings) {
            // when settings provided
            this.columnMaps = this.settings;
        }
        else {
            // no settings, create column maps with defaults
            this.columnMaps = Object.keys(this.records[0]).map((key) => {
                return {
                    primaryKey: key,
                    header: key.slice(0, 1).toUpperCase() + key.replace(/_/g, ' ').slice(1),
                    format: 'default',
                };
            });
        }
        // Reset all when records are changing
        if (changes.records !== undefined) {
            this.reset();
        }
        this.groupRecords();
        this.pageRecords();
        this.detectChanges();
    }
    onSelectionChange(event, record) {
        if (event.target.checked) {
            this.selectedRecords.push(record);
        }
        else {
            const index = this.selectedRecords.indexOf(record);
            if (index > -1) {
                this.selectedRecords.splice(index, 1);
            }
        }
        this.selectionChanged.emit();
        this.detectChanges();
    }
    onSelectAllChange(event, primaryKey) {
        if (event.target.checked) {
            for (const i in this.pagedRecords) {
                const index = this.selectedRecords.indexOf(this.pagedRecords[i]);
                if (index === -1) {
                    this.selectedRecords.push(this.pagedRecords[i]);
                }
            }
        }
        else {
            for (const i in this.pagedRecords) {
                const index = this.selectedRecords.indexOf(this.pagedRecords[i]);
                if (index > -1) {
                    this.selectedRecords.splice(index, 1);
                }
            }
        }
        for (const i in this.pagedRecords) {
            this.pagedRecords[i][primaryKey] = event.target.checked;
        }
        this.selectionChanged.emit();
        this.detectChanges();
    }
    onButtonClick(event, record, eventEmitter) {
        eventEmitter.emit(record);
    }
    onMouseOver(event, record) {
        if (this.onMouseOverRow) {
            this.onMouseOverRow.emit(record);
        }
    }
    onMouseLeave(event, record) {
        if (this.onMouseLeaveRow) {
            this.onMouseLeaveRow.emit(record);
        }
    }
    onToggleDetail(event, record, toggle) {
        if (!toggle === true) {
            if (this.onExpandDetail) {
                this.onExpandDetail.emit(record);
            }
        }
        else {
            if (this.onCollapseDetail) {
                this.onCollapseDetail.emit(record);
            }
        }
        this.detectChanges();
        // to stop bubble event for editing the row instead of expanding.
        event.preventDefault();
        event.stopPropagation();
    }
    onPaginationClick(event) {
        this.selectAllChecked = false;
        this.page = event.page;
        this.pageRecords();
        this.detectChanges();
        this.onPaginate.next(event);
    }
    onRowClick(event, record) {
        // if there is no record in edit, always ok to put row in edit mode
        if (!this.currentRecord) {
            record.editMode = true;
            this.currentRecord = record;
        }
        // get row which is in edit mode and save
        if (!record.editMode) {
            // get current record which is in edit mode
            if (this.currentRecord && this.currentRecord.editMode) {
                this.onRowSave.subscribe((savedRecord) => {
                    if (savedRecord.isValid) {
                        this.currentRecord.editMode = false;
                        // set current record and set it to editMode
                        record.editMode = true;
                        this.currentRecord = record;
                    }
                    else {
                        // show validation errors and stay in edit mode for row
                    }
                });
                this.onRowSave.emit(this.currentRecord);
            }
            else {
                // no record in edit mode, but record selected
                record.editMode = true;
                this.currentRecord = record;
            }
        } // else if current row is in editmode, do nothing
        this.detectChanges();
    }
    onChangeDropdown(event, record, map) {
        const selectElementText = event.target['options'][event.target['options'].selectedIndex].text;
        record[map.primaryKey] = selectElementText;
        this.detectChanges();
    }
    getHeaderGroup() {
        const vResult = new Array();
        if (this.columnMaps !== undefined) {
            const groups = this.columnMaps.map((x) => x.headergroup);
            if (groups.filter((x) => x === undefined).length !== this.columnMaps.length) {
                let vPreviousGroup;
                let vIndex = 0;
                let vColSpan = 0;
                groups.forEach((group) => {
                    if (vPreviousGroup === group && vIndex !== 0) {
                        vColSpan++;
                    }
                    else {
                        const vColumnHeader = new ColumnGroupHeader();
                        vColumnHeader.header = group;
                        vColumnHeader.classes = this.columnMaps[vIndex].classes;
                        if (vResult.length > 0) {
                            vResult[vResult.length - 1].colspan = (vColSpan + 1).toString();
                        }
                        vResult.push(vColumnHeader);
                        vColSpan = 0;
                    }
                    vIndex++;
                    vPreviousGroup = group;
                });
                vResult[vResult.length - 1].colspan = (vColSpan + 1).toString();
            }
        }
        return vResult;
    }
    groupRecords() {
        if (this.groupColumns && this.records && this.records.length > 0) {
            const vComparison = [];
            this.groupColumns.forEach((element) => {
                vComparison.push(element);
            });
            const vGroup = this.groupByMulti(this.records, this.groupColumns);
            this.records = this.flatten(vGroup);
            // this.records.sort(this.propertyComparator(vComparison));
            for (let j = 0; j < this.records.length; j++) {
                if (j === 0) {
                    // first record is always group parent
                    this.records[j].groupParent = true;
                    this.records[j].groupChild = false;
                }
                else {
                    let isEqual = true;
                    for (let l = 0; l < this.groupColumns.length; l++) {
                        if (this.records[j][this.groupColumns[l]] !== this.records[j - 1][this.groupColumns[l]]) {
                            isEqual = false;
                            break;
                        }
                    }
                    if (isEqual) {
                        this.records[j].groupChild = true;
                        this.records[j].groupParent = false;
                        // check if records need to be sorted and if, swap
                        if (this.sortSettings && this.sortSettings.length > 0) {
                            // sorting order is based on array order
                            this.sortSettings.forEach((element) => {
                                const vIndexLastRecord = element.sortCriteria.indexOf(this.records[j][element.column]);
                                const vIndexFirstRecord = element.sortCriteria.indexOf(this.records[j - 1][element.column]);
                                if (vIndexLastRecord < vIndexFirstRecord) {
                                    if (this.records[j - 1].groupParent) {
                                        this.records[j - 1].groupParent = false;
                                        this.records[j - 1].groupChild = true;
                                        this.records[j].groupParent = true;
                                        this.records[j].groupChild = false;
                                    }
                                    // swap
                                    const b = this.records[j];
                                    this.records[j] = this.records[j - 1];
                                    this.records[j - 1] = b;
                                }
                            });
                        }
                    }
                    else {
                        this.records[j].groupParent = true;
                        this.records[j].groupChild = false;
                    }
                }
            }
        }
    }
    flatten(arr, result = []) {
        for (let i = 0, length = arr.length; i < length; i++) {
            const value = arr[i];
            if (Array.isArray(value)) {
                this.flatten(value, result);
            }
            else {
                result.push(value);
            }
        }
        return result;
    }
    groupByMulti(collection, properties) {
        if (!properties.length) {
            return collection;
        }
        const byFirst = this.groupBy(collection, properties[0]), rest = properties.slice(1);
        for (const prop in byFirst) {
            byFirst[prop] = this.groupByMulti(byFirst[prop], rest);
        }
        return byFirst;
    }
    groupBy(collection, property) {
        // prevents the application from breaking if the array of objects doesn't exist yet
        if (!collection) {
            return null;
        }
        const groupedCollection = collection.reduce((previous, current) => {
            if (!previous[current[property]]) {
                previous[current[property]] = [current];
            }
            else {
                previous[current[property]].push(current);
            }
            return previous;
        }, {});
        // this will return an array of objects, each object containing a group of objects
        return Object.keys(groupedCollection).map(function (index) {
            return groupedCollection[index];
        });
    }
    pageRecords() {
        if (this.paging) {
            if (this.paginationComponent !== undefined && this.records !== undefined) {
                this.paginationComponent.resultStart = this.page * this.pageSize - (this.pageSize - 1);
                this.paginationComponent.resultEnd =
                    this.page * this.pageSize > this.records.length ? this.records.length : this.page * this.pageSize;
                this.paginationComponent.totaal = this.records.length;
                this.pagedRecords = this.records.slice(this.page * this.pageSize - this.pageSize, this.page * this.pageSize);
                const totalPages = Math.ceil(this.paginationComponent.totaal / this.pageSize);
                if (this.page > totalPages)
                    this.page = totalPages;
            }
        }
        else {
            this.pagedRecords = this.records;
        }
    }
    reset() {
        if (this.resetPagination)
            this.page = 1;
        this.selectedRecords = [];
        this.toggle = [];
    }
    showValueGrouped(record, column, rowIndex) {
        if (record.groupChild && this.groupColumns.indexOf(column) > -1 && rowIndex > 0) {
            // hide value if child and column belongs to groupedcolumns
            // show value if first row
            return false;
        }
        return true;
    }
    setClassParent(record, rowIndex) {
        if (record.groupParent && rowIndex > 0) {
            // don't border first row
            return 'divider';
        }
    }
    detectChanges() {
        this.changeDetectorRef.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbDataTableComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbDataTableComponent, selector: "anb-data-table", inputs: { records: "records", settings: "settings", paging: "paging", page: "page", pageSize: "pageSize", resetPagination: "resetPagination", noResultFoundText: "noResultFoundText", detailTemplate: "detailTemplate", groupColumns: "groupColumns", sortSettings: "sortSettings" }, outputs: { selectionChanged: "selectionChanged", onPaginate: "onPaginate", onRowSave: "onRowSave", onMouseOverRow: "onMouseOverRow", onMouseLeaveRow: "onMouseLeaveRow", onCollapseDetail: "onCollapseDetail", onExpandDetail: "onExpandDetail" }, viewQueries: [{ propertyName: "paginationComponent", first: true, predicate: ["pagination"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div>\n  <div *ngIf=\"!pagedRecords || pagedRecords.length === 0\" class=\"u-spacer\">\n    <div class=\"alert\">\n      <div aria-hidden=\"true\"></div>\n      <div class=\"alert__content\">\n        <div class=\"alert__title\">{{ noResultFoundText }}</div>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"pagedRecords && pagedRecords.length > 0\" class=\"u-spacer\">\n    <div data-table>\n      <div class=\"u-table-overflow\">\n        <table class=\"data-table\">\n          <thead>\n            <tr class=\"headergroup\">\n              <th class=\"toggle\" *ngIf=\"detailTemplate\"></th>\n              <th\n                *ngFor=\"let headerGroup of getHeaderGroup()\"\n                [attr.colspan]=\"headerGroup.colspan\"\n                [ngClass]=\"headerGroup.classes ? headerGroup.classes(undefined) : undefined\"\n              >\n                {{ headerGroup.header }}\n              </th>\n            </tr>\n            <tr class=\"data-table__header\">\n              <th *ngIf=\"detailTemplate\"></th>\n              <th\n                class=\"data-table__header-title\"\n                *ngFor=\"let map of columnMaps\"\n                [ngSwitch]=\"map.format\"\n                [ngClass]=\"map.classes ? map.classes(undefined) : undefined\"\n              >\n                <div *ngSwitchCase=\"'checkbox'\">\n                  <label class=\"checkbox checkbox--empty\">\n                    <input\n                      type=\"checkbox\"\n                      name=\"checkbox\"\n                      class=\"checkbox__toggle\"\n                      [checked]=\"selectAllChecked\"\n                      [value]=\"selectAllChecked\"\n                      (change)=\"selectAllChecked = !selectAllChecked; onSelectAllChange($event, map.primaryKey)\"\n                    />\n                    <span></span>\n                    <span class=\"u-visually-hidden\">Selecteer rij</span>\n                  </label>\n                </div>\n                <div *ngSwitchDefault>\n                  {{ map.header }}\n                </div>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <ng-template ngFor let-record [ngForOf]=\"pagedRecords\" let-i=\"index\">\n              <tr\n                data-table-selectable\n                (click)=\"onRowClick($event, record)\"\n                (mouseover)=\"onMouseOver($event, record)\"\n                (mouseleave)=\"onMouseLeave($event, record)\"\n                [ngClass]=\"setClassParent(record, i)\"\n                [class.no-border]=\"toggle[i]\"\n              >\n                <td class=\"toggle\" *ngIf=\"detailTemplate\">\n                  <button\n                    (click)=\"toggle[i] = !toggle[i]; onToggleDetail($event, record, !toggle[i])\"\n                    class=\"webuniversum dynamic-label__toggle js-dynamic-label__toggle\"\n                    type=\"button\"\n                  >\n                    <i class=\"fa\" [ngClass]=\"toggle[i] ? 'fa-minus' : 'fa-plus'\"></i>\n                  </button>\n                </td>\n                <td *ngFor=\"let map of columnMaps\" [ngSwitch]=\"map.format\" [ngClass]=\"map.classes ? map.classes(record) : undefined\">\n                  <div [ngSwitch]=\"map.format\" [style.display]=\"record.editMode ? 'none' : 'block'\">\n                    <div *ngSwitchCase=\"'checkbox'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"selectRowCheckboxColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'button'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"buttonColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'iconbutton'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"iconButtonColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'custom'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"customColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchDefault>\n                      <ng-container\n                        [ngTemplateOutlet]=\"defaultColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                  </div>\n                  <div [ngSwitch]=\"map.format\" [style.display]=\"record.editMode ? 'block' : 'none'\">\n                    <div *ngSwitchCase=\"'checkbox'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"selectRowCheckboxColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'button'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"buttonColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'iconbutton'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"iconButtonColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchDefault>\n                      <div *ngIf=\"map.editable && (map.canEdit ? map.canEdit(record) : true)\">\n                        <div *ngIf=\"map.editType === textbox\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"textboxColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                        <div *ngIf=\"map.editType === textarea\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"textareaColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                        <div *ngIf=\"map.editType === dropdown && map.dropdownValues && map.dropdownKey\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"dropdownColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                        <div *ngIf=\"map.editType === checkbox\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"checkboxColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                      </div>\n                      <div *ngIf=\"!map.editable\" [ngSwitch]=\"map.format\">\n                        <div *ngSwitchCase=\"'custom'\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"customColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                        <div *ngSwitchDefault>\n                          <ng-container\n                            [ngTemplateOutlet]=\"defaultColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </td>\n              </tr>\n              <tr *ngIf=\"toggle[i] && detailTemplate\">\n                <td></td>\n                <td [attr.colspan]=\"columnMaps.length\">\n                  <ng-container [ngTemplateOutlet]=\"detailTemplate\" [ngTemplateOutletContext]=\"{ data: record }\"> </ng-container>\n                </td>\n              </tr>\n            </ng-template>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class=\"u-spacer\" [hidden]=\"!paging || !pagedRecords || pagedRecords.length == 0\">\n    <anb-pagination #pagination (onPaginate)=\"onPaginationClick($event)\" [page]=\"page\" [count]=\"pageSize\"></anb-pagination>\n  </div>\n</div>\n\n<!-- TEMPLATES -->\n<ng-template #defaultColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <div\n    [innerHtml]=\"record[map.primaryKey] | formatCell: map.format | safe: 'html'\"\n    *ngIf=\"showValueGrouped(record, map.primaryKey, i)\"\n  ></div>\n</ng-template>\n\n<ng-template #iconButtonColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <button\n    class=\"webuniversum dynamic-label__toggle js-dynamic-label__toggle\"\n    (click)=\"onButtonClick($event, record, map.event)\"\n    title=\"{{ map.tooltip }}\"\n    [innerHTML]=\"map.text\"\n    type=\"button\"\n  ></button>\n</ng-template>\n\n<ng-template #buttonColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <button class=\"webuniversum button button--narrow\" (click)=\"onButtonClick($event, record, map.event)\" type=\"button\">\n    {{ map.text }}\n  </button>\n</ng-template>\n\n<ng-template #customColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <div [innerHtml]=\"map.template ? map.template(record) : (undefined | safe: 'html')\"></div>\n</ng-template>\n\n<ng-template #selectRowCheckboxColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <label class=\"checkbox checkbox--empty\">\n    <input\n      type=\"checkbox\"\n      name=\"checkbox\"\n      class=\"checkbox__toggle\"\n      [checked]=\"record[map.primaryKey]\"\n      [value]=\"record[map.primaryKey]\"\n      (change)=\"record[map.primaryKey] = !record[map.primaryKey]; onSelectionChange($event, record)\"\n    />\n    <span></span>\n    <span class=\"u-visually-hidden\">Selecteer rij</span>\n  </label>\n</ng-template>\n\n<ng-template #textboxColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <input\n    type=\"text\"\n    [class.input-field--error]=\"currentRecord.invalidColumns && currentRecord.invalidColumns.indexOf(map.primaryKey) > -1\"\n    class=\"webuniversum input-field\"\n    *ngIf=\"currentRecord\"\n    [(ngModel)]=\"currentRecord[map.primaryKey]\"\n  />\n</ng-template>\n\n<ng-template #textareaColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <textarea\n    [class.input-field--error]=\"currentRecord.invalidColumns && currentRecord.invalidColumns.indexOf(map.primaryKey) > -1\"\n    class=\"textarea component\"\n    *ngIf=\"currentRecord\"\n    [(ngModel)]=\"currentRecord[map.primaryKey]\"\n  ></textarea>\n</ng-template>\n\n<ng-template #dropdownColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <select\n    class=\"webuniversum select\"\n    *ngIf=\"currentRecord\"\n    [(ngModel)]=\"currentRecord[map.dropdownKey]\"\n    (change)=\"onChangeDropdown($event, currentRecord, map)\"\n  >\n    <option\n      *ngFor=\"let v of map.dropdownValues\"\n      [attr.value]=\"v.dropdownModelID\"\n      [attr.selected]=\"v.dropdownModelID === currentRecord[map.dropdownKey] ? 'selected' : null\"\n      [attr.title]=\"v.tooltip\"\n    >\n      {{ v.description }}\n    </option>\n  </select>\n</ng-template>\n\n<ng-template #checkboxColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <label class=\"checkbox checkbox--empty\">\n    <input\n      type=\"checkbox\"\n      [class.input-field--error]=\"currentRecord.invalidColumns && currentRecord.invalidColumns.indexOf(map.primaryKey) > -1\"\n      class=\"checkbox__toggle\"\n      *ngIf=\"currentRecord\"\n      [(ngModel)]=\"currentRecord[map.primaryKey]\"\n    />\n    <span></span>\n  </label>\n</ng-template>\n", styles: [".divider{border-top:3px #ccc solid}.headergroup{border-bottom:none}th.toggle{width:10px}td.toggle{padding:.9rem .5rem}td.toggle button{padding:.5rem}textarea{width:100%}.dynamic-label__toggle{padding:0}.no-border{border-bottom:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: AnbPaginationComponent, selector: "anb-pagination", inputs: ["page", "count", "resultStart", "resultEnd", "totaal"], outputs: ["onPaginate"] }, { kind: "pipe", type: FormatCellPipe, name: "formatCell" }, { kind: "pipe", type: SafePipe, name: "safe" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbDataTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-data-table', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\n  <div *ngIf=\"!pagedRecords || pagedRecords.length === 0\" class=\"u-spacer\">\n    <div class=\"alert\">\n      <div aria-hidden=\"true\"></div>\n      <div class=\"alert__content\">\n        <div class=\"alert__title\">{{ noResultFoundText }}</div>\n      </div>\n    </div>\n  </div>\n  <div *ngIf=\"pagedRecords && pagedRecords.length > 0\" class=\"u-spacer\">\n    <div data-table>\n      <div class=\"u-table-overflow\">\n        <table class=\"data-table\">\n          <thead>\n            <tr class=\"headergroup\">\n              <th class=\"toggle\" *ngIf=\"detailTemplate\"></th>\n              <th\n                *ngFor=\"let headerGroup of getHeaderGroup()\"\n                [attr.colspan]=\"headerGroup.colspan\"\n                [ngClass]=\"headerGroup.classes ? headerGroup.classes(undefined) : undefined\"\n              >\n                {{ headerGroup.header }}\n              </th>\n            </tr>\n            <tr class=\"data-table__header\">\n              <th *ngIf=\"detailTemplate\"></th>\n              <th\n                class=\"data-table__header-title\"\n                *ngFor=\"let map of columnMaps\"\n                [ngSwitch]=\"map.format\"\n                [ngClass]=\"map.classes ? map.classes(undefined) : undefined\"\n              >\n                <div *ngSwitchCase=\"'checkbox'\">\n                  <label class=\"checkbox checkbox--empty\">\n                    <input\n                      type=\"checkbox\"\n                      name=\"checkbox\"\n                      class=\"checkbox__toggle\"\n                      [checked]=\"selectAllChecked\"\n                      [value]=\"selectAllChecked\"\n                      (change)=\"selectAllChecked = !selectAllChecked; onSelectAllChange($event, map.primaryKey)\"\n                    />\n                    <span></span>\n                    <span class=\"u-visually-hidden\">Selecteer rij</span>\n                  </label>\n                </div>\n                <div *ngSwitchDefault>\n                  {{ map.header }}\n                </div>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <ng-template ngFor let-record [ngForOf]=\"pagedRecords\" let-i=\"index\">\n              <tr\n                data-table-selectable\n                (click)=\"onRowClick($event, record)\"\n                (mouseover)=\"onMouseOver($event, record)\"\n                (mouseleave)=\"onMouseLeave($event, record)\"\n                [ngClass]=\"setClassParent(record, i)\"\n                [class.no-border]=\"toggle[i]\"\n              >\n                <td class=\"toggle\" *ngIf=\"detailTemplate\">\n                  <button\n                    (click)=\"toggle[i] = !toggle[i]; onToggleDetail($event, record, !toggle[i])\"\n                    class=\"webuniversum dynamic-label__toggle js-dynamic-label__toggle\"\n                    type=\"button\"\n                  >\n                    <i class=\"fa\" [ngClass]=\"toggle[i] ? 'fa-minus' : 'fa-plus'\"></i>\n                  </button>\n                </td>\n                <td *ngFor=\"let map of columnMaps\" [ngSwitch]=\"map.format\" [ngClass]=\"map.classes ? map.classes(record) : undefined\">\n                  <div [ngSwitch]=\"map.format\" [style.display]=\"record.editMode ? 'none' : 'block'\">\n                    <div *ngSwitchCase=\"'checkbox'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"selectRowCheckboxColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'button'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"buttonColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'iconbutton'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"iconButtonColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'custom'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"customColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchDefault>\n                      <ng-container\n                        [ngTemplateOutlet]=\"defaultColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                  </div>\n                  <div [ngSwitch]=\"map.format\" [style.display]=\"record.editMode ? 'block' : 'none'\">\n                    <div *ngSwitchCase=\"'checkbox'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"selectRowCheckboxColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'button'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"buttonColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchCase=\"'iconbutton'\">\n                      <ng-container\n                        [ngTemplateOutlet]=\"iconButtonColumnTemplate\"\n                        [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                      >\n                      </ng-container>\n                    </div>\n                    <div *ngSwitchDefault>\n                      <div *ngIf=\"map.editable && (map.canEdit ? map.canEdit(record) : true)\">\n                        <div *ngIf=\"map.editType === textbox\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"textboxColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                        <div *ngIf=\"map.editType === textarea\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"textareaColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                        <div *ngIf=\"map.editType === dropdown && map.dropdownValues && map.dropdownKey\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"dropdownColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                        <div *ngIf=\"map.editType === checkbox\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"checkboxColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                      </div>\n                      <div *ngIf=\"!map.editable\" [ngSwitch]=\"map.format\">\n                        <div *ngSwitchCase=\"'custom'\">\n                          <ng-container\n                            [ngTemplateOutlet]=\"customColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                        <div *ngSwitchDefault>\n                          <ng-container\n                            [ngTemplateOutlet]=\"defaultColumnTemplate\"\n                            [ngTemplateOutletContext]=\"{ record: record, map: map, i: i }\"\n                          >\n                          </ng-container>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </td>\n              </tr>\n              <tr *ngIf=\"toggle[i] && detailTemplate\">\n                <td></td>\n                <td [attr.colspan]=\"columnMaps.length\">\n                  <ng-container [ngTemplateOutlet]=\"detailTemplate\" [ngTemplateOutletContext]=\"{ data: record }\"> </ng-container>\n                </td>\n              </tr>\n            </ng-template>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class=\"u-spacer\" [hidden]=\"!paging || !pagedRecords || pagedRecords.length == 0\">\n    <anb-pagination #pagination (onPaginate)=\"onPaginationClick($event)\" [page]=\"page\" [count]=\"pageSize\"></anb-pagination>\n  </div>\n</div>\n\n<!-- TEMPLATES -->\n<ng-template #defaultColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <div\n    [innerHtml]=\"record[map.primaryKey] | formatCell: map.format | safe: 'html'\"\n    *ngIf=\"showValueGrouped(record, map.primaryKey, i)\"\n  ></div>\n</ng-template>\n\n<ng-template #iconButtonColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <button\n    class=\"webuniversum dynamic-label__toggle js-dynamic-label__toggle\"\n    (click)=\"onButtonClick($event, record, map.event)\"\n    title=\"{{ map.tooltip }}\"\n    [innerHTML]=\"map.text\"\n    type=\"button\"\n  ></button>\n</ng-template>\n\n<ng-template #buttonColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <button class=\"webuniversum button button--narrow\" (click)=\"onButtonClick($event, record, map.event)\" type=\"button\">\n    {{ map.text }}\n  </button>\n</ng-template>\n\n<ng-template #customColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <div [innerHtml]=\"map.template ? map.template(record) : (undefined | safe: 'html')\"></div>\n</ng-template>\n\n<ng-template #selectRowCheckboxColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <label class=\"checkbox checkbox--empty\">\n    <input\n      type=\"checkbox\"\n      name=\"checkbox\"\n      class=\"checkbox__toggle\"\n      [checked]=\"record[map.primaryKey]\"\n      [value]=\"record[map.primaryKey]\"\n      (change)=\"record[map.primaryKey] = !record[map.primaryKey]; onSelectionChange($event, record)\"\n    />\n    <span></span>\n    <span class=\"u-visually-hidden\">Selecteer rij</span>\n  </label>\n</ng-template>\n\n<ng-template #textboxColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <input\n    type=\"text\"\n    [class.input-field--error]=\"currentRecord.invalidColumns && currentRecord.invalidColumns.indexOf(map.primaryKey) > -1\"\n    class=\"webuniversum input-field\"\n    *ngIf=\"currentRecord\"\n    [(ngModel)]=\"currentRecord[map.primaryKey]\"\n  />\n</ng-template>\n\n<ng-template #textareaColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <textarea\n    [class.input-field--error]=\"currentRecord.invalidColumns && currentRecord.invalidColumns.indexOf(map.primaryKey) > -1\"\n    class=\"textarea component\"\n    *ngIf=\"currentRecord\"\n    [(ngModel)]=\"currentRecord[map.primaryKey]\"\n  ></textarea>\n</ng-template>\n\n<ng-template #dropdownColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <select\n    class=\"webuniversum select\"\n    *ngIf=\"currentRecord\"\n    [(ngModel)]=\"currentRecord[map.dropdownKey]\"\n    (change)=\"onChangeDropdown($event, currentRecord, map)\"\n  >\n    <option\n      *ngFor=\"let v of map.dropdownValues\"\n      [attr.value]=\"v.dropdownModelID\"\n      [attr.selected]=\"v.dropdownModelID === currentRecord[map.dropdownKey] ? 'selected' : null\"\n      [attr.title]=\"v.tooltip\"\n    >\n      {{ v.description }}\n    </option>\n  </select>\n</ng-template>\n\n<ng-template #checkboxColumnTemplate let-record=\"record\" let-map=\"map\" let-i=\"i\">\n  <label class=\"checkbox checkbox--empty\">\n    <input\n      type=\"checkbox\"\n      [class.input-field--error]=\"currentRecord.invalidColumns && currentRecord.invalidColumns.indexOf(map.primaryKey) > -1\"\n      class=\"checkbox__toggle\"\n      *ngIf=\"currentRecord\"\n      [(ngModel)]=\"currentRecord[map.primaryKey]\"\n    />\n    <span></span>\n  </label>\n</ng-template>\n", styles: [".divider{border-top:3px #ccc solid}.headergroup{border-bottom:none}th.toggle{width:10px}td.toggle{padding:.9rem .5rem}td.toggle button{padding:.5rem}textarea{width:100%}.dynamic-label__toggle{padding:0}.no-border{border-bottom:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { paginationComponent: [{
                type: ViewChild,
                args: ['pagination', { static: true }]
            }], records: [{
                type: Input
            }], settings: [{
                type: Input
            }], paging: [{
                type: Input
            }], page: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], resetPagination: [{
                type: Input
            }], noResultFoundText: [{
                type: Input
            }], detailTemplate: [{
                type: Input
            }], selectionChanged: [{
                type: Output
            }], onPaginate: [{
                type: Output
            }], groupColumns: [{
                type: Input
            }], onRowSave: [{
                type: Output
            }], sortSettings: [{
                type: Input
            }], onMouseOverRow: [{
                type: Output
            }], onMouseLeaveRow: [{
                type: Output
            }], onCollapseDetail: [{
                type: Output
            }], onExpandDetail: [{
                type: Output
            }] } });

class AnbEnvironmentIndicatorComponent {
    constructor() {
        this.anbEnvironment = null;
        this.renderer = inject(Renderer2);
        this.el = inject(ElementRef);
    }
    ngAfterViewInit() {
        if (this.anbEnvironment === AnbEnvironmentEnum.prd)
            return;
        const env = AnbEnvironmentEnum[this.anbEnvironment];
        document.body.classList.add('environment');
        document.body.classList.toggle(env);
        const headerExists = this.el.nativeElement.parentElement.querySelector('anb-burgerprofiel-header');
        if (!headerExists) {
            this.renderer.addClass(this.el.nativeElement, 'no-burger-header');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbEnvironmentIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbEnvironmentIndicatorComponent, selector: "anb-environment-indicator", inputs: { anbEnvironment: "anbEnvironment" }, ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbEnvironmentIndicatorComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'anb-environment-indicator',
                    template: '',
                }]
        }], propDecorators: { anbEnvironment: [{
                type: Input
            }] } });

class LoadingModel {
    constructor(counter, text, width) {
        this.counter = counter;
        this.text = text;
        this.width = width;
    }
}

class Dialog {
    constructor(title, message, confirmButtonText, cancelButtonText) {
        this.confirmButtonText = 'Ja';
        this.cancelButtonText = 'Annuleren';
        this.title = title;
        this.message = message;
        if (confirmButtonText !== undefined)
            this.confirmButtonText = confirmButtonText;
        if (confirmButtonText !== undefined)
            this.cancelButtonText = cancelButtonText;
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
class AnbModalDialogComponent {
    constructor() {
        this.show = false;
        this.clearResult();
    }
    get result() {
        return this.resultSrc;
    }
    setDialog(dialog) {
        this.dialog = dialog;
        if (dialog) {
            this.show = true;
        }
    }
    setResult(ok) {
        if (ok) {
            this.resolve();
        }
        else {
            this.reject();
        }
    }
    clearResult() {
        this.resultSrc = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.dialog = null;
        this.show = false;
    }
    hide() {
        this.clearResult();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModalDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbModalDialogComponent, selector: "anb-modal-dialog", ngImport: i0, template: "<div class=\"overlay\" *ngIf=\"this.show\">\n  <div class=\"modal-dialog\" tabindex=\"-1\" role=\"document\" aria-hidden=\"true\">\n    <div class=\"modal-dialog__content\">\n      <h2 class=\"modal-dialog__title\">\n        {{ this.dialog.title }}\n      </h2>\n      <div class=\"modal-dialog__content\" [innerHtml]=\"this.dialog.message | safe: 'html'\"></div>\n      <div class=\"modal-dialog__buttons\">\n        <a href=\"javascript:void(0)\" role=\"button\" class=\"button modal-dialog__button\" (click)=\"setResult(true)\">{{\n          this.dialog.confirmButtonText\n        }}</a>\n        <a href=\"javascript:void(0)\" role=\"button\" class=\"modal-dialog__button\" (click)=\"setResult(false)\"\n          ><i class=\"vi vi-cross vi-u-link\"></i>{{ this.dialog.cancelButtonText }}</a\n        >\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModalDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-modal-dialog', template: "<div class=\"overlay\" *ngIf=\"this.show\">\n  <div class=\"modal-dialog\" tabindex=\"-1\" role=\"document\" aria-hidden=\"true\">\n    <div class=\"modal-dialog__content\">\n      <h2 class=\"modal-dialog__title\">\n        {{ this.dialog.title }}\n      </h2>\n      <div class=\"modal-dialog__content\" [innerHtml]=\"this.dialog.message | safe: 'html'\"></div>\n      <div class=\"modal-dialog__buttons\">\n        <a href=\"javascript:void(0)\" role=\"button\" class=\"button modal-dialog__button\" (click)=\"setResult(true)\">{{\n          this.dialog.confirmButtonText\n        }}</a>\n        <a href=\"javascript:void(0)\" role=\"button\" class=\"modal-dialog__button\" (click)=\"setResult(false)\"\n          ><i class=\"vi vi-cross vi-u-link\"></i>{{ this.dialog.cancelButtonText }}</a\n        >\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return []; } });

/* eslint-disable @typescript-eslint/no-explicit-any */
class AnbUIService {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.iLoadingModel = new LoadingModel(0, '', 250);
        this.loaderCounter = new BehaviorSubject(new LoadingModel(0, '', 250));
        this.ErrorList = new BehaviorSubject(new Array());
    }
    scrollToTop() {
        window.scrollTo(0, 0);
    }
    displayLoader(value, loadText, width) {
        this.iLoadingModel.text = loadText;
        this.iLoadingModel.width = width;
        const counter = value ? this.loaderCounter.value.counter + 1 : this.loaderCounter.value.counter - 1;
        this.iLoadingModel.counter = counter;
        this.loaderCounter.next(this.iLoadingModel);
    }
    ClearErrorList() {
        this.ErrorList.next(new Array());
    }
    showConfirmDialog(title, message, confirmButtonText, cancelButtonText) {
        const result$ = new Subject();
        const anbModelDialogComponentRef = this.appendComponentToBody(AnbModalDialogComponent);
        const anbModelDialogComponent = anbModelDialogComponentRef.instance;
        if (anbModelDialogComponent) {
            const dialog = new Dialog(title, message, confirmButtonText ? confirmButtonText : 'Doorgaan', cancelButtonText ? cancelButtonText : 'Terug');
            anbModelDialogComponent.setDialog(dialog);
            const dialogResult = anbModelDialogComponent.result;
            dialogResult
                .then(() => {
                this.destroyComponentFromBody(anbModelDialogComponentRef);
                result$.next(true);
            })
                .catch(() => {
                this.destroyComponentFromBody(anbModelDialogComponentRef);
                result$.next(false);
            });
        }
        return result$;
    }
    appendComponentToBody(component) {
        // Create a component reference from the component
        const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);
        // Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(componentRef.hostView);
        // Get DOM element from component
        const domElem = componentRef.hostView.rootNodes[0];
        // Append DOM element to the body
        document.body.appendChild(domElem);
        return componentRef;
    }
    destroyComponentFromBody(componentRef) {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbUIService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbUIService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbUIService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.Injector }]; } });

class AnbErrorSummaryComponent {
    constructor(anbUIService) {
        this.anbUIService = anbUIService;
        this.hideDetails = false;
        this.errorListItem = [];
        this.subs = new Subscription();
    }
    ngOnInit() {
        const sub = this.anbUIService.ErrorList.subscribe((value) => {
            this.errorListItem = value;
        });
        this.subs.add(sub);
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbErrorSummaryComponent, deps: [{ token: AnbUIService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbErrorSummaryComponent, selector: "anb-errorsummary", inputs: { title: "title", hideDetails: "hideDetails" }, ngImport: i0, template: "<div class=\"wrapper\">\n  <div *ngIf=\"errorListItem.length > 0\">\n    <!-- alert with error modifier -->\n    <div class=\"alert alert--error\">\n      <div class=\"alert__icon\" aria-hidden=\"true\"></div>\n      <div class=\"alert__content\" [class.container]=\"hideDetails\">\n        <div class=\"alert__title\" [innerHtml]=\"title | safe: 'html'\" [class.element]=\"hideDetails\"></div>\n        <div class=\"alert__message\" *ngIf=\"!hideDetails\">\n          <ul>\n            <li *ngFor=\"let error of errorListItem\">\n              <span [innerHtml]=\"error.value | safe: 'html'\"></span>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".container{position:relative}.element{position:absolute;top:50%;transform:translateY(-50%)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbErrorSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-errorsummary', template: "<div class=\"wrapper\">\n  <div *ngIf=\"errorListItem.length > 0\">\n    <!-- alert with error modifier -->\n    <div class=\"alert alert--error\">\n      <div class=\"alert__icon\" aria-hidden=\"true\"></div>\n      <div class=\"alert__content\" [class.container]=\"hideDetails\">\n        <div class=\"alert__title\" [innerHtml]=\"title | safe: 'html'\" [class.element]=\"hideDetails\"></div>\n        <div class=\"alert__message\" *ngIf=\"!hideDetails\">\n          <ul>\n            <li *ngFor=\"let error of errorListItem\">\n              <span [innerHtml]=\"error.value | safe: 'html'\"></span>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".container{position:relative}.element{position:absolute;top:50%;transform:translateY(-50%)}\n"] }]
        }], ctorParameters: function () { return [{ type: AnbUIService }]; }, propDecorators: { title: [{
                type: Input
            }], hideDetails: [{
                type: Input
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
class ErrorValue {
    constructor(code, description, asParams = false, severity = '', objectId = '') {
        this.Descriptions = [];
        this.Params = undefined;
        this.Code = code;
        this.Description = description;
        this.Severity = severity;
        this.ObjectId = objectId;
        if (asParams) {
            this.Params = this.toParameters(description);
        }
    }
    toParameters(error, prefix = '') {
        if (!error || error.length === 0) {
            return {};
        }
        const segments = error.split('-').map((segment) => segment.trim());
        return segments.reduce((acc, param) => {
            const key = `${prefix}${segments.indexOf(param)}`;
            return { ...acc, [key]: param };
        }, {});
    }
}
class ErrorResults {
}

class AnbModalRef {
    constructor() {
        this.afterClosed = new Subject();
    }
    close(dialogResult) {
        if (this.anbModal) {
            this.anbModal.close(this.instance);
            this.afterClosed.next(dialogResult);
            this.afterClosed.complete();
        }
    }
}

var AnbModalPosition;
(function (AnbModalPosition) {
    AnbModalPosition["default"] = "default";
    AnbModalPosition["left"] = "left";
    AnbModalPosition["right"] = "right";
})(AnbModalPosition || (AnbModalPosition = {}));

class AnbModalComponent {
    set content(dialogModal) {
        if (dialogModal && !this.dialogModal) {
            this.dialogModal = dialogModal;
            if (this.open === true) {
                this.showModalDialog();
            }
        }
    }
    constructor(overlay) {
        this.overlay = overlay;
        this.id = '';
        this.title = '';
        this.hideCloseButton = false;
        this.hideBackdrop = false;
        this.open = false;
        /** Enables modal closing by click on the backdrop when set to true */
        this.closeOnBackdrop = false;
        this.position = AnbModalPosition.default;
        this.close = new EventEmitter();
        this.AnbModalPosition = AnbModalPosition;
    }
    ngOnChanges(changes) {
        if (changes && changes.open) {
            if (changes.open.currentValue === true) {
                this.showModalDialog();
            }
            else {
                this.hideModalDialog();
            }
        }
        if (changes?.position) {
            this.startOpenPaneAnimation();
        }
    }
    /** Show the modal dialog */
    showModalDialog() {
        let backdropClass = '';
        if (this.hideBackdrop) {
            backdropClass = this.closeOnBackdrop ? 'opacity-zero' : 'hide-backdrop';
        }
        if (this.dialogModal) {
            const config = new OverlayConfig({
                hasBackdrop: true,
                backdropClass: ['overlay', backdropClass],
                positionStrategy: this.overlay.position().global().centerHorizontally()
            });
            this.overlayRef = this.overlay.create(config);
            this.overlayRef.attach(this.dialogModal);
            if (this.closeOnBackdrop) {
                this.overlayRef.backdropClick().subscribe(() => this.hideModalDialog());
            }
        }
    }
    /** Hide the modal dialog */
    hideModalDialog() {
        if (this.dialogModal) {
            this.open = false;
            if (this.close) {
                this.close.emit(true);
            }
        }
    }
    /** Close the left or right modal dialog with animation */
    startClosePaneAnimation() {
        return new Promise((resolve) => {
            switch (this.position) {
                case AnbModalPosition.left:
                    this.slideState = 'slide-out-from-left';
                    break;
                case AnbModalPosition.right:
                    this.slideState = 'slide-out-from-right';
                    break;
                case AnbModalPosition.default:
                    resolve();
                    return;
            }
            // Wait for the animation to complete
            setTimeout(resolve, 300);
        });
    }
    /** Open the left or right modal dialog with animation */
    startOpenPaneAnimation() {
        if (this.position === AnbModalPosition.left) {
            this.slideState = 'slide-in-from-left';
        }
        else if (this.position === AnbModalPosition.right) {
            this.slideState = 'slide-in-from-right';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModalComponent, deps: [{ token: i1$3.Overlay }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbModalComponent, selector: "anb-modal", inputs: { id: "id", title: "title", hideCloseButton: "hideCloseButton", hideBackdrop: "hideBackdrop", open: "open", closeOnBackdrop: "closeOnBackdrop", position: "position" }, outputs: { close: "close" }, viewQueries: [{ propertyName: "content", first: true, predicate: ["dialogModal"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-template cdkPortal #dialogModal=\"cdkPortal\">\n  <div class=\"vl-modal\">\n    <div\n      [@slide]=\"slideState\"\n      class=\"vl-modal-dialog\"\n      [id]=\"id\"\n      style=\"display: block\"\n      [class.hide-backdrop]\n      [class.right]=\"position === AnbModalPosition.right\"\n      [class.left]=\"position === AnbModalPosition.left\"\n    >\n      <button *ngIf=\"!hideCloseButton\" type=\"button\" class=\"vl-modal-dialog__close\" (click)=\"hideModalDialog()\">\n        <i class=\"vl-modal-dialog__close__icon vl-vi vl-vi-cross\"></i>\n        <span class=\"vl-u-visually-hidden\">Venster sluiten</span>\n      </button>\n      <h2 mat-dialog-title *ngIf=\"title\" class=\"vl-modal-dialog__title\">{{ title }}</h2>\n      <div class=\"\" id=\"modal-toggle-1-description\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", styles: ["::ng-deep .cdk-overlay-backdrop{transition:none}::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing.hide-backdrop{display:none}::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing.opacity-zero{opacity:0}::ng-deep .cdk-overlay-container{z-index:10005!important}::ng-deep .vl-modal-dialog.right{right:0;left:initial;top:0;transform:initial;max-height:initial;height:100vh;transform:translate(100%)}::ng-deep .vl-modal-dialog.left{left:0;right:initial;top:0;transform:initial;max-height:initial;height:100vh;transform:translate(-100%)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.CdkPortal, selector: "[cdkPortal]", exportAs: ["cdkPortal"] }], animations: [
            trigger('slide', [
                state('slide-in-from-right', style({ transform: 'translateX(0)' })),
                state('slide-out-from-right', style({ transform: 'translateX(100%)' })),
                state('slide-in-from-left', style({ transform: 'translateX(0)' })),
                state('slide-out-from-left', style({ transform: 'translateX(-100%)' })),
                transition('* => *', animate(300))
            ])
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-modal', animations: [
                        trigger('slide', [
                            state('slide-in-from-right', style({ transform: 'translateX(0)' })),
                            state('slide-out-from-right', style({ transform: 'translateX(100%)' })),
                            state('slide-in-from-left', style({ transform: 'translateX(0)' })),
                            state('slide-out-from-left', style({ transform: 'translateX(-100%)' })),
                            transition('* => *', animate(300))
                        ])
                    ], template: "<ng-template cdkPortal #dialogModal=\"cdkPortal\">\n  <div class=\"vl-modal\">\n    <div\n      [@slide]=\"slideState\"\n      class=\"vl-modal-dialog\"\n      [id]=\"id\"\n      style=\"display: block\"\n      [class.hide-backdrop]\n      [class.right]=\"position === AnbModalPosition.right\"\n      [class.left]=\"position === AnbModalPosition.left\"\n    >\n      <button *ngIf=\"!hideCloseButton\" type=\"button\" class=\"vl-modal-dialog__close\" (click)=\"hideModalDialog()\">\n        <i class=\"vl-modal-dialog__close__icon vl-vi vl-vi-cross\"></i>\n        <span class=\"vl-u-visually-hidden\">Venster sluiten</span>\n      </button>\n      <h2 mat-dialog-title *ngIf=\"title\" class=\"vl-modal-dialog__title\">{{ title }}</h2>\n      <div class=\"\" id=\"modal-toggle-1-description\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", styles: ["::ng-deep .cdk-overlay-backdrop{transition:none}::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing.hide-backdrop{display:none}::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing.opacity-zero{opacity:0}::ng-deep .cdk-overlay-container{z-index:10005!important}::ng-deep .vl-modal-dialog.right{right:0;left:initial;top:0;transform:initial;max-height:initial;height:100vh;transform:translate(100%)}::ng-deep .vl-modal-dialog.left{left:0;right:initial;top:0;transform:initial;max-height:initial;height:100vh;transform:translate(-100%)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.Overlay }]; }, propDecorators: { id: [{
                type: Input
            }], title: [{
                type: Input
            }], hideCloseButton: [{
                type: Input
            }], hideBackdrop: [{
                type: Input
            }], open: [{
                type: Input
            }], closeOnBackdrop: [{
                type: Input
            }], position: [{
                type: Input
            }], close: [{
                type: Output
            }], content: [{
                type: ViewChild,
                args: ['dialogModal']
            }] } });

class AnbToggleComponent {
    constructor() {
        this.useFormgroupContainer = true;
        this.open = false;
    }
    toggle() {
        this.open = !this.open;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbToggleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbToggleComponent, selector: "anb-toggle", inputs: { title: "title", useFormgroupContainer: "useFormgroupContainer", id: "id" }, ngImport: i0, template: "<div class=\"js-accordion\" [class.js-accordion--open]=\"open\">\n  <!-- toggle -->\n  <a class=\"toggle--arrow-down js-accordion__toggle\" href=\"javascript:void(0)\" (click)=\"toggle()\">\n    <i class=\"toggle__icon\"></i>{{ this.title }}</a\n  >\n  <div class=\"accordion__content\">\n    <!-- grey content-->\n    <div [class.form__group]=\"useFormgroupContainer\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-toggle', template: "<div class=\"js-accordion\" [class.js-accordion--open]=\"open\">\n  <!-- toggle -->\n  <a class=\"toggle--arrow-down js-accordion__toggle\" href=\"javascript:void(0)\" (click)=\"toggle()\">\n    <i class=\"toggle__icon\"></i>{{ this.title }}</a\n  >\n  <div class=\"accordion__content\">\n    <!-- grey content-->\n    <div [class.form__group]=\"useFormgroupContainer\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n" }]
        }], propDecorators: { title: [{
                type: Input
            }], useFormgroupContainer: [{
                type: Input
            }], id: [{
                type: Input
            }] } });

class AnbExceptionModalComponent {
    constructor(modalRef) {
        this.modalRef = modalRef;
        this.globalTitle = 'Er is iets misgelopen';
        this.globalMessage = 'Probeer het even opnieuw, als het blijft aanhouden kan je onze helpdesk contacteren door onderaan op "Meld het probleem" te klikken.';
        this.reportTitle = 'Meld het probleem';
        this.reportMessage = ' Meld het probleem aan de <a href="https://servicedesk.natuurenbos.be/plugins/servlet/desk/portal/2/create/82" target="_blank">helpdesk</a>. Geef hierbij de volgende informatie door:';
        this.messages = [];
        this.isUserError = false;
        this.copied = false;
    }
    ngOnInit() {
        const exceptionModalData = this.modalRef?.data;
        const exception = exceptionModalData?.exception;
        const error = exception?.result;
        const headers = exceptionModalData?.exception?.headers;
        this.globalTitle = exceptionModalData?.title ?? this.globalTitle;
        this.globalMessage = exceptionModalData?.message ?? this.globalMessage;
        this.reportTitle = exceptionModalData?.reportTitle ?? this.reportTitle;
        this.reportMessage = exceptionModalData?.reportMessage ?? this.reportMessage;
        if (error?.errorMessageUser) {
            this.isUserError = true;
            this.globalTitle = null;
            this.globalMessage = error.errorMessageUser;
        }
        else {
            const errorMessage = error?.errorMessage ?? exception?.message;
            const statusCode = error?.statusCode ?? exception?.status;
            const traceId = error?.traceID;
            const correlationId = headers?.['x-correlation-id'];
            const detail = exception?.result?.detail; // When using ProblemDetails
            if (errorMessage) {
                this.messages.push(new ErrorValue('Beschrijving', errorMessage));
            }
            if (detail) {
                this.messages.push(new ErrorValue('Detail', detail));
            }
            if (statusCode) {
                this.messages.push(new ErrorValue('Error Code', statusCode));
            }
            if (traceId) {
                this.messages.push(new ErrorValue('Trace ID', traceId));
            }
            if (correlationId) {
                this.messages.push(new ErrorValue('Correlation ID', correlationId));
            }
            this.messages.push(new ErrorValue('Tijdstip', new Date().toLocaleString()));
            this.messages.push(new ErrorValue('Applicatie', exceptionModalData?.applicationName));
        }
    }
    close() {
        this.modalRef.close(false);
    }
    copyToClipboard() {
        const text = this.messages.map(m => `${m.Code}: ${m.Description}`).join('\n');
        navigator.clipboard.writeText(text);
        this.copied = true;
        // Hide message after x seconds
        setTimeout(() => {
            this.copied = false;
        }, 2000);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbExceptionModalComponent, deps: [{ token: AnbModalRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbExceptionModalComponent, selector: "anb-exception-modal", viewQueries: [{ propertyName: "anbModalComponent", first: true, predicate: ["exceptionModal"], descendants: true, static: true }], ngImport: i0, template: "<anb-modal #exceptionModal id=\"exceptionModal\" title=\"\" [closeOnBackdrop]=\"false\">\n  <div\n    [class.vl-alert--warning]=\"isUserError\"\n    [class.vl-alert--error]=\"!isUserError\"\n    class=\"vl-alert\"\n    role=\"alertdialog\"\n    style=\"flex-wrap: wrap\"\n  >\n    <div style=\"display: flex\">\n      <div class=\"vl-alert__icon\">\n        <i class=\"vl-vi vl-vi-warning\" aria-hidden=\"true\"></i>\n      </div>\n      <div class=\"vl-alert__content\">\n        <ng-container *ngIf=\"globalTitle\">\n          <p class=\"vl-alert__title\">{{ globalTitle }}</p>\n        </ng-container>\n        <div class=\"vl-alert__message\">\n          <p [innerHTML]=\"globalMessage | safe: 'html'\"></p>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"messages && messages.length > 0\">\n    <anb-toggle [title]=\"reportTitle\">\n      <div style=\"width: 100%\">\n        <p *ngIf=\"reportMessage\" [innerHTML]=\"reportMessage | safe: 'html'\"></p>\n        <div class=\"vl-info-tile\" title=\"\" style=\"border: 0; padding: 0px\">\n          <header class=\"vl-info-tile__header\" role=\"presentation\">\n            <div class=\"vl-info-tile__header__wrapper\">\n              <div class=\"vl-info-tile__header__subtitle vl-typography\">\n                <ul *ngFor=\"let message of messages\">\n                  <li [innerHTML]=\"message?.Code + ': ' + message?.Description | safe: 'html'\"></li>\n                </ul>\n              </div>\n            </div>\n          </header>\n        </div>\n        <div class=\"vl-action-group vl-action-group--align-right\" style=\"margin-top: 0\">\n          <ng-container *ngIf=\"copied\">\n            <div style=\"margin-right: 10px\"><span class=\"vl-vi vl-vi-check\"></span> Details gekopieerd</div>\n          </ng-container>\n\n          <button class=\"vl-button vl-button--tertiary vl-button--icon\" vl-button (click)=\"copyToClipboard()\" title=\"Kopier naar klembord\">\n            <i class=\"vl-button__icon vl-vi vl-vi-file-copy\" aria-hidden=\"true\"></i>\n            <span class=\"vl-u-visually-hidden\">Kopier naar klembord</span>\n          </button>\n        </div>\n      </div>\n    </anb-toggle>\n  </ng-container>\n\n  <div class=\"vl-action-group vl-action-group--align-right mt-10\">\n    <button class=\"vl-button\" type=\"submit\" (click)=\"close()\">Ok</button>\n  </div>\n</anb-modal>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AnbModalComponent, selector: "anb-modal", inputs: ["id", "title", "hideCloseButton", "hideBackdrop", "open", "closeOnBackdrop", "position"], outputs: ["close"] }, { kind: "component", type: AnbToggleComponent, selector: "anb-toggle", inputs: ["title", "useFormgroupContainer", "id"] }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbExceptionModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-exception-modal', template: "<anb-modal #exceptionModal id=\"exceptionModal\" title=\"\" [closeOnBackdrop]=\"false\">\n  <div\n    [class.vl-alert--warning]=\"isUserError\"\n    [class.vl-alert--error]=\"!isUserError\"\n    class=\"vl-alert\"\n    role=\"alertdialog\"\n    style=\"flex-wrap: wrap\"\n  >\n    <div style=\"display: flex\">\n      <div class=\"vl-alert__icon\">\n        <i class=\"vl-vi vl-vi-warning\" aria-hidden=\"true\"></i>\n      </div>\n      <div class=\"vl-alert__content\">\n        <ng-container *ngIf=\"globalTitle\">\n          <p class=\"vl-alert__title\">{{ globalTitle }}</p>\n        </ng-container>\n        <div class=\"vl-alert__message\">\n          <p [innerHTML]=\"globalMessage | safe: 'html'\"></p>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"messages && messages.length > 0\">\n    <anb-toggle [title]=\"reportTitle\">\n      <div style=\"width: 100%\">\n        <p *ngIf=\"reportMessage\" [innerHTML]=\"reportMessage | safe: 'html'\"></p>\n        <div class=\"vl-info-tile\" title=\"\" style=\"border: 0; padding: 0px\">\n          <header class=\"vl-info-tile__header\" role=\"presentation\">\n            <div class=\"vl-info-tile__header__wrapper\">\n              <div class=\"vl-info-tile__header__subtitle vl-typography\">\n                <ul *ngFor=\"let message of messages\">\n                  <li [innerHTML]=\"message?.Code + ': ' + message?.Description | safe: 'html'\"></li>\n                </ul>\n              </div>\n            </div>\n          </header>\n        </div>\n        <div class=\"vl-action-group vl-action-group--align-right\" style=\"margin-top: 0\">\n          <ng-container *ngIf=\"copied\">\n            <div style=\"margin-right: 10px\"><span class=\"vl-vi vl-vi-check\"></span> Details gekopieerd</div>\n          </ng-container>\n\n          <button class=\"vl-button vl-button--tertiary vl-button--icon\" vl-button (click)=\"copyToClipboard()\" title=\"Kopier naar klembord\">\n            <i class=\"vl-button__icon vl-vi vl-vi-file-copy\" aria-hidden=\"true\"></i>\n            <span class=\"vl-u-visually-hidden\">Kopier naar klembord</span>\n          </button>\n        </div>\n      </div>\n    </anb-toggle>\n  </ng-container>\n\n  <div class=\"vl-action-group vl-action-group--align-right mt-10\">\n    <button class=\"vl-button\" type=\"submit\" (click)=\"close()\">Ok</button>\n  </div>\n</anb-modal>\n" }]
        }], ctorParameters: function () { return [{ type: AnbModalRef }]; }, propDecorators: { anbModalComponent: [{
                type: ViewChild,
                args: ['exceptionModal', { static: true }]
            }] } });

class AnbModalLoadingComponent {
    constructor() {
        this.isModalShown = false;
        this.isOverlay = true;
        this.beforeAll = true;
        this.subs = new Subscription();
        this.width = 250;
    }
    ngOnInit() {
        if (this.loaderCounter) {
            const sub = this.loaderCounter.subscribe((pLoadingModel) => {
                this.isModalShown = pLoadingModel.counter !== 0;
                this.loadText = pLoadingModel.text;
                if (pLoadingModel.width) {
                    this.width = pLoadingModel.width;
                }
                else {
                    this.width = 250;
                }
            });
            this.subs.add(sub);
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModalLoadingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbModalLoadingComponent, selector: "anb-modal-loading", inputs: { loadText: "loadText", loaderCounter: "loaderCounter", isModalShown: "isModalShown", isOverlay: "isOverlay", beforeAll: "beforeAll" }, ngImport: i0, template: "<div class=\"overlay\" [class.before_all]=\"beforeAll\" *ngIf=\"isModalShown && isOverlay\">\n  <div class=\"modal-dialog\" tabindex=\"-1\" role=\"document\" aria-hidden=\"true\" [style.width.px]=\"width\">\n    <div class=\"modal-dialog__content\">\n      <div class=\"alert__content\">\n        <div class=\"alert__title centered\">Even geduld</div>\n        <br />\n        <div class=\"alert__message centered\">\n          <div class=\"loader\"></div>\n          <br />\n          <div *ngIf=\"loadText\">{{ loadText }}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"isModalShown && !isOverlay\">\n  <div class=\"modal-dialog\" tabindex=\"-1\" role=\"document\" aria-hidden=\"true\" [style.width.px]=\"width\">\n    <div class=\"modal-dialog__content\">\n      <div class=\"alert__content\">\n        <div class=\"alert__title centered\">Even geduld</div>\n        <br />\n        <div class=\"alert__message centered\">\n          <div class=\"loader\"></div>\n          <br />\n          <div *ngIf=\"loadText\">{{ loadText }}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".centered{text-align:center}::ng-deep .overlay.before_all{z-index:11000}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModalLoadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-modal-loading', template: "<div class=\"overlay\" [class.before_all]=\"beforeAll\" *ngIf=\"isModalShown && isOverlay\">\n  <div class=\"modal-dialog\" tabindex=\"-1\" role=\"document\" aria-hidden=\"true\" [style.width.px]=\"width\">\n    <div class=\"modal-dialog__content\">\n      <div class=\"alert__content\">\n        <div class=\"alert__title centered\">Even geduld</div>\n        <br />\n        <div class=\"alert__message centered\">\n          <div class=\"loader\"></div>\n          <br />\n          <div *ngIf=\"loadText\">{{ loadText }}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div *ngIf=\"isModalShown && !isOverlay\">\n  <div class=\"modal-dialog\" tabindex=\"-1\" role=\"document\" aria-hidden=\"true\" [style.width.px]=\"width\">\n    <div class=\"modal-dialog__content\">\n      <div class=\"alert__content\">\n        <div class=\"alert__title centered\">Even geduld</div>\n        <br />\n        <div class=\"alert__message centered\">\n          <div class=\"loader\"></div>\n          <br />\n          <div *ngIf=\"loadText\">{{ loadText }}</div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".centered{text-align:center}::ng-deep .overlay.before_all{z-index:11000}\n"] }]
        }], propDecorators: { loadText: [{
                type: Input
            }], loaderCounter: [{
                type: Input
            }], isModalShown: [{
                type: Input
            }], isOverlay: [{
                type: Input
            }], beforeAll: [{
                type: Input
            }] } });

class AnbPopoverComponent {
    constructor() {
        this.infoText = '';
        this.titleText = 'Informatie';
        this.buttonText = 'Extra informatie';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbPopoverComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbPopoverComponent, selector: "anb-popover", inputs: { infoText: "infoText", titleText: "titleText", buttonText: "buttonText" }, ngImport: i0, template: "<template #popContent>{{ infoText }}</template>\n<button type=\"button\" class=\"btn btn-outline-secondary\" placement=\"top\">\n  {{ buttonText }}\n</button>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-popover', template: "<template #popContent>{{ infoText }}</template>\n<button type=\"button\" class=\"btn btn-outline-secondary\" placement=\"top\">\n  {{ buttonText }}\n</button>\n" }]
        }], propDecorators: { infoText: [{
                type: Input
            }], titleText: [{
                type: Input
            }], buttonText: [{
                type: Input
            }] } });

class SnackBarAlert {
}

class AnbSnackBarComponent {
    constructor(alert) {
        this.alert = alert;
        this.snackBarRef = inject(MatSnackBarRef);
        this.AlertType = AlertType;
    }
    close() {
        this.snackBarRef.dismiss();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSnackBarComponent, deps: [{ token: MAT_SNACK_BAR_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbSnackBarComponent, selector: "anb-snack-bar", ngImport: i0, template: "<div\n  tabindex=\"-1\"\n  matSnackBarLabel\n  class=\"vl-alert\"\n  [ngClass]=\"{\n    'vl-alert--success': alert.type == AlertType.Success,\n    'vl-alert--error': alert.type == AlertType.Error,\n    'vl-alert--warning': alert.type == AlertType.Warning,\n    'vl-alert--cta': alert.type == AlertType.Info\n  }\"\n  role=\"alert\"\n>\n  <div class=\"vl-alert__icon\">\n    <i\n      class=\"vl-vi\"\n      [ngClass]=\"{\n        'vl-vi-check': alert.type == AlertType.Success,\n        'vl-vi-warning': alert.type == AlertType.Error || alert.type == AlertType.Warning,\n        'vl-vi-info': alert.type == AlertType.Info\n      }\"\n      aria-hidden=\"true\"\n    ></i>\n  </div>\n  <ng-container *ngIf=\"alert.canClose\">\n    <button class=\"vl-alert__close\" type=\"button\" (click)=\"close()\">\n      <i class=\"vl-vi vl-vi-close\" aria-hidden=\"true\"></i>\n      <span class=\"vl-u-visually-hidden\">Sluiten</span>\n    </button>\n  </ng-container>\n  <div class=\"vl-alert__content\">\n    <p *ngIf=\"!!alert.title\" class=\"vl-alert__title\">{{ alert.title }}</p>\n    <div class=\"vl-alert__message\" [innerHtml]=\"alert.message | safe: 'html'\"></div>\n  </div>\n</div>\n", styles: [".vl-vi-check,.vl-vi-warning{color:#fff}.vl-vi-info,.vl-alert--success,.vl-alert--error,.vl-alert--warning,.vl-alert--cta{color:#333332}::ng-deep .mdc-snackbar__surface{padding:0}.vl-alert__close{transform:none!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.MatSnackBarLabel, selector: "[matSnackBarLabel]" }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSnackBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-snack-bar', template: "<div\n  tabindex=\"-1\"\n  matSnackBarLabel\n  class=\"vl-alert\"\n  [ngClass]=\"{\n    'vl-alert--success': alert.type == AlertType.Success,\n    'vl-alert--error': alert.type == AlertType.Error,\n    'vl-alert--warning': alert.type == AlertType.Warning,\n    'vl-alert--cta': alert.type == AlertType.Info\n  }\"\n  role=\"alert\"\n>\n  <div class=\"vl-alert__icon\">\n    <i\n      class=\"vl-vi\"\n      [ngClass]=\"{\n        'vl-vi-check': alert.type == AlertType.Success,\n        'vl-vi-warning': alert.type == AlertType.Error || alert.type == AlertType.Warning,\n        'vl-vi-info': alert.type == AlertType.Info\n      }\"\n      aria-hidden=\"true\"\n    ></i>\n  </div>\n  <ng-container *ngIf=\"alert.canClose\">\n    <button class=\"vl-alert__close\" type=\"button\" (click)=\"close()\">\n      <i class=\"vl-vi vl-vi-close\" aria-hidden=\"true\"></i>\n      <span class=\"vl-u-visually-hidden\">Sluiten</span>\n    </button>\n  </ng-container>\n  <div class=\"vl-alert__content\">\n    <p *ngIf=\"!!alert.title\" class=\"vl-alert__title\">{{ alert.title }}</p>\n    <div class=\"vl-alert__message\" [innerHtml]=\"alert.message | safe: 'html'\"></div>\n  </div>\n</div>\n", styles: [".vl-vi-check,.vl-vi-warning{color:#fff}.vl-vi-info,.vl-alert--success,.vl-alert--error,.vl-alert--warning,.vl-alert--cta{color:#333332}::ng-deep .mdc-snackbar__surface{padding:0}.vl-alert__close{transform:none!important}\n"] }]
        }], ctorParameters: function () { return [{ type: SnackBarAlert, decorators: [{
                    type: Inject,
                    args: [MAT_SNACK_BAR_DATA]
                }] }]; } });

class StepperService {
    constructor() {
        this.currentStepComponent$ = new BehaviorSubject(null);
    }
}

class AnbStepperComponent {
    constructor(stepperService, router) {
        this.stepperService = stepperService;
        this.router = router;
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onNavigate = new EventEmitter();
        this.subs = new Subscription();
        const sub = router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.activateStep();
        });
        this.subs.add(sub);
    }
    ngOnInit() {
        const sub = this.stepperService.currentStepComponent$.subscribe((component) => {
            this.currentStepComponent = component;
        });
        this.subs.add(sub);
        this.activateStep();
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    onActivate(component) {
        this.currentRoutingComponent = component;
    }
    activateStep() {
        if (this.steps) {
            this.steptitle = null;
            this.steps.forEach((step) => {
                const currentUrlTree = this.router.parseUrl(this.router.url);
                const stepUrlTree = this.router.createUrlTree(step.route);
                const currentUrl = this.getPathFromUrl(this.router.serializeUrl(currentUrlTree));
                const stepUrl = this.router.serializeUrl(stepUrlTree);
                if (currentUrl === stepUrl) {
                    step.active = true;
                    this.steptitle = step.title;
                }
                else {
                    step.active = false;
                }
            });
        }
    }
    getPathFromUrl(url) {
        return url.split(/[?#]/)[0];
    }
    navigateOnClick(step) {
        if (this.onNavigate && this.onNavigate.observers.length > 0) {
            this.onNavigate.emit(step);
        }
        else {
            this.router.navigate(step.route);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbStepperComponent, deps: [{ token: StepperService }, { token: i2$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbStepperComponent, selector: "anb-stepper", inputs: { steps: "steps" }, outputs: { onNavigate: "onNavigate" }, ngImport: i0, template: "<h4 class=\"vl-title vl-title--h4\" *ngIf=\"steptitle\">\n  {{ steptitle }}\n</h4>\n\n<!-- Begin Progressbar  -->\n<div class=\"vl-progress-bar vl-u-spacer--medium\">\n  <div\n    *ngFor=\"let step of steps\"\n    class=\"vl-progress-bar__step\"\n    [class.vl-progress-bar__step--active]=\"step.active\"\n    [class.vl-u-hidden]=\"step.hidden\"\n  >\n    <button class=\"vl-progress-bar__bullet js-vl-tooltip\" (click)=\"navigateOnClick(step)\" type=\"button\">\n      <span class=\"vl-u-visually-hidden\"></span>\n    </button>\n  </div>\n</div>\n<!-- End Progressbar  -->\n<router-outlet name=\"stap\" (activate)=\"onActivate($event)\"></router-outlet>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.RouterOutlet, selector: "router-outlet", inputs: ["name"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbStepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-stepper', template: "<h4 class=\"vl-title vl-title--h4\" *ngIf=\"steptitle\">\n  {{ steptitle }}\n</h4>\n\n<!-- Begin Progressbar  -->\n<div class=\"vl-progress-bar vl-u-spacer--medium\">\n  <div\n    *ngFor=\"let step of steps\"\n    class=\"vl-progress-bar__step\"\n    [class.vl-progress-bar__step--active]=\"step.active\"\n    [class.vl-u-hidden]=\"step.hidden\"\n  >\n    <button class=\"vl-progress-bar__bullet js-vl-tooltip\" (click)=\"navigateOnClick(step)\" type=\"button\">\n      <span class=\"vl-u-visually-hidden\"></span>\n    </button>\n  </div>\n</div>\n<!-- End Progressbar  -->\n<router-outlet name=\"stap\" (activate)=\"onActivate($event)\"></router-outlet>\n" }]
        }], ctorParameters: function () { return [{ type: StepperService }, { type: i2$1.Router }]; }, propDecorators: { steps: [{
                type: Input
            }], onNavigate: [{
                type: Output
            }] } });

class AnbStepComponent {
    constructor() {
        this.open = false;
        this.disabled = false;
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onToggle = new EventEmitter();
    }
    toggle() {
        this.open = !this.open;
        this.onToggle.emit(this.open);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbStepComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbStepComponent, selector: "anb-step", inputs: { id: "id", icon: "icon", title: "title", open: "open", valid: "valid", disabled: "disabled" }, outputs: { onToggle: "onToggle" }, ngImport: i0, template: "<li\n  class=\"vl-step vl-step--accordion\"\n  [class.js-vl-accordion--open]=\"open\"\n  [class.vl-step--valid]=\"valid === true\"\n  [class.vl-step--disabled]=\"disabled\"\n  [attr.id]=\"id\"\n>\n  <div class=\"vl-step__icon\" [innerHtml]=\"icon\"></div>\n  <div class=\"vl-step__wrapper\">\n    <button class=\"vl-step__header js-vl-accordion__toggle\" (click)=\"toggle()\" type=\"button\">\n      <div class=\"vl-step__header__titles\">\n        <h3 class=\"vl-step__title\" [innerHtml]=\"title\"></h3>\n      </div>\n      <div class=\"vl-step__header__info\" aria-hidden=\"true\">\n        <em class=\"vl-step__accordion-toggle\"></em>\n      </div>\n    </button>\n    <div class=\"vl-step__content-wrapper\">\n      <p class=\"vl-step__content\">\n        <ng-content></ng-content>\n      </p>\n    </div>\n  </div>\n</li>\n", styles: ["::ng-deep .vl-steps--has-line .vl-step{margin-top:1.5rem}::ng-deep .vl-step--valid .vl-step__icon{background-color:#8bae00}::ng-deep .vl-step--disabled .vl-step__icon{background-color:#cbd2da}::ng-deep .vl-step--accordion.js-vl-accordion--open .vl-step__content-wrapper{max-height:initial}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-step', template: "<li\n  class=\"vl-step vl-step--accordion\"\n  [class.js-vl-accordion--open]=\"open\"\n  [class.vl-step--valid]=\"valid === true\"\n  [class.vl-step--disabled]=\"disabled\"\n  [attr.id]=\"id\"\n>\n  <div class=\"vl-step__icon\" [innerHtml]=\"icon\"></div>\n  <div class=\"vl-step__wrapper\">\n    <button class=\"vl-step__header js-vl-accordion__toggle\" (click)=\"toggle()\" type=\"button\">\n      <div class=\"vl-step__header__titles\">\n        <h3 class=\"vl-step__title\" [innerHtml]=\"title\"></h3>\n      </div>\n      <div class=\"vl-step__header__info\" aria-hidden=\"true\">\n        <em class=\"vl-step__accordion-toggle\"></em>\n      </div>\n    </button>\n    <div class=\"vl-step__content-wrapper\">\n      <p class=\"vl-step__content\">\n        <ng-content></ng-content>\n      </p>\n    </div>\n  </div>\n</li>\n", styles: ["::ng-deep .vl-steps--has-line .vl-step{margin-top:1.5rem}::ng-deep .vl-step--valid .vl-step__icon{background-color:#8bae00}::ng-deep .vl-step--disabled .vl-step__icon{background-color:#cbd2da}::ng-deep .vl-step--accordion.js-vl-accordion--open .vl-step__content-wrapper{max-height:initial}\n"] }]
        }], propDecorators: { id: [{
                type: Input
            }], icon: [{
                type: Input
            }], title: [{
                type: Input
            }], open: [{
                type: Input
            }], valid: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onToggle: [{
                type: Output
            }] } });

class AnbStepsComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbStepsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbStepsComponent, selector: "anb-steps", ngImport: i0, template: "<ul class=\"vl-steps vl-steps--has-line\">\n  <ng-content></ng-content>\n</ul>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbStepsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-steps', template: "<ul class=\"vl-steps vl-steps--has-line\">\n  <ng-content></ng-content>\n</ul>\n" }]
        }] });

class AnbToggleButtonComponent {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.click = new EventEmitter();
    }
    get imgSrc() {
        if (this.selected === true) {
            return this.defaultIconUri;
        }
        return this.selectedIconUri;
    }
    buttonOnClick() {
        if (this.click) {
            this.click.emit();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbToggleButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbToggleButtonComponent, selector: "anb-toggle-button", inputs: { text: "text", selected: "selected", defaultIconUri: "defaultIconUri", selectedIconUri: "selectedIconUri" }, outputs: { click: "click" }, ngImport: i0, template: "<button class=\"button toggle-button\" [class.button--secondary]=\"!selected\" (click)=\"buttonOnClick()\" type=\"button\">\n  <img *ngIf=\"imgSrc\" src=\"{{ imgSrc }}\" height=\"20\" class=\"button-icon\" />\n  <span [innerHtml]=\"text\"></span>\n</button>\n", styles: [".button-icon{margin-right:10px;position:relative;top:3px}.toggle-button{border:.3rem solid #06c;margin-right:-.3rem}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbToggleButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-toggle-button', template: "<button class=\"button toggle-button\" [class.button--secondary]=\"!selected\" (click)=\"buttonOnClick()\" type=\"button\">\n  <img *ngIf=\"imgSrc\" src=\"{{ imgSrc }}\" height=\"20\" class=\"button-icon\" />\n  <span [innerHtml]=\"text\"></span>\n</button>\n", styles: [".button-icon{margin-right:10px;position:relative;top:3px}.toggle-button{border:.3rem solid #06c;margin-right:-.3rem}\n"] }]
        }], propDecorators: { text: [{
                type: Input
            }], selected: [{
                type: Input
            }], defaultIconUri: [{
                type: Input
            }], selectedIconUri: [{
                type: Input
            }], click: [{
                type: Output
            }] } });

class AnbToggleButtonGroupComponent {
    constructor() {
        this.subs = new Subscription();
    }
    ngAfterContentInit() {
        if (this.buttons) {
            this.buttons.forEach((button) => {
                const sub = button.click.subscribe(() => {
                    this.setSelectedButton(button);
                });
                this.subs.add(sub);
            });
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    setSelectedButton(button) {
        this.buttons.forEach((b) => {
            b.selected = false;
        });
        button.selected = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbToggleButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbToggleButtonGroupComponent, selector: "anb-toggle-button-group", queries: [{ propertyName: "buttons", predicate: AnbToggleButtonComponent }], ngImport: i0, template: "<div class=\"button-group toggle-button-group\">\n  <ng-content></ng-content>\n</div>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbToggleButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-toggle-button-group', template: "<div class=\"button-group toggle-button-group\">\n  <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { buttons: [{
                type: ContentChildren,
                args: [AnbToggleButtonComponent]
            }] } });

class AnbWizardPaneComponent {
    constructor() {
        this.active = false;
        this.canNavigate = true;
        this.isLoading = false;
        this.errors = [];
    }
    ngOnInit() {
        if (!this.id) {
            this.id = 'tab' + this.title.replace(' ', '');
        }
        if (!this.tabHeaderControlId) {
            this.tabHeaderControlId = 'tabHeader' + this.title.replace(' ', '');
        }
    }
    setErrorDescription(error) {
        this.errors = error;
    }
    setErrorOnField(fields) {
        for (let element in fields) {
            if (fields[element] && fields[element].key && fields[element].key.indexOf('.') > -1) {
                let fieldRef = this.group.controls;
                let fieldTab = fields[element].key.substr(0, fields[element].key.indexOf('.'));
                let fieldName = fields[element].key.substr(fields[element].key.indexOf('.') + 1);
                let tab = fieldRef[fieldTab];
                if (tab && tab.controls[fieldName]) {
                    tab.controls[fieldName].setErrors({ 'incorrect': true });
                }
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbWizardPaneComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbWizardPaneComponent, selector: "anb-wizard-pane", inputs: { title: ["tabTitle", "title"], active: "active", id: "id", canNavigate: "canNavigate", isLoading: "isLoading", group: "group" }, outputs: { tabHeaderControlId: "tabHeaderControlId" }, ngImport: i0, template: "<div [hidden]=\"!active\" role=\"tabpanel\" [attr.id]=\"id\" [attr.aria-labelledby]=\"tabHeaderControlId\" [attr.aria-hidden]=\"!active\">\n\n  <div class=\"wrapper\">\n    <div class=\"centeredOverlay\" *ngIf=\"isLoading\">\n      <span><anb-modal-loading [isModalShown]=\"isLoading\" [isOverlay]=\"false\"></anb-modal-loading></span>\n    </div>\n\n    <div *ngIf=\"errors.length > 0\">\n      <!-- alert with error modifier -->\n      <div class=\"alert alert--error\">\n        <div class=\"alert__icon\" aria-hidden=\"true\"></div>\n        <div class=\"alert__content\">\n          <div class=\"alert__title\">Fout!</div>\n          <div class=\"alert__message\">\n            <ul>\n              <li *ngFor=\"let errorMsg of errors;\">\n                <span [innerHtml]=\"errorMsg | safe:'html'\"></span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <ng-content></ng-content>\n  </div>\n</div>", styles: [".pane{padding:1em}.centeredOverlay{position:absolute;background-color:#fffc;top:0;left:0;width:100%;height:100%;z-index:1000}.centeredOverlay span{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.wrapper{position:relative}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AnbModalLoadingComponent, selector: "anb-modal-loading", inputs: ["loadText", "loaderCounter", "isModalShown", "isOverlay", "beforeAll"] }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbWizardPaneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-wizard-pane', template: "<div [hidden]=\"!active\" role=\"tabpanel\" [attr.id]=\"id\" [attr.aria-labelledby]=\"tabHeaderControlId\" [attr.aria-hidden]=\"!active\">\n\n  <div class=\"wrapper\">\n    <div class=\"centeredOverlay\" *ngIf=\"isLoading\">\n      <span><anb-modal-loading [isModalShown]=\"isLoading\" [isOverlay]=\"false\"></anb-modal-loading></span>\n    </div>\n\n    <div *ngIf=\"errors.length > 0\">\n      <!-- alert with error modifier -->\n      <div class=\"alert alert--error\">\n        <div class=\"alert__icon\" aria-hidden=\"true\"></div>\n        <div class=\"alert__content\">\n          <div class=\"alert__title\">Fout!</div>\n          <div class=\"alert__message\">\n            <ul>\n              <li *ngFor=\"let errorMsg of errors;\">\n                <span [innerHtml]=\"errorMsg | safe:'html'\"></span>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <ng-content></ng-content>\n  </div>\n</div>", styles: [".pane{padding:1em}.centeredOverlay{position:absolute;background-color:#fffc;top:0;left:0;width:100%;height:100%;z-index:1000}.centeredOverlay span{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.wrapper{position:relative}\n"] }]
        }], propDecorators: { title: [{
                type: Input,
                args: ['tabTitle']
            }], active: [{
                type: Input
            }], id: [{
                type: Input
            }], canNavigate: [{
                type: Input,
                args: ['canNavigate']
            }], isLoading: [{
                type: Input,
                args: ['isLoading']
            }], group: [{
                type: Input,
                args: ['group']
            }], tabHeaderControlId: [{
                type: Output
            }] } });

class AnbWizardComponent {
    constructor(anbUIService) {
        this.anbUIService = anbUIService;
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
        this.onSelect = new EventEmitter();
        this.isCurrentTabFirst = true;
        this.isCurrentTabLast = false;
        this.canNavigate = true;
        this.iPreventNavigation = new BehaviorSubject(false);
        this.iLoadersForTabsAfterContentInit = new Array();
    }
    // contentChildren are set
    ngAfterContentInit() {
        // get all active tabs
        const activeTabs = this.tabs.filter((tab) => tab.active);
        // if there is no active tab set, activate the first
        if (activeTabs.length === 0) {
            this.selectTab(this.tabs.first);
        }
        this.iPreventNavigation.subscribe((value) => {
            if (value) {
                this.canNavigate = false;
            }
            else {
                this.canNavigate = true;
            }
        });
        this.setLoadersAfterContentInit();
    }
    preventNavigation(value) {
        this.iPreventNavigation.next(value);
    }
    selectTab(tab) {
        /* if (tab.requireType && (!this.dossiertype || !this.dossiertype.value)) {
                this.warn('Gelieve eerst een dossiertype aan te duiden');
                return;
            }*/
        if (this.onSelecting !== undefined && !this.onSelecting(this.currentTab, tab)) {
            return;
        }
        if (!this.canNavigate) {
            return;
        }
        // deactivate all tabs
        const tabArr = this.tabs.toArray();
        tabArr.forEach(() => (tab.active = false));
        // activate the tab the user has clicked on.
        if (tab) {
            tab.active = true;
        }
        this.currentTab = tab;
        this.checkTabStatus();
        this.anbUIService.scrollToTop();
    }
    selectTabById(tab) {
        if (tab) {
            const tabComponent = this.tabs.find((p) => p.id === tab);
            if (tabComponent) {
                this.selectTab(tabComponent);
            }
        }
    }
    checkCurrentTabFirst() {
        if (this.tabs) {
            const index = this.tabs.toArray().indexOf(this.currentTab);
            if (this.currentTab && index === 0) {
                this.isCurrentTabFirst = true;
                return;
            }
        }
        this.isCurrentTabFirst = false;
    }
    checkCurrentTabLast() {
        if (this.tabs) {
            const index = this.tabs.toArray().indexOf(this.currentTab);
            if (this.currentTab && index + 1 === this.tabs.length) {
                this.isCurrentTabLast = true;
                return;
            }
        }
        this.isCurrentTabLast = false;
    }
    checkTabStatus() {
        this.checkCurrentTabFirst();
        this.checkCurrentTabLast();
        this.onSelect.emit({
            isCurrentTabFirst: this.isCurrentTabFirst,
            isCurrentTabLast: this.isCurrentTabLast,
            currentTab: this.currentTab,
        });
    }
    volgendeTab() {
        const index = this.tabs.toArray().indexOf(this.currentTab);
        const nextTab = this.tabs.toArray()[index + 1];
        this.selectTab(nextTab);
    }
    vorigeTab() {
        const index = this.tabs.toArray().indexOf(this.currentTab);
        const previousTab = this.tabs.toArray()[index - 1];
        this.selectTab(previousTab);
    }
    clearErrorDescriptions() {
        this.tabs.forEach((tab) => {
            tab.setErrorDescription([]);
        });
    }
    setErrorDescription(tab, errors) {
        const errorsSummary = [];
        for (const errorMsg of errors) {
            for (const message of errorMsg.value) {
                if (errorsSummary.indexOf(message) === -1) {
                    errorsSummary.push(message);
                }
            }
        }
        const wizardPaneComponent = this.tabs.find((p) => p.id === tab);
        if (wizardPaneComponent) {
            wizardPaneComponent.setErrorDescription(errorsSummary);
            wizardPaneComponent.setErrorOnField(errors);
            if (errorsSummary.length > 0) {
                this.anbUIService.scrollToTop();
            }
        }
    }
    setLoader(tab, value) {
        if (this.tabs) {
            const wizardPaneComponent = this.tabs.find((p) => p.id === tab);
            if (wizardPaneComponent) {
                wizardPaneComponent.isLoading = value;
            }
        }
        else {
            this.iLoadersForTabsAfterContentInit.push(tab);
        }
    }
    setLoadersAfterContentInit() {
        for (const tab of this.iLoadersForTabsAfterContentInit) {
            this.setLoader(tab, true);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbWizardComponent, deps: [{ token: AnbUIService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbWizardComponent, selector: "anb-wizard", outputs: { onSelect: "onSelect" }, queries: [{ propertyName: "tabs", predicate: AnbWizardPaneComponent }], ngImport: i0, template: "<div class=\"webuniversum tabs__wrapper\">\n  <div class=\"progress-bar\" role=\"progressbar\" style=\"background-color: transparent\">\n    <div *ngFor=\"let tab of tabs\" class=\"progress-bar__step\" [class.progress-bar__step--active]=\"tab.active\">\n      <a\n        *ngIf=\"canNavigate && tab.canNavigate\"\n        href=\"javascript:void(0)\"\n        (click)=\"selectTab(tab)\"\n        class=\"progress-bar__bullet\"\n        data-toggle=\"popover\"\n        aria-label=\"Stap 1: Gegevens\"\n        data-content=\"Gegevens\"\n        data-placement=\"top\"\n        data-wizard-step\n      ></a>\n      <span *ngIf=\"!canNavigate || !tab.canNavigate\" class=\"progress-bar__bullet\" data-toggle=\"popover\"></span>\n      <!-- [aria-expanded]=\"tab.active\" -->\n    </div>\n    <!--<div class=\"progress-bar__step\">\n            <a href=\"#\" class=\"progress-bar__bullet\" data-toggle=\"popover\" aria-label=\"Stap 2: Meer gegevens\" data-content=\"Meer gegevens\" data-placement=\"top\" data-wizard-step></a>\n        </div>\n        <div class=\"progress-bar__step\">\n            <a href=\"#\" class=\"progress-bar__bullet\" data-toggle=\"popover\" aria-label=\"Stap 3: Nog meer gegevens\" data-content=\"Nog meer gegevens\" data-placement=\"top\" data-wizard-step></a>\n        </div>\n        <div class=\"progress-bar__step\">\n            <a href=\"#\" class=\"progress-bar__bullet\" data-toggle=\"popover\" aria-label=\"Stap 4: En nog meer gegevens\" data-content=\"En nog meer ggevens\" data-placement=\"top\" data-wizard-step></a>\n        </div>-->\n  </div>\n  <div class=\"wizard__panes\" style=\"clear: both\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [".progress-bar{box-shadow:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbWizardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-wizard', template: "<div class=\"webuniversum tabs__wrapper\">\n  <div class=\"progress-bar\" role=\"progressbar\" style=\"background-color: transparent\">\n    <div *ngFor=\"let tab of tabs\" class=\"progress-bar__step\" [class.progress-bar__step--active]=\"tab.active\">\n      <a\n        *ngIf=\"canNavigate && tab.canNavigate\"\n        href=\"javascript:void(0)\"\n        (click)=\"selectTab(tab)\"\n        class=\"progress-bar__bullet\"\n        data-toggle=\"popover\"\n        aria-label=\"Stap 1: Gegevens\"\n        data-content=\"Gegevens\"\n        data-placement=\"top\"\n        data-wizard-step\n      ></a>\n      <span *ngIf=\"!canNavigate || !tab.canNavigate\" class=\"progress-bar__bullet\" data-toggle=\"popover\"></span>\n      <!-- [aria-expanded]=\"tab.active\" -->\n    </div>\n    <!--<div class=\"progress-bar__step\">\n            <a href=\"#\" class=\"progress-bar__bullet\" data-toggle=\"popover\" aria-label=\"Stap 2: Meer gegevens\" data-content=\"Meer gegevens\" data-placement=\"top\" data-wizard-step></a>\n        </div>\n        <div class=\"progress-bar__step\">\n            <a href=\"#\" class=\"progress-bar__bullet\" data-toggle=\"popover\" aria-label=\"Stap 3: Nog meer gegevens\" data-content=\"Nog meer gegevens\" data-placement=\"top\" data-wizard-step></a>\n        </div>\n        <div class=\"progress-bar__step\">\n            <a href=\"#\" class=\"progress-bar__bullet\" data-toggle=\"popover\" aria-label=\"Stap 4: En nog meer gegevens\" data-content=\"En nog meer ggevens\" data-placement=\"top\" data-wizard-step></a>\n        </div>-->\n  </div>\n  <div class=\"wizard__panes\" style=\"clear: both\">\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [".progress-bar{box-shadow:none}\n"] }]
        }], ctorParameters: function () { return [{ type: AnbUIService }]; }, propDecorators: { onSelect: [{
                type: Output
            }], tabs: [{
                type: ContentChildren,
                args: [AnbWizardPaneComponent]
            }] } });

var HorizontalPosition;
(function (HorizontalPosition) {
    HorizontalPosition["Left"] = "left";
    HorizontalPosition["Center"] = "center";
    HorizontalPosition["Right"] = "right";
})(HorizontalPosition || (HorizontalPosition = {}));
var VerticalPosition;
(function (VerticalPosition) {
    VerticalPosition["Top"] = "top";
    VerticalPosition["Bottom"] = "bottom";
})(VerticalPosition || (VerticalPosition = {}));

const AnbSnackBarDefaultOptions = {
    durationInSeconds: 0,
    horizontalPosition: HorizontalPosition.Right,
    verticalPosition: VerticalPosition.Top,
};
const ANB_SNACKBAR_DEFAULT_OPTIONS = new InjectionToken('ANB_SNACKBAR_DEFAULT_OPTIONS');

class AnbBrowserNotSupportedComponent {
    constructor(browserSupportedService, router, uiConfig) {
        this.browserSupportedService = browserSupportedService;
        this.router = router;
        this.uiConfig = uiConfig;
    }
    ngOnInit() {
        this.redirectWhenSupported();
    }
    resizeWindow(event) {
        this.redirectWhenSupported();
    }
    redirectWhenSupported() {
        if (this.browserSupportedService.isBrowserSupported()) {
            const route = this.uiConfig.rootUri ?? ['/'];
            this.router.navigate(route);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserNotSupportedComponent, deps: [{ token: AnbBrowserSupportedService }, { token: i2$1.Router }, { token: UIConfiguration }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbBrowserNotSupportedComponent, selector: "anb-browser-not-supported-component", host: { listeners: { "window:resize": "resizeWindow($event)" } }, ngImport: i0, template: "<div class=\"vl-region\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <!-- Begin Content  -->\n\n    <!-- End Content -->\n  </div>\n</div>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserNotSupportedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-browser-not-supported-component', template: "<div class=\"vl-region\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <!-- Begin Content  -->\n\n    <!-- End Content -->\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: AnbBrowserSupportedService }, { type: i2$1.Router }, { type: UIConfiguration }]; }, propDecorators: { resizeWindow: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class AnbDeviceNotSupportedComponent {
    constructor(browserSupportedService, router, uiConfig) {
        this.browserSupportedService = browserSupportedService;
        this.router = router;
        this.uiConfig = uiConfig;
    }
    ngOnInit() {
        this.redirectWhenSupported();
    }
    resizeWindow(event) {
        this.redirectWhenSupported();
    }
    redirectWhenSupported() {
        const isDeviceSizeSupported = this.browserSupportedService.isDeviceSizeSupported();
        if (isDeviceSizeSupported || (!isDeviceSizeSupported && this.browserSupportedService.canBeUsedWithUnsupportedDeviceSize)) {
            const route = this.uiConfig.rootUri ?? ['/'];
            this.router.navigate(route);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbDeviceNotSupportedComponent, deps: [{ token: AnbBrowserSupportedService }, { token: i2$1.Router }, { token: UIConfiguration }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbDeviceNotSupportedComponent, selector: "anb-device-not-supported-component", host: { listeners: { "window:resize": "resizeWindow($event)" } }, ngImport: i0, template: "<div class=\"vl-region\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <!-- Begin Content  -->\n\n    <!-- End Content -->\n  </div>\n</div>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbDeviceNotSupportedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-device-not-supported-component', template: "<div class=\"vl-region\">\n  <div class=\"vl-layout vl-layout--wide\">\n    <!-- Begin Content  -->\n\n    <!-- End Content -->\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: AnbBrowserSupportedService }, { type: i2$1.Router }, { type: UIConfiguration }]; }, propDecorators: { resizeWindow: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class ErrorList {
}
class ErrorListItem {
}
class RootErrorList {
}

var ActivityStatusEnum;
(function (ActivityStatusEnum) {
    ActivityStatusEnum[ActivityStatusEnum["None"] = 0] = "None";
    ActivityStatusEnum[ActivityStatusEnum["Select"] = 1] = "Select";
    ActivityStatusEnum[ActivityStatusEnum["Insert"] = 2] = "Insert";
    ActivityStatusEnum[ActivityStatusEnum["View"] = 3] = "View";
    ActivityStatusEnum[ActivityStatusEnum["Edit"] = 4] = "Edit";
})(ActivityStatusEnum || (ActivityStatusEnum = {}));

class AnbFormGroup extends FormGroup {
    constructor() {
        super(...arguments);
        this.activityStatus = new BehaviorSubject(ActivityStatusEnum.None);
    }
    setActivityStatus(activityStatus) {
        this.activityStatus.next(activityStatus);
    }
}

class ErrorService {
    getErrorMessages(pFormGroup, vErrorList, customErrors) {
        let formGroupName = '';
        if (pFormGroup instanceof AnbFormGroup) {
            formGroupName = pFormGroup.name;
        }
        this.getErrorMessage(pFormGroup.errors, '', formGroupName, customErrors, vErrorList);
        Object.keys(pFormGroup.controls).forEach((key) => {
            if (pFormGroup.get(key) instanceof UntypedFormGroup) {
                const vSubErrorList = this.getErrorMessages(pFormGroup.get(key), vErrorList, customErrors);
                vErrorList.concat(vSubErrorList);
            }
            else if (pFormGroup.get(key) instanceof UntypedFormArray) {
                const vErrors = pFormGroup.get(key).errors;
                this.getErrorMessage(vErrors, key, formGroupName, customErrors, vErrorList);
                pFormGroup.get(key).controls.forEach((element) => {
                    if (element instanceof UntypedFormGroup) {
                        const vSubErrorList = this.getErrorMessages(element, vErrorList, customErrors);
                        vErrorList.concat(vSubErrorList);
                    }
                });
            }
            else {
                const vErrors = pFormGroup.get(key).errors;
                this.getErrorMessage(vErrors, key, formGroupName, customErrors, vErrorList);
            }
        });
        return vErrorList;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getErrorMessage(vErrors, key, groupname, customErrors, vErrorList) {
        if (vErrors != null) {
            Object.keys(vErrors).forEach((keyError) => {
                const vErroListItem = new ErrorListItem();
                const vCustomError = customErrors.filter((ce) => ((ce.formControlName.indexOf('.') === -1 && ce.formControlName === key) ||
                    (ce.formControlName.indexOf('.') > -1 && ce.formControlName.indexOf(key) > -1)) &&
                    ce.validationKey === keyError)[0];
                if (vCustomError) {
                    vErroListItem.value = vCustomError.errorMessage;
                    vErrorList.push(vErroListItem);
                }
                else {
                    vErroListItem.value = key + ': ' + keyError;
                    vErrorList.push(vErroListItem);
                }
                if (groupname) {
                    vErroListItem.value = groupname + ': ' + vErroListItem.value;
                }
            });
        }
    }
    scrollToTop() {
        const element = document.querySelector('body');
        element.scrollIntoView();
        window.scrollTo(0, 0);
    }
    scrollTo(id) {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class SnackBarOptions {
}

class AnbSnackBarService {
    constructor(snackBar, defaultOptions) {
        this.snackBar = snackBar;
        this.defaultOptions = defaultOptions;
    }
    showAlert(alert) {
        const config = {
            ...this.defaultOptions,
            duration: this.getAlertDurationInMilliseconds(alert, this.defaultOptions.durationInSeconds ?? 0),
            data: {
                ...alert,
            },
        };
        this.snackBar.openFromComponent(AnbSnackBarComponent, config);
    }
    getAlertDurationInMilliseconds(alert, defaultSeconds) {
        // Normalize the data
        const afterSeconds = !alert.closeAfterSeconds || alert.closeAfterSeconds <= 0 ? undefined : alert.closeAfterSeconds;
        // by default defaultSeconds is 0 (close manually only) but this is the backup to avoid we can't close the notification
        const backupDefaultValue = !!defaultSeconds && defaultSeconds > 0 ? defaultSeconds * 1000 : 5000;
        // We must be able to either close the snackbar or there must be time set.
        // If neither are set we give it a default closing time
        if (!alert.canClose && !afterSeconds)
            return backupDefaultValue;
        // If a time is provided return it
        if (!!afterSeconds)
            return afterSeconds * 1000;
        // A time is not set but close manually is on so we will be able to close the notification
        return 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSnackBarService, deps: [{ token: i1$4.MatSnackBar }, { token: ANB_SNACKBAR_DEFAULT_OPTIONS }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSnackBarService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSnackBarService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$4.MatSnackBar }, { type: SnackBarOptions, decorators: [{
                    type: Inject,
                    args: [ANB_SNACKBAR_DEFAULT_OPTIONS]
                }] }]; } });

class ClickEventService {
    constructor(document) {
        this.document = document;
        this.eventTargets = new BehaviorSubject(null);
        this.eventTargets$ = this.eventTargets.asObservable().pipe(filter$1((x) => x !== null));
        fromEvent(this.document, 'click')
            .pipe(map((x) => x.target))
            .subscribe((x) => this.eventTargets.next(x));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ClickEventService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ClickEventService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ClickEventService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

var KebabMenuAlignment;
(function (KebabMenuAlignment) {
    KebabMenuAlignment["left"] = "vl-popover--align-left";
    KebabMenuAlignment["right"] = "vl-popover--align-right";
    KebabMenuAlignment["center"] = "vl-popover--align-center";
})(KebabMenuAlignment || (KebabMenuAlignment = {}));

class AnbKebabMenuItemComponent {
    onListItemClick() {
        if (this.item.disabled ?? false)
            return;
        if (!this.item.callBackOnClick)
            return true;
        if (this.data) {
            this.item.callBackOnClick(this.data);
        }
        else {
            this.item.callBackOnClick();
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbKebabMenuItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbKebabMenuItemComponent, selector: "anb-kebab-menu-item", inputs: { index: "index", data: "data", item: "item" }, ngImport: i0, template: "<li *ngIf=\"index > 0\" role=\"none\" [ngClass]=\"[item.useSeperator ? 'vl-popover__link-list__separator' : '']\"></li>\n<ng-container *ngIf=\"!!item.icon; else anchorOnly\">\n  <li\n    (click)=\"onListItemClick()\"\n    class=\"flex-container vl-popover__link-list__item\"\n    [title]=\"item.tooltip ?? ''\"\n    [ngClass]=\"item.disabled ? 'kebab-menu-item-disabled-parent' : ''\"\n  >\n    <span\n      [ngClass]=\"item.disabled ? [item.icon, 'kebab-menu-item-disabled'] : item.icon\"\n      [attr.aria-disabled]=\"item.disabled\"\n      disabled=\"item.disabled\"\n      [attr.disabled]=\"item.disabled ? '' : null\"\n      class=\"vl-icon vl-icon--before vl-vi vl-link no-underline\"\n      aria-hidden=\"true\"\n    >\n      <a class=\"vl-link vl-link--block\">{{ item.text }}</a>\n    </span>\n  </li>\n</ng-container>\n<ng-template #anchorOnly>\n  <li class=\"vl-popover__link-list__item\" [title]=\"item.tooltip ?? ''\" [ngClass]=\"item.disabled ? 'kebab-menu-item-disabled-parent' : ''\">\n    <span\n      [ngClass]=\"{ 'kebab-menu-item-disabled': item.disabled }\"\n      [attr.aria-disabled]=\"item.disabled\"\n      disabled=\"item.disabled\"\n      [attr.disabled]=\"item.disabled ? '' : null\"\n      (click)=\"onListItemClick()\"\n    >\n      <a class=\"anb-kebab-menu-item vl-link vl-link--block\">{{ item.text }}</a>\n    </span>\n  </li>\n</ng-template>\n", styles: [".flex-container{padding:0}.flex-container span{padding:0 .5rem;margin-left:1rem}span.vl-icon.vl-vi.vl-link.no-underline:hover{text-decoration:none}span.vl-icon.vl-vi.vl-link.no-underline>a.vl-link.vl-link--block{padding:.8rem 1.5rem .8rem .5rem}.kebab-menu-item-disabled,.kebab-menu-item-disabled>a{pointer-events:none!important;color:#cbd2da!important}.kebab-menu-item-disabled-parent{cursor:not-allowed!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbKebabMenuItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-kebab-menu-item', template: "<li *ngIf=\"index > 0\" role=\"none\" [ngClass]=\"[item.useSeperator ? 'vl-popover__link-list__separator' : '']\"></li>\n<ng-container *ngIf=\"!!item.icon; else anchorOnly\">\n  <li\n    (click)=\"onListItemClick()\"\n    class=\"flex-container vl-popover__link-list__item\"\n    [title]=\"item.tooltip ?? ''\"\n    [ngClass]=\"item.disabled ? 'kebab-menu-item-disabled-parent' : ''\"\n  >\n    <span\n      [ngClass]=\"item.disabled ? [item.icon, 'kebab-menu-item-disabled'] : item.icon\"\n      [attr.aria-disabled]=\"item.disabled\"\n      disabled=\"item.disabled\"\n      [attr.disabled]=\"item.disabled ? '' : null\"\n      class=\"vl-icon vl-icon--before vl-vi vl-link no-underline\"\n      aria-hidden=\"true\"\n    >\n      <a class=\"vl-link vl-link--block\">{{ item.text }}</a>\n    </span>\n  </li>\n</ng-container>\n<ng-template #anchorOnly>\n  <li class=\"vl-popover__link-list__item\" [title]=\"item.tooltip ?? ''\" [ngClass]=\"item.disabled ? 'kebab-menu-item-disabled-parent' : ''\">\n    <span\n      [ngClass]=\"{ 'kebab-menu-item-disabled': item.disabled }\"\n      [attr.aria-disabled]=\"item.disabled\"\n      disabled=\"item.disabled\"\n      [attr.disabled]=\"item.disabled ? '' : null\"\n      (click)=\"onListItemClick()\"\n    >\n      <a class=\"anb-kebab-menu-item vl-link vl-link--block\">{{ item.text }}</a>\n    </span>\n  </li>\n</ng-template>\n", styles: [".flex-container{padding:0}.flex-container span{padding:0 .5rem;margin-left:1rem}span.vl-icon.vl-vi.vl-link.no-underline:hover{text-decoration:none}span.vl-icon.vl-vi.vl-link.no-underline>a.vl-link.vl-link--block{padding:.8rem 1.5rem .8rem .5rem}.kebab-menu-item-disabled,.kebab-menu-item-disabled>a{pointer-events:none!important;color:#cbd2da!important}.kebab-menu-item-disabled-parent{cursor:not-allowed!important}\n"] }]
        }], propDecorators: { index: [{
                type: Input
            }], data: [{
                type: Input
            }], item: [{
                type: Input
            }] } });

class AnbKebabMenuComponent {
    constructor() {
        this.subSink = new SubSink();
        this.clickEventService = inject(ClickEventService);
        this.id = v4();
        this.toggleId = `kebabToggle-${this.id}`;
        this.open = false;
        this.subSink.sink = this.clickEventService.eventTargets$
            .pipe(map((target) => target['id'] === this.toggleId), tap((isClicked) => (this.open = isClicked ? !this.open : false)), tap(() => (this.styleClass = `${this.open ? this.shownClass : this.hiddenClass}`)))
            .subscribe();
    }
    ngOnInit() {
        this.hiddenClass = `${this.menuParams.alignment} popover-hidden vl-popover`;
        this.shownClass = `${this.menuParams.alignment} popover-shown vl-popover`;
        this.styleClass = this.hiddenClass;
    }
    ngAfterViewInit() {
        const contentElement = this.popoverContent.nativeElement;
        if (!contentElement) {
            return;
        }
        this.resizeObserver = new ResizeObserver((entries) => {
            const button = this.kebabMenu.nativeElement;
            const entry = entries[0];
            const width = button.clientWidth;
            let offsetX;
            switch (this.menuParams.alignment) {
                case KebabMenuAlignment.center:
                    offsetX = (width / 2) - entry.contentRect.width / 2;
                    break;
                case KebabMenuAlignment.left:
                    offsetX = 0;
                    break;
                case KebabMenuAlignment.right:
                    offsetX = width - entry.contentRect.width;
                    break;
            }
            contentElement.style.transform = `translate(${offsetX}px, 10px)`;
        });
        this.resizeObserver.observe(contentElement);
    }
    ngOnDestroy() {
        this.subSink.unsubscribe();
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbKebabMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbKebabMenuComponent, selector: "anb-kebab-menu", inputs: { menuParams: "menuParams", data: "data" }, viewQueries: [{ propertyName: "kebabMenu", first: true, predicate: ["kebabMenu"], descendants: true }, { propertyName: "popoverContent", first: true, predicate: ["popoverContent"], descendants: true }], ngImport: i0, template: "<div #kebabMenu [ngClass]=\"open ? 'popover-shown' : 'popover-hidden'\" class=\"vl-popover {{ menuParams.alignment }}\" data-vl-popover>\n  <button class=\"vl-popover__toggle\" type=\"button\" aria-expanded=\"false\">\n    <i [id]=\"toggleId\" class=\"vl-vi vl-vi-u-badge\" [ngClass]=\"menuParams.icon\" aria-hidden=\"true\"></i>\n  </button>\n  <div #popoverContent class=\"vl-popover__content\">\n    <ul class=\"vl-popover__link-list\">\n      <anb-kebab-menu-item\n        *ngFor=\"let item of menuParams.menuItems; index as i\"\n        [item]=\"item\"\n        [data]=\"data\"\n        [index]=\"i\"\n      ></anb-kebab-menu-item>\n    </ul>\n  </div>\n</div>\n", styles: [".vl-popover{cursor:pointer;position:relative}.vl-popover__content{position:absolute;min-width:5rem;width:-moz-max-content;width:max-content;max-width:none!important;bottom:auto!important}.vl-popover__content ul{margin-bottom:0!important}div.vl-popover__content{display:none;will-change:transform}div.vl-popover.popover-hidden div.vl-popover__content{display:none}div.vl-popover.popover-shown div.vl-popover__content{display:block}.vl-popover--align-left .vl-popover__content:before{left:10px;right:auto}.vl-popover__content:before{display:block;content:\"\"}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: AnbKebabMenuItemComponent, selector: "anb-kebab-menu-item", inputs: ["index", "data", "item"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbKebabMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-kebab-menu', template: "<div #kebabMenu [ngClass]=\"open ? 'popover-shown' : 'popover-hidden'\" class=\"vl-popover {{ menuParams.alignment }}\" data-vl-popover>\n  <button class=\"vl-popover__toggle\" type=\"button\" aria-expanded=\"false\">\n    <i [id]=\"toggleId\" class=\"vl-vi vl-vi-u-badge\" [ngClass]=\"menuParams.icon\" aria-hidden=\"true\"></i>\n  </button>\n  <div #popoverContent class=\"vl-popover__content\">\n    <ul class=\"vl-popover__link-list\">\n      <anb-kebab-menu-item\n        *ngFor=\"let item of menuParams.menuItems; index as i\"\n        [item]=\"item\"\n        [data]=\"data\"\n        [index]=\"i\"\n      ></anb-kebab-menu-item>\n    </ul>\n  </div>\n</div>\n", styles: [".vl-popover{cursor:pointer;position:relative}.vl-popover__content{position:absolute;min-width:5rem;width:-moz-max-content;width:max-content;max-width:none!important;bottom:auto!important}.vl-popover__content ul{margin-bottom:0!important}div.vl-popover__content{display:none;will-change:transform}div.vl-popover.popover-hidden div.vl-popover__content{display:none}div.vl-popover.popover-shown div.vl-popover__content{display:block}.vl-popover--align-left .vl-popover__content:before{left:10px;right:auto}.vl-popover__content:before{display:block;content:\"\"}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { menuParams: [{
                type: Input
            }], data: [{
                type: Input
            }], kebabMenu: [{
                type: ViewChild,
                args: ['kebabMenu']
            }], popoverContent: [{
                type: ViewChild,
                args: ['popoverContent']
            }] } });

class AnbSharepointExplorerHeaderComponent {
    constructor() {
        this.title = "Bestanden";
        this.newFile = new EventEmitter();
        this.openBrowser = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSharepointExplorerHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbSharepointExplorerHeaderComponent, selector: "anb-sharepoint-explorer-header", inputs: { title: "title" }, outputs: { newFile: "newFile", openBrowser: "openBrowser" }, ngImport: i0, template: "<div class=\"sharepoint-explorer-header\">\n  <h2 class=\"vl-title vl-title--h2 sharepoint-explorer-header__title\">\n    {{ title }}\n  </h2>\n  <div class=\"sharepoint-explorer-header__actions\">\n    <ng-content></ng-content>\n    <button class=\"vl-button vl-button--secondary vl-button--narrow vl-button--icon-before\" (click)=\"openBrowser.emit()\">\n      <i class=\"vl-button__icon vl-vi vl-vi-external vl-button__icon--before\" aria-hidden=\"true\"></i> Open in Sharepoint\n    </button>\n    <button class=\"vl-button vl-button--secondary vl-button--narrow vl-button--icon-before\" (click)=\"newFile.emit()\">\n      <i class=\"vl-button__icon vl-vi vl-vi-add vl-button__icon--before\" aria-hidden=\"true\"></i> Toevoegen\n    </button>\n  </div>\n</div>\n", styles: [".sharepoint-explorer-header{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding-bottom:10px;border-bottom:.3rem solid #cbd2da}.sharepoint-explorer-header__title{font-size:3rem;margin:0}.sharepoint-explorer-header__actions .vl-button{margin-left:10px}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSharepointExplorerHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-sharepoint-explorer-header', template: "<div class=\"sharepoint-explorer-header\">\n  <h2 class=\"vl-title vl-title--h2 sharepoint-explorer-header__title\">\n    {{ title }}\n  </h2>\n  <div class=\"sharepoint-explorer-header__actions\">\n    <ng-content></ng-content>\n    <button class=\"vl-button vl-button--secondary vl-button--narrow vl-button--icon-before\" (click)=\"openBrowser.emit()\">\n      <i class=\"vl-button__icon vl-vi vl-vi-external vl-button__icon--before\" aria-hidden=\"true\"></i> Open in Sharepoint\n    </button>\n    <button class=\"vl-button vl-button--secondary vl-button--narrow vl-button--icon-before\" (click)=\"newFile.emit()\">\n      <i class=\"vl-button__icon vl-vi vl-vi-add vl-button__icon--before\" aria-hidden=\"true\"></i> Toevoegen\n    </button>\n  </div>\n</div>\n", styles: [".sharepoint-explorer-header{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding-bottom:10px;border-bottom:.3rem solid #cbd2da}.sharepoint-explorer-header__title{font-size:3rem;margin:0}.sharepoint-explorer-header__actions .vl-button{margin-left:10px}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], newFile: [{
                type: Output
            }], openBrowser: [{
                type: Output
            }] } });

class AnbSharepointExplorerBodyComponent {
    constructor() {
        this.deleteKeyword = new EventEmitter();
        this.deleteFile = new EventEmitter();
        this.addKeyword = new EventEmitter();
        this.uiService = inject(AnbUIService);
        this.subs = new SubSink();
    }
    ngOnInit() {
        this.buildMenuParams();
        this.sortedFiles = this.files.sort((a, b) => b.creationDate.getTime() - a.creationDate.getTime());
    }
    confirmTagDelete(keyword, file) {
        this.subs.sink = this.uiService.showConfirmDialog('Keyword verwijderen', `Bent u zeker dat u het keyword <strong>${keyword}</strong> voor bestand <strong>${file.name}</strong> wilt verwijderen?`, 'Ja', 'Nee')
            .subscribe((value) => {
            this.deleteKeyword.emit(value ? { file, keyword } : false);
        });
    }
    confirmFileDelete() {
        this.subs.sink = this.uiService.showConfirmDialog('Keyword verwijderen', `Bent u zeker dat u het bestand <strong>${this.activeFile.name}</strong> wilt verwijderen?`, 'Ja', 'Nee')
            .subscribe((value) => {
            this.deleteFile.emit(value ? { file: this.activeFile } : false);
        });
    }
    buildMenuParams() {
        if (this.canAddTag || this.canDelete) {
            this.menuParams = {
                icon: 'vl-vi-nav-show-more-vertical',
                alignment: KebabMenuAlignment.right,
                menuItems: []
            };
            this.canAddTag && this.menuParams.menuItems.push({ text: 'Tag toevoegen', disabled: false, tooltip: 'tag toevoegen aan bestand', useSeperator: true, icon: 'vl-vi-add', callBackOnClick: () => this.addKeyword.emit({ file: this.activeFile }) });
            this.canDelete && this.menuParams.menuItems.push({ text: 'Bestand verwijderen', disabled: false, tooltip: 'bestand verwijderen', useSeperator: false, icon: 'vl-vi-trash', callBackOnClick: () => this.confirmFileDelete() });
        }
        else {
            return;
        }
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSharepointExplorerBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbSharepointExplorerBodyComponent, selector: "anb-sharepoint-explorer-body", inputs: { files: "files", canDelete: "canDelete", canAddTag: "canAddTag" }, outputs: { deleteKeyword: "deleteKeyword", deleteFile: "deleteFile", addKeyword: "addKeyword" }, ngImport: i0, template: "<div class=\"anb-sharepoint-explorer-body\">\n  <div class=\"anb-sharepoint-explorer-body__file-wrapper\">\n    <div class=\"anb-sharepoint-explorer-body__file\" *ngFor=\"let file of sortedFiles\">\n      <div class=\"anb-sharepoint-explorer-body__file-title\">\n        <a href=\"{{ file.url }}\" target=\"_blank\">{{ file.name }}</a>\n      </div>\n      <div class=\"anb-sharepoint-explorer-body__file-tags\">\n        <div class=\"vl-pill vl-pill--closable anb-sharepoint-explorer-body__file-tag\" *ngFor=\"let keyword of file.keywords\">\n          <span class=\"vl-pill__text\">{{ keyword }}</span>\n          <button class=\"vl-pill__close\" type=\"button\" (click)=\"confirmTagDelete(keyword, file)\">\n            <span class=\"vl-pill__close__icon\" aria-hidden=\"true\"></span>\n            <span class=\"vl-u-visually-hidden\">Keyword verwijderen</span>\n          </button>\n        </div>\n      </div>\n\n      <div class=\"anb-sharepoint-explorer-body__file-date\">{{ file.creationDate | date: 'dd/MM/yyyy' }}</div>\n      <div class=\"anb-sharepoint-explorer-body__file-tag-add\" *ngIf=\"canAddTag || canDelete\">\n        <anb-kebab-menu [menuParams]=\"menuParams\" (click)=\"activeFile = file\"></anb-kebab-menu>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".anb-sharepoint-explorer-body__file-wrapper{display:flex;flex-direction:column;width:100%}.anb-sharepoint-explorer-body__file{width:100%;display:flex;flex-direction:row;align-items:center;border-bottom:1px solid #cbd2da}.anb-sharepoint-explorer-body__file>div{flex:1;align-content:center;padding:5px 10px}.anb-sharepoint-explorer-body__file>div:last-child{padding-right:5px}.anb-sharepoint-explorer-body__file>div:first-child{padding-left:5px}.anb-sharepoint-explorer-body__file>div:not(:first-child){text-align:right}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-title{text-overflow:ellipsis;overflow:hidden}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-tags{align-self:end}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-tag-add{flex:0}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-tag-add anb-kebab-menu{text-align:left}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-date{flex:0 0 100px}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-tag{margin-left:5px;margin-bottom:5px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AnbKebabMenuComponent, selector: "anb-kebab-menu", inputs: ["menuParams", "data"] }, { kind: "pipe", type: i1$1.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSharepointExplorerBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-sharepoint-explorer-body', template: "<div class=\"anb-sharepoint-explorer-body\">\n  <div class=\"anb-sharepoint-explorer-body__file-wrapper\">\n    <div class=\"anb-sharepoint-explorer-body__file\" *ngFor=\"let file of sortedFiles\">\n      <div class=\"anb-sharepoint-explorer-body__file-title\">\n        <a href=\"{{ file.url }}\" target=\"_blank\">{{ file.name }}</a>\n      </div>\n      <div class=\"anb-sharepoint-explorer-body__file-tags\">\n        <div class=\"vl-pill vl-pill--closable anb-sharepoint-explorer-body__file-tag\" *ngFor=\"let keyword of file.keywords\">\n          <span class=\"vl-pill__text\">{{ keyword }}</span>\n          <button class=\"vl-pill__close\" type=\"button\" (click)=\"confirmTagDelete(keyword, file)\">\n            <span class=\"vl-pill__close__icon\" aria-hidden=\"true\"></span>\n            <span class=\"vl-u-visually-hidden\">Keyword verwijderen</span>\n          </button>\n        </div>\n      </div>\n\n      <div class=\"anb-sharepoint-explorer-body__file-date\">{{ file.creationDate | date: 'dd/MM/yyyy' }}</div>\n      <div class=\"anb-sharepoint-explorer-body__file-tag-add\" *ngIf=\"canAddTag || canDelete\">\n        <anb-kebab-menu [menuParams]=\"menuParams\" (click)=\"activeFile = file\"></anb-kebab-menu>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".anb-sharepoint-explorer-body__file-wrapper{display:flex;flex-direction:column;width:100%}.anb-sharepoint-explorer-body__file{width:100%;display:flex;flex-direction:row;align-items:center;border-bottom:1px solid #cbd2da}.anb-sharepoint-explorer-body__file>div{flex:1;align-content:center;padding:5px 10px}.anb-sharepoint-explorer-body__file>div:last-child{padding-right:5px}.anb-sharepoint-explorer-body__file>div:first-child{padding-left:5px}.anb-sharepoint-explorer-body__file>div:not(:first-child){text-align:right}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-title{text-overflow:ellipsis;overflow:hidden}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-tags{align-self:end}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-tag-add{flex:0}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-tag-add anb-kebab-menu{text-align:left}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-date{flex:0 0 100px}.anb-sharepoint-explorer-body__file .anb-sharepoint-explorer-body__file-tag{margin-left:5px;margin-bottom:5px}\n"] }]
        }], propDecorators: { files: [{
                type: Input
            }], canDelete: [{
                type: Input
            }], canAddTag: [{
                type: Input
            }], deleteKeyword: [{
                type: Output
            }], deleteFile: [{
                type: Output
            }], addKeyword: [{
                type: Output
            }] } });

class AnbSharepointExplorerComponent {
    constructor() {
        this.canDelete = true;
        this.canAddTag = true;
        this.clickNewFile = new EventEmitter();
        this.clickOpenBrowser = new EventEmitter();
        this.deleteKeyword = new EventEmitter();
        this.deleteFile = new EventEmitter();
        this.addKeyword = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSharepointExplorerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbSharepointExplorerComponent, selector: "anb-sharepoint-explorer", inputs: { files: "files", canDelete: "canDelete", canAddTag: "canAddTag" }, outputs: { clickNewFile: "clickNewFile", clickOpenBrowser: "clickOpenBrowser", deleteKeyword: "deleteKeyword", deleteFile: "deleteFile", addKeyword: "addKeyword" }, ngImport: i0, template: "<div class=\"anb-sharepoint-explorer\">\n  <anb-sharepoint-explorer-header (newFile)=\"clickNewFile.emit()\" (openBrowser)=\"clickOpenBrowser.emit()\"\n    ><ng-content></ng-content\n  ></anb-sharepoint-explorer-header>\n  <anb-sharepoint-explorer-body\n    [files]=\"files\"\n    [canDelete]=\"canDelete\"\n    [canAddTag]=\"canAddTag\"\n    (deleteKeyword)=\"deleteKeyword.emit($event)\"\n    (deleteFile)=\"deleteFile.emit($event)\"\n    (addKeyword)=\"addKeyword.emit($event)\"\n  ></anb-sharepoint-explorer-body>\n</div>\n", styles: [".anb-sharepoint-explorer{display:flex;flex-direction:column;background-color:#f3f5f6;padding:10px 20px}\n"], dependencies: [{ kind: "component", type: AnbSharepointExplorerHeaderComponent, selector: "anb-sharepoint-explorer-header", inputs: ["title"], outputs: ["newFile", "openBrowser"] }, { kind: "component", type: AnbSharepointExplorerBodyComponent, selector: "anb-sharepoint-explorer-body", inputs: ["files", "canDelete", "canAddTag"], outputs: ["deleteKeyword", "deleteFile", "addKeyword"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbSharepointExplorerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-sharepoint-explorer', template: "<div class=\"anb-sharepoint-explorer\">\n  <anb-sharepoint-explorer-header (newFile)=\"clickNewFile.emit()\" (openBrowser)=\"clickOpenBrowser.emit()\"\n    ><ng-content></ng-content\n  ></anb-sharepoint-explorer-header>\n  <anb-sharepoint-explorer-body\n    [files]=\"files\"\n    [canDelete]=\"canDelete\"\n    [canAddTag]=\"canAddTag\"\n    (deleteKeyword)=\"deleteKeyword.emit($event)\"\n    (deleteFile)=\"deleteFile.emit($event)\"\n    (addKeyword)=\"addKeyword.emit($event)\"\n  ></anb-sharepoint-explorer-body>\n</div>\n", styles: [".anb-sharepoint-explorer{display:flex;flex-direction:column;background-color:#f3f5f6;padding:10px 20px}\n"] }]
        }], propDecorators: { files: [{
                type: Input
            }], canDelete: [{
                type: Input
            }], canAddTag: [{
                type: Input
            }], clickNewFile: [{
                type: Output
            }], clickOpenBrowser: [{
                type: Output
            }], deleteKeyword: [{
                type: Output
            }], deleteFile: [{
                type: Output
            }], addKeyword: [{
                type: Output
            }] } });

var ContextButtonAlignment;
(function (ContextButtonAlignment) {
    ContextButtonAlignment["left"] = "left";
    ContextButtonAlignment["right"] = "right";
    ContextButtonAlignment["center"] = "center";
})(ContextButtonAlignment || (ContextButtonAlignment = {}));
var ContextButtonType;
(function (ContextButtonType) {
    ContextButtonType["primary"] = "primary";
    ContextButtonType["secondary"] = "secondary";
    ContextButtonType["tertiary"] = "tertiary";
    ContextButtonType["naked"] = "naked";
})(ContextButtonType || (ContextButtonType = {}));

class AnbContextButtonItemComponent {
    onListItemClick() {
        if (this.item.disabled ?? false)
            return;
        if (!this.item.callBackOnClick)
            return true;
        if (this.data) {
            this.item.callBackOnClick(this.data);
        }
        else {
            this.item.callBackOnClick();
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbContextButtonItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbContextButtonItemComponent, selector: "anb-context-button-item", inputs: { index: "index", data: "data", item: "item" }, ngImport: i0, template: "<li *ngIf=\"index > 0\" role=\"none\" [ngClass]=\"[item.useSeperator ? 'vl-popover__link-list__separator' : '']\"></li>\n<ng-container *ngIf=\"!!item.icon; else anchorOnly\">\n  <li\n    (click)=\"onListItemClick()\"\n    class=\"flex-container vl-popover__link-list__item\"\n    [title]=\"item.tooltip ?? ''\"\n    [ngClass]=\"item.disabled ? 'context-button-item-disabled-parent' : ''\"\n  >\n    <span\n      [ngClass]=\"item.disabled ? [item.icon, 'context-button-item-disabled'] : item.icon\"\n      [attr.aria-disabled]=\"item.disabled\"\n      disabled=\"item.disabled\"\n      [attr.disabled]=\"item.disabled ? '' : null\"\n      class=\"vl-icon vl-icon--before vl-vi vl-link no-underline\"\n      aria-hidden=\"true\"\n    >\n      <a class=\"vl-link vl-link--block\">{{ item.text }}</a>\n    </span>\n  </li>\n</ng-container>\n<ng-template #anchorOnly>\n  <li\n    class=\"vl-popover__link-list__item\"\n    [title]=\"item.tooltip ?? ''\"\n    [ngClass]=\"item.disabled ? 'context-button-item-disabled-parent' : ''\"\n  >\n    <span\n      [ngClass]=\"{ 'context-button-item-disabled': item.disabled }\"\n      [attr.aria-disabled]=\"item.disabled\"\n      disabled=\"item.disabled\"\n      [attr.disabled]=\"item.disabled ? '' : null\"\n      (click)=\"onListItemClick()\"\n    >\n      <a class=\"anb-context-button-item vl-link vl-link--block\">{{ item.text }}</a>\n    </span>\n  </li>\n</ng-template>\n", styles: [".flex-container{padding:0}.flex-container span{padding:0 .5rem;margin-left:1rem}span.vl-icon.vl-vi.vl-link.no-underline:hover{text-decoration:none}span.vl-icon.vl-vi.vl-link.no-underline>a.vl-link.vl-link--block{padding:.8rem 1.5rem .8rem .5rem}.context-button-item-disabled,.context-button-item-disabled>a{pointer-events:none!important;color:#cbd2da!important}.context-button-item-disabled-parent{cursor:not-allowed!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbContextButtonItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-context-button-item', template: "<li *ngIf=\"index > 0\" role=\"none\" [ngClass]=\"[item.useSeperator ? 'vl-popover__link-list__separator' : '']\"></li>\n<ng-container *ngIf=\"!!item.icon; else anchorOnly\">\n  <li\n    (click)=\"onListItemClick()\"\n    class=\"flex-container vl-popover__link-list__item\"\n    [title]=\"item.tooltip ?? ''\"\n    [ngClass]=\"item.disabled ? 'context-button-item-disabled-parent' : ''\"\n  >\n    <span\n      [ngClass]=\"item.disabled ? [item.icon, 'context-button-item-disabled'] : item.icon\"\n      [attr.aria-disabled]=\"item.disabled\"\n      disabled=\"item.disabled\"\n      [attr.disabled]=\"item.disabled ? '' : null\"\n      class=\"vl-icon vl-icon--before vl-vi vl-link no-underline\"\n      aria-hidden=\"true\"\n    >\n      <a class=\"vl-link vl-link--block\">{{ item.text }}</a>\n    </span>\n  </li>\n</ng-container>\n<ng-template #anchorOnly>\n  <li\n    class=\"vl-popover__link-list__item\"\n    [title]=\"item.tooltip ?? ''\"\n    [ngClass]=\"item.disabled ? 'context-button-item-disabled-parent' : ''\"\n  >\n    <span\n      [ngClass]=\"{ 'context-button-item-disabled': item.disabled }\"\n      [attr.aria-disabled]=\"item.disabled\"\n      disabled=\"item.disabled\"\n      [attr.disabled]=\"item.disabled ? '' : null\"\n      (click)=\"onListItemClick()\"\n    >\n      <a class=\"anb-context-button-item vl-link vl-link--block\">{{ item.text }}</a>\n    </span>\n  </li>\n</ng-template>\n", styles: [".flex-container{padding:0}.flex-container span{padding:0 .5rem;margin-left:1rem}span.vl-icon.vl-vi.vl-link.no-underline:hover{text-decoration:none}span.vl-icon.vl-vi.vl-link.no-underline>a.vl-link.vl-link--block{padding:.8rem 1.5rem .8rem .5rem}.context-button-item-disabled,.context-button-item-disabled>a{pointer-events:none!important;color:#cbd2da!important}.context-button-item-disabled-parent{cursor:not-allowed!important}\n"] }]
        }], propDecorators: { index: [{
                type: Input
            }], data: [{
                type: Input
            }], item: [{
                type: Input
            }] } });

class AnbContextButtonComponent {
    constructor() {
        this.buttonType = ContextButtonType.primary;
        this.alignment = ContextButtonAlignment.center;
        this.closeOnClick = true;
        this.elementRef = inject(ElementRef);
        this.open = false;
    }
    // Detect clicks outside the component
    onClick(targetElement) {
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.open = false;
        }
    }
    onItemClicked() {
        if (this.closeOnClick) {
            this.open = false;
        }
    }
    toggleOpen() {
        this.open = !this.open;
    }
    ngAfterViewInit() {
        const contentElement = this.popoverContent.nativeElement;
        if (!contentElement) {
            return;
        }
        this.resizeObserver = new ResizeObserver((entries) => {
            const button = this.contextButton.nativeElement;
            const entry = entries[0];
            const width = button.clientWidth;
            let offsetX;
            switch (this.alignment) {
                case ContextButtonAlignment.center:
                    offsetX = (width / 2) - entry.contentRect.width / 2;
                    break;
                case ContextButtonAlignment.left:
                    offsetX = 0;
                    break;
                case ContextButtonAlignment.right:
                    offsetX = width - entry.contentRect.width;
                    break;
            }
            contentElement.style.transform = `translate(${offsetX}px, 10px)`;
        });
        this.resizeObserver.observe(contentElement);
    }
    ngOnDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbContextButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AnbContextButtonComponent, selector: "anb-context-button", inputs: { data: "data", icon: "icon", buttonText: "buttonText", buttonType: "buttonType", alignment: "alignment", menuItems: "menuItems", closeOnClick: "closeOnClick" }, host: { listeners: { "document:click": "onClick($event.target)" } }, viewQueries: [{ propertyName: "contextButton", first: true, predicate: ["contextButton"], descendants: true }, { propertyName: "popoverContent", first: true, predicate: ["popoverContent"], descendants: true }], ngImport: i0, template: "<div\n  #contextButton\n  [ngClass]=\"open ? 'popover-shown' : 'popover-hidden'\"\n  class=\"vl-popover vl-popover--align-{{ alignment }}\"\n  data-vl-popover\n>\n  <button\n    class=\"vl-button vl-button--{{ this.buttonType }} vl-button--narrow\"\n    [class.vl-button--icon-before]=\"icon\"\n    type=\"button\"\n    aria-expanded=\"false\"\n    (click)=\"toggleOpen()\"\n  >\n    <i *ngIf=\"icon\" class=\"vl-button__icon vl-button__icon--before vl-vi {{ icon }}\" aria-hidden=\"true\"></i>\n    <span> {{ buttonText }} </span>\n    <i class=\"vl-vi vl-vi-u-badge vl-vi-u-badge--grey vl-vi-u-badge--small vl-vi-arrow vl-vi-u-90deg\" aria-hidden=\"true\"></i>\n  </button>\n  <div #popoverContent class=\"vl-popover__content\">\n    <ul class=\"vl-popover__link-list\">\n      <anb-context-button-item\n        *ngFor=\"let item of menuItems; index as i\"\n        [item]=\"item\"\n        [data]=\"data\"\n        [index]=\"i\"\n        (click)=\"onItemClicked()\"\n      ></anb-context-button-item>\n    </ul>\n  </div>\n</div>\n", styles: [".vl-popover{cursor:pointer;position:relative}.vl-popover__content{position:absolute;min-width:5rem;width:-moz-max-content;width:max-content;max-width:none!important;bottom:auto!important}.vl-popover__content ul{margin-bottom:0!important}div.vl-popover__content{display:none;will-change:transform}div.vl-popover.popover-hidden div.vl-popover__content{display:none}div.vl-popover.popover-shown div.vl-popover__content{display:block}.vl-popover--align-left .vl-popover__content:before{left:10px;right:auto}.vl-popover__content:before{display:block;content:\"\"}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: AnbContextButtonItemComponent, selector: "anb-context-button-item", inputs: ["index", "data", "item"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbContextButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'anb-context-button', template: "<div\n  #contextButton\n  [ngClass]=\"open ? 'popover-shown' : 'popover-hidden'\"\n  class=\"vl-popover vl-popover--align-{{ alignment }}\"\n  data-vl-popover\n>\n  <button\n    class=\"vl-button vl-button--{{ this.buttonType }} vl-button--narrow\"\n    [class.vl-button--icon-before]=\"icon\"\n    type=\"button\"\n    aria-expanded=\"false\"\n    (click)=\"toggleOpen()\"\n  >\n    <i *ngIf=\"icon\" class=\"vl-button__icon vl-button__icon--before vl-vi {{ icon }}\" aria-hidden=\"true\"></i>\n    <span> {{ buttonText }} </span>\n    <i class=\"vl-vi vl-vi-u-badge vl-vi-u-badge--grey vl-vi-u-badge--small vl-vi-arrow vl-vi-u-90deg\" aria-hidden=\"true\"></i>\n  </button>\n  <div #popoverContent class=\"vl-popover__content\">\n    <ul class=\"vl-popover__link-list\">\n      <anb-context-button-item\n        *ngFor=\"let item of menuItems; index as i\"\n        [item]=\"item\"\n        [data]=\"data\"\n        [index]=\"i\"\n        (click)=\"onItemClicked()\"\n      ></anb-context-button-item>\n    </ul>\n  </div>\n</div>\n", styles: [".vl-popover{cursor:pointer;position:relative}.vl-popover__content{position:absolute;min-width:5rem;width:-moz-max-content;width:max-content;max-width:none!important;bottom:auto!important}.vl-popover__content ul{margin-bottom:0!important}div.vl-popover__content{display:none;will-change:transform}div.vl-popover.popover-hidden div.vl-popover__content{display:none}div.vl-popover.popover-shown div.vl-popover__content{display:block}.vl-popover--align-left .vl-popover__content:before{left:10px;right:auto}.vl-popover__content:before{display:block;content:\"\"}\n"] }]
        }], propDecorators: { data: [{
                type: Input
            }], icon: [{
                type: Input
            }], buttonText: [{
                type: Input,
                args: [{ required: true }]
            }], buttonType: [{
                type: Input
            }], alignment: [{
                type: Input
            }], menuItems: [{
                type: Input,
                args: [{ required: true }]
            }], closeOnClick: [{
                type: Input
            }], contextButton: [{
                type: ViewChild,
                args: ['contextButton']
            }], popoverContent: [{
                type: ViewChild,
                args: ['popoverContent']
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event.target']]
            }] } });

const sharedComponents = [
    AnbAlertComponent,
    AnbDataTableComponent,
    AnbModalComponent,
    AnbModalDialogComponent,
    AnbModalLoadingComponent,
    AnbPaginationComponent,
    AnbPopoverComponent,
    AnbWizardComponent,
    AnbWizardPaneComponent,
    AnbErrorSummaryComponent,
    AnbToggleComponent,
    AnbToggleButtonGroupComponent,
    AnbToggleButtonComponent,
    AnbBurgerprofielFooterComponent,
    AnbBurgerprofielHeaderComponent,
    AnbEnvironmentIndicatorComponent,
    AnbStepperComponent,
    AnbStepsComponent,
    AnbStepComponent,
    AnbAppHeaderComponent,
    AnbAccordionComponent,
    AnbAccordionItemComponent,
    AnbBrowserSupportedComponent,
    AnbBrowserNotSupportedComponent,
    AnbDeviceNotSupportedComponent,
    AnbSnackBarComponent,
    AnbExceptionModalComponent,
    AnbKebabMenuComponent,
    AnbKebabMenuItemComponent,
    AnbSharepointExplorerComponent,
    AnbSharepointExplorerHeaderComponent,
    AnbSharepointExplorerBodyComponent,
    AnbContextButtonComponent,
    AnbContextButtonItemComponent
];
const sharedPipes = [FormatCellPipe, SafePipe];
const uiRoutes = [
    {
        path: 'unsupported-browser',
        component: AnbBrowserNotSupportedComponent,
    },
    {
        path: 'unsupported-device',
        component: AnbDeviceNotSupportedComponent,
    },
];
class AnbUIElementsModule {
    static forRoot(configurationFactory) {
        return {
            ngModule: AnbUIElementsModule,
            providers: [{ provide: UIConfiguration, useFactory: configurationFactory }],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbUIElementsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AnbUIElementsModule, declarations: [AnbAlertComponent,
            AnbDataTableComponent,
            AnbModalComponent,
            AnbModalDialogComponent,
            AnbModalLoadingComponent,
            AnbPaginationComponent,
            AnbPopoverComponent,
            AnbWizardComponent,
            AnbWizardPaneComponent,
            AnbErrorSummaryComponent,
            AnbToggleComponent,
            AnbToggleButtonGroupComponent,
            AnbToggleButtonComponent,
            AnbBurgerprofielFooterComponent,
            AnbBurgerprofielHeaderComponent,
            AnbEnvironmentIndicatorComponent,
            AnbStepperComponent,
            AnbStepsComponent,
            AnbStepComponent,
            AnbAppHeaderComponent,
            AnbAccordionComponent,
            AnbAccordionItemComponent,
            AnbBrowserSupportedComponent,
            AnbBrowserNotSupportedComponent,
            AnbDeviceNotSupportedComponent,
            AnbSnackBarComponent,
            AnbExceptionModalComponent,
            AnbKebabMenuComponent,
            AnbKebabMenuItemComponent,
            AnbSharepointExplorerComponent,
            AnbSharepointExplorerHeaderComponent,
            AnbSharepointExplorerBodyComponent,
            AnbContextButtonComponent,
            AnbContextButtonItemComponent, FormatCellPipe, SafePipe], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule, i2$1.RouterModule, OverlayModule,
            PortalModule,
            MatSnackBarModule], exports: [AnbAlertComponent,
            AnbDataTableComponent,
            AnbModalComponent,
            AnbModalDialogComponent,
            AnbModalLoadingComponent,
            AnbPaginationComponent,
            AnbPopoverComponent,
            AnbWizardComponent,
            AnbWizardPaneComponent,
            AnbErrorSummaryComponent,
            AnbToggleComponent,
            AnbToggleButtonGroupComponent,
            AnbToggleButtonComponent,
            AnbBurgerprofielFooterComponent,
            AnbBurgerprofielHeaderComponent,
            AnbEnvironmentIndicatorComponent,
            AnbStepperComponent,
            AnbStepsComponent,
            AnbStepComponent,
            AnbAppHeaderComponent,
            AnbAccordionComponent,
            AnbAccordionItemComponent,
            AnbBrowserSupportedComponent,
            AnbBrowserNotSupportedComponent,
            AnbDeviceNotSupportedComponent,
            AnbSnackBarComponent,
            AnbExceptionModalComponent,
            AnbKebabMenuComponent,
            AnbKebabMenuItemComponent,
            AnbSharepointExplorerComponent,
            AnbSharepointExplorerHeaderComponent,
            AnbSharepointExplorerBodyComponent,
            AnbContextButtonComponent,
            AnbContextButtonItemComponent, FormatCellPipe, SafePipe, RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbUIElementsModule, providers: [
            AnbUIService,
            AlertService,
            AnbSnackBarService,
            ErrorService,
            ClickEventService,
            UIConfiguration,
            { provide: ANB_SNACKBAR_DEFAULT_OPTIONS, useValue: AnbSnackBarDefaultOptions },
        ], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            RouterModule.forChild(uiRoutes),
            OverlayModule,
            PortalModule,
            MatSnackBarModule, RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbUIElementsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...sharedComponents, ...sharedPipes],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        RouterModule.forChild(uiRoutes),
                        OverlayModule,
                        PortalModule,
                        MatSnackBarModule,
                    ],
                    exports: [...sharedComponents, ...sharedPipes, RouterModule],
                    providers: [
                        AnbUIService,
                        AlertService,
                        AnbSnackBarService,
                        ErrorService,
                        ClickEventService,
                        UIConfiguration,
                        { provide: ANB_SNACKBAR_DEFAULT_OPTIONS, useValue: AnbSnackBarDefaultOptions },
                    ],
                }]
        }] });

/* eslint-disable @typescript-eslint/no-explicit-any */
class AnbModal {
    constructor(componentFactoryResolver, applicationRef) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.applicationRef = applicationRef;
    }
    /**
     * Opens a modal dialog containing the given component.
     *
     */
    open(componentType, config) {
        const modalRef = new AnbModalRef();
        modalRef.data = config ? config.data : null;
        modalRef.anbModal = this;
        modalRef.instance = this.appendComponentToBody(componentType, modalRef);
        const component = modalRef.instance.instance;
        if (component && component.anbModalComponent) {
            component.anbModalComponent.open = true;
            component.anbModalComponent.close.subscribe(() => modalRef.close());
        }
        else {
            throw Error(`The dialog must implement interface IAnbModal.`);
        }
        return modalRef;
    }
    /**
     * Close a modal dialog containing the given component reference.
     *
     */
    close(componentRef) {
        const component = componentRef.instance;
        if (component && component.anbModalComponent) {
            component.anbModalComponent.startClosePaneAnimation().then(() => {
                component.anbModalComponent.overlayRef?.detach();
                this.destroyComponentFromBody(componentRef);
            });
        }
        else {
            this.destroyComponentFromBody(componentRef);
        }
    }
    /**
     * Append the component to the body
     *
     */
    appendComponentToBody(componentOrTemplateRef, modalRef) {
        const injector = Injector.create([
            {
                provide: AnbModalRef,
                useValue: modalRef,
            }
        ]);
        // Create a component reference from the component
        const componentRef = this.componentFactoryResolver.resolveComponentFactory(componentOrTemplateRef).create(injector);
        // Attach component to the appRef so that it's inside the ng component tree
        this.applicationRef.attachView(componentRef.hostView);
        // Get DOM element from component
        const domElem = componentRef.hostView.rootNodes[0];
        // Append DOM element to the body
        document.body.appendChild(domElem);
        return componentRef;
    }
    /**
     * Destroy the component form the body
     *
     */
    destroyComponentFromBody(componentRef) {
        this.applicationRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModal, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ApplicationRef }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModal }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbModal, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }]; } });

class AnbModalConfig {
}

class AnbBaseStepComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBaseStepComponent, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBaseStepComponent }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBaseStepComponent, decorators: [{
            type: Injectable
        }] });

/**
 * Decides if a route can be activated based on the supported browser
 *
 */
class AnbBrowserSupportedGuardService {
    constructor(browserSupportedService, router) {
        this.browserSupportedService = browserSupportedService;
        this.router = router;
    }
    /**
     * Decides if a route can be activated based on the supported browser
     */
    canActivate(route, state) {
        const isDeviceSizeSupported = this.browserSupportedService.isDeviceSizeSupported();
        if (!isDeviceSizeSupported && !this.browserSupportedService.canBeUsedWithUnsupportedDeviceSize) {
            return this.router.parseUrl('/unsupported-device');
        }
        const isBrowserSupported = this.browserSupportedService.isBrowserSupported();
        if (!isBrowserSupported) {
            return this.router.parseUrl('/unsupported-browser');
        }
        return true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserSupportedGuardService, deps: [{ token: AnbBrowserSupportedService }, { token: i2$1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserSupportedGuardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBrowserSupportedGuardService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: AnbBrowserSupportedService }, { type: i2$1.Router }]; } });
const AnbBrowserSupportedGuard = (next, state) => {
    return inject(AnbBrowserSupportedGuardService).canActivate(next, state);
};

class AnbHttpBaseValidationResponse {
}

class AnbHttpErrorResponse extends AnbHttpBaseValidationResponse {
}

class AnbHttpUtils {
    static getAnbHttpErrorResponse(response) {
        const result = new AnbHttpErrorResponse();
        if (response && response.error) {
            // Map ErrorMessage
            if (response.error.errorMessage) {
                result.errorMessage = response.error.errorMessage;
            }
            // Map StackTrace
            if (response.error.stackTrace) {
                result.stackTrace = response.error.stackTrace;
            }
            // Map IsValid
            if (response.error.isValid) {
                result.isValid = response.error.isValid;
            }
            // Map Messages
            if (response.error.messages) {
                result.messages = [];
                const errorKeys = Object.keys(response.error.messages);
                errorKeys.forEach((key) => {
                    const errorMessages = response.error.messages[key];
                    if (errorMessages && Array.isArray(errorMessages)) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        errorMessages.forEach((errorMessage) => {
                            result.messages.push({
                                level: errorMessage.level,
                                message: errorMessage.message,
                                type: errorMessage.type,
                            });
                        });
                    }
                });
            }
        }
        return result;
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * This class will handle the global http requests
 * DEPRECATED  use the split Authentication interceptor and error interceptor instead
 */
class AnbBaseHttpInterceptor {
    constructor() {
        this.errorTitle = 'Er deed zich een technische fout voor.';
        this.errorMessage = '<p>We proberen dit probleem zo snel mogelijk op te lossen. <br />Gelieve het later nog eens te proberen. <br /><br />Onze excuses voor het ongemak.</p>';
    }
    intercept(request, next) {
        /**
         *  Add Authorization token to request of our API.
         */
        if (this.authorizationUris.some((x) => request.url.indexOf(x) === 0)) {
            const token = this.token;
            if (token) {
                request = request.clone({
                    headers: request.headers.set('Authorization', 'Bearer ' + token),
                });
            }
        }
        /**
         *  Global error handling
         *  Redirect 401 error to adfs, all the other show a errormessage to the user
         */
        return next.handle(request).pipe(map$1((event) => {
            if (event instanceof HttpResponse) {
            }
            return event;
        }), retryWhen((errors) => errors.pipe(concatMap((error, count) => {
            if (count < this.httpRequestMaxRetry && (error.status === 504 || error.status === 0)) {
                return of(error.status);
            }
            return throwError(error);
        }))), catchError((error) => {
            if (error.status === 401) {
                this.handle401Error();
            }
            else if (error.status === 403) {
                this.handle403Error(error);
            }
            else if (error.status === 451) {
                this.handle451Error(error);
            }
            else if (error.status === 500) {
                this.handle500Error(error);
            }
            else if (error.status === 0) {
                this.handle0Error(error);
            }
            else if (error.status === 400 && error.error && error.error.isValid === false) {
                this.handleValidationError(error);
            }
            else {
                this.handleUnknownError(error);
            }
            return throwError(error);
        }));
    }
    // Unauthorized
    handle401Error() {
        this.redirectToAdfs();
    }
    // Forbidden
    handle403Error(error) {
        this.showError(error.message + this.getErrors(error));
    }
    // Unavailable because of legal reasons
    handle451Error(error) {
        this.showError(error.message + this.getErrors(error));
    }
    // Internal Server Error
    handle500Error(error) {
        let message = error.message + this.getErrors(error);
        if (!this.isDebugMode()) {
            message = this.getErrorMessageUser(error);
        }
        this.showError(message, this.errorTitle);
    }
    // Request failed Error - possible causes: api offline, no internet, blocker extension
    handle0Error(error) {
        let message = error.message + this.getErrors(error);
        if (!this.isDebugMode()) {
            message = `<p>We proberen dit probleem zo snel mogelijk op te lossen.<br />
      Controleer jij alvast even je internetverbinding? Schakel via jouw browser blokkerende extensies uit. Probeer het daarna nog een keer. <br /><br />Onze excuses voor het ongemak.</p>`;
        }
        this.showError(message, this.errorTitle);
    }
    // Other Unknown Error
    handleUnknownError(error) {
        let message = error.message + this.getErrors(error);
        if (!this.isDebugMode()) {
            message = this.getErrorMessageUser(error);
        }
        this.showError(message, this.errorTitle);
    }
    handleValidationError(error) {
        const anbHttpErrorResponse = AnbHttpUtils.getAnbHttpErrorResponse(error);
        this.showError(this.getValidationErrorsHtml(anbHttpErrorResponse));
    }
    /**
     * Check if the browser is in debug mode
     *
     */
    isDebugMode() {
        const threshold = 160;
        const isOverWidthThreshold = window.outerWidth - window.innerWidth > threshold;
        const isOverHeightThreshold = window.outerHeight - window.innerHeight > threshold;
        const w = window;
        if (!(isOverHeightThreshold && isOverWidthThreshold) &&
            ((w.Firebug && w.Firebug.chrome && w.Firebug.chrome.isInitialized) || isOverWidthThreshold || isOverHeightThreshold)) {
            return true;
        }
        return false;
    }
    // Generate html for validationerrors
    getValidationErrorsHtml(response) {
        let result = '';
        if (response.errorMessage) {
            result += `${response.errorMessage} <br />`;
        }
        if (response.messages.length > 0) {
            result += '<div class="vl-typography"><ul>';
            response.messages.forEach((m) => {
                result += `<li>${m.message}</li>`;
            });
            result += '</ul></div>';
        }
        return result;
    }
    /**
     * Generate html for a HttpErrorResponse
     *
     */
    getErrors(error) {
        let result = '';
        const messages = [];
        if (error && error.error) {
            if (typeof error.error === 'string' || error.error instanceof String) {
                // error is a string
                messages.push(error.error);
            }
            else {
                // error is an object
                const errorKeys = Object.keys(error.error);
                errorKeys.forEach((key) => {
                    messages.push(`${key}: ${error.error[key]}`);
                });
            }
        }
        if (messages.length > 0) {
            result += '<div class="vl-typography"><ul>';
            messages.forEach((message) => {
                result += `<li>${message}</li>`;
            });
            result += '</ul></div>';
        }
        return result;
    }
    /**
     * Gets the userfriendly UI Error message
     */
    getErrorMessageUser(error) {
        if (error) {
            if (error.error && error.error.errorMessageUser) {
                // use the error message sent by the api
                return error.error.errorMessageUser;
            }
            else {
                // use the default error message
                return this.errorMessage;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBaseHttpInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBaseHttpInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbBaseHttpInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class AnbErrorHandlerInterceptor {
    constructor() {
        this.errorTitle = 'Er deed zich een technische fout voor.';
        this.errorMessage = '<p>We proberen dit probleem zo snel mogelijk op te lossen. <br />Gelieve het later nog eens te proberen. <br /><br />Onze excuses voor het ongemak.</p>';
        this.httpRequestMaxRetry = 0;
        this.showError = (m, t) => {
            console.error(`Error occured "${t}" : ${m}`);
        };
    }
    intercept(request, next) {
        /**
         *  Global error handling
         *  Redirect 401 error to login page,
         *  show all the other errormessage to the user
         */
        return next.handle(request).pipe(map$1((event) => {
            if (event instanceof HttpResponse) {
            }
            return event;
        }), retryWhen((errors) => errors.pipe(concatMap((error, count) => {
            if (count < this.httpRequestMaxRetry && (error.status === 504 || error.status === 0)) {
                return of(error.status);
            }
            return throwError(error);
        }))), catchError((error) => {
            if (error.status === 401) {
                this.handle401Error(error);
            }
            else if (error.status === 403) {
                this.handle403Error(error);
            }
            else if (error.status === 451) {
                this.handle451Error(error);
            }
            else if (error.status === 500) {
                this.handle500Error(error);
            }
            else if (error.status === 0) {
                this.handle0Error(error);
            }
            else if (error.status === 400 && error.error && error.error.isValid === false) {
                this.handleValidationError(error);
            }
            else {
                this.handleUnknownError(error);
            }
            return throwError(error);
        }));
    }
    // Unauthorized
    handle401Error(error) {
        this.showError(error.message + this.getErrors(error));
    }
    // Forbidden
    handle403Error(error) {
        this.showError(error.message + this.getErrors(error));
    }
    // Unavailable because of legal reasons
    handle451Error(error) {
        this.showError(error.message + this.getErrors(error));
    }
    // Internal Server Error
    handle500Error(error) {
        let message = error.message + this.getErrors(error);
        if (!this.isDebugMode()) {
            message = this.getErrorMessageUser(error);
        }
        this.showError(message, this.errorTitle);
    }
    // Request failed Error - possible causes: api offline, no internet, blocker extension
    handle0Error(error) {
        let message = error.message + this.getErrors(error);
        if (!this.isDebugMode()) {
            message = `<p>We proberen dit probleem zo snel mogelijk op te lossen.<br />
            Controleer jij alvast even je internetverbinding? Schakel via jouw browser blokkerende extensies uit. Probeer het daarna nog een keer. <br /><br />Onze excuses voor het ongemak.</p>`;
        }
        this.showError(message, this.errorTitle);
    }
    // Other Unknown Error
    handleUnknownError(error) {
        let message = error.message + this.getErrors(error);
        if (!this.isDebugMode()) {
            message = this.getErrorMessageUser(error);
        }
        this.showError(message, this.errorTitle);
    }
    handleValidationError(error) {
        const anbHttpErrorResponse = AnbHttpUtils.getAnbHttpErrorResponse(error);
        this.showError(this.getValidationErrorsHtml(anbHttpErrorResponse));
    }
    /**
     * Check if the browser is in debug mode
     *
     */
    isDebugMode() {
        const threshold = 160;
        const isOverWidthThreshold = window.outerWidth - window.innerWidth > threshold;
        const isOverHeightThreshold = window.outerHeight - window.innerHeight > threshold;
        const w = window;
        if (!(isOverHeightThreshold && isOverWidthThreshold) &&
            ((w.Firebug && w.Firebug.chrome && w.Firebug.chrome.isInitialized) || isOverWidthThreshold || isOverHeightThreshold)) {
            return true;
        }
        return false;
    }
    // Generate html for validationerrors
    getValidationErrorsHtml(response) {
        let result = '';
        if (response.errorMessage) {
            result += `${response.errorMessage} <br />`;
        }
        if (response.messages.length > 0) {
            result += '<div class="vl-typography"><ul>';
            response.messages.forEach((m) => {
                result += `<li>${m.message}</li>`;
            });
            result += '</ul></div>';
        }
        return result;
    }
    /**
     * Generate html for a HttpErrorResponse
     *
     */
    getErrors(error) {
        let result = '';
        const messages = [];
        if (error && error.error) {
            if (typeof error.error === 'string' || error.error instanceof String) {
                // error is a string
                messages.push(error.error);
            }
            else {
                // error is an object
                const errorKeys = Object.keys(error.error);
                errorKeys.forEach((key) => {
                    messages.push(`${key}: ${error.error[key]}`);
                });
            }
        }
        if (messages.length > 0) {
            result += '<div class="vl-typography"><ul>';
            messages.forEach((message) => {
                result += `<li>${message}</li>`;
            });
            result += '</ul></div>';
        }
        return result;
    }
    /**
     * Gets the userfriendly UI Error message
     */
    getErrorMessageUser(error) {
        if (error) {
            if (error.error && error.error.errorMessageUser) {
                // use the error message sent by the api
                return error.error.errorMessageUser;
            }
            else {
                // use the default error message
                return this.errorMessage;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbErrorHandlerInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbErrorHandlerInterceptor, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbErrorHandlerInterceptor, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class AnbLoaderConfig {
}

/**
 * This service is used in the app.component and will show the loader "Even geduld" when the counder is not equal to 0
 *
 */
class AnbLoadingService {
    constructor() {
        /**
         * Subscribe to this BehaviorSubject to manage the loader
         *
         */
        this.loaderCounter = new BehaviorSubject(new LoadingModel(0, '', 250));
        this.loadingModel = new LoadingModel(0, '', 250);
        /**
         * Global counter to know or a loader should be displayed or not
         *
         */
        this.counter = 0;
    }
    /**
     * This method is called in the LoaderIntercepter for each starting http request and will increase the counter
     *
     */
    showLoader() {
        this.counter = this.counter + 1;
        this.loadingModel.counter = this.counter;
        setTimeout(() => this.loaderCounter.next(this.loadingModel), 0);
    }
    /**
     * This method is called in the LoaderIntercepter for each ending http request and will lower the counter
     *
     */
    hideLoader() {
        this.counter = this.counter - 1;
        this.loadingModel.counter = this.counter;
        setTimeout(() => this.loaderCounter.next(this.loadingModel), 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbLoadingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbLoadingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbLoadingService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * This class will handle http requests and show or hide a loader
 *
 */
class AnbLoaderInterceptor {
    constructor(config, loadingService) {
        this.config = config;
        this.loadingService = loadingService;
    }
    intercept(req, next) {
        if (this.config) {
            if (this.isIgnored(req.url, this.config.exclude, this.config.excludeRegexp)) {
                return next.handle(req);
            }
        }
        this.showLoader();
        return next.handle(req).pipe(finalize(() => {
            this.onEnd();
        }));
    }
    /**
     * When http request ended
     *
     */
    onEnd() {
        this.hideLoader();
    }
    /**
     * Show loader, called when the http request starts
     *
     */
    showLoader() {
        this.loadingService.showLoader();
    }
    /**
     * Hide loader, called when the http request ends
     *
     */
    hideLoader() {
        this.loadingService.hideLoader();
    }
    /**
     * Do not show the loader for some urls
     */
    isIgnored(url, excludeStrings, excludeRegexps) {
        if (excludeStrings) {
            // do not show the loader for urls in the `exclude` list
            if (excludeStrings.findIndex((str) => url.toLowerCase().startsWith(str)) !== -1) {
                return true;
            }
        }
        if (excludeRegexps) {
            const regExps = excludeRegexps.map((regexp) => new RegExp(regexp, 'i'));
            // do not show the loader for urls which matches regexps in the `excludeRegexp` list
            if (regExps.findIndex((regexp) => regexp.test(url)) !== -1) {
                return true;
            }
        }
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbLoaderInterceptor, deps: [{ token: AnbLoaderConfig, optional: true }, { token: AnbLoadingService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbLoaderInterceptor }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbLoaderInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: AnbLoaderConfig, decorators: [{
                    type: Optional
                }] }, { type: AnbLoadingService }]; } });

class SortSetting {
}

class AnbHttpValidationMessage {
}
var AnbHttpValidationMessageLevel;
(function (AnbHttpValidationMessageLevel) {
    AnbHttpValidationMessageLevel[AnbHttpValidationMessageLevel["Success"] = 0] = "Success";
    AnbHttpValidationMessageLevel[AnbHttpValidationMessageLevel["Error"] = 1] = "Error";
    AnbHttpValidationMessageLevel[AnbHttpValidationMessageLevel["Warning"] = 2] = "Warning";
    AnbHttpValidationMessageLevel[AnbHttpValidationMessageLevel["Info"] = 3] = "Info";
})(AnbHttpValidationMessageLevel || (AnbHttpValidationMessageLevel = {}));
var AnbHttpValidationMessageType;
(function (AnbHttpValidationMessageType) {
    AnbHttpValidationMessageType[AnbHttpValidationMessageType["Validation"] = 0] = "Validation";
    AnbHttpValidationMessageType[AnbHttpValidationMessageType["Error"] = 1] = "Error";
    AnbHttpValidationMessageType[AnbHttpValidationMessageType["General"] = 2] = "General";
})(AnbHttpValidationMessageType || (AnbHttpValidationMessageType = {}));

class Step {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(title, route, hidden = false) {
        this.title = title;
        this.route = route;
        this.hidden = hidden;
    }
}

class AnbUtils {
    static isEmpty(value) {
        return value == null // NULL value
            || value === undefined // undefined
            || value === 'undefined' // undefined
            || value.length === 0 // Array is empty
            || value === '00000000-0000-0000-0000-000000000000' // Guid empty
            || ((value instanceof Date && !isNaN(value.valueOf())) // Validate DateTime value and check min-max value
                && ((value <= new Date(1753, 0o1, 0o1)) // SQL DateTime minimum value
                    || (value >= new Date(9999, 12, 31, 23, 59, 59, 999))) // SQL DateTime maximum value
            );
    }
}

class AnbKboNummerUtils {
    /**
     * kbo nummer has 10 digits. the first one should be a 0 or a 1.
     * source: https://economie.fgov.be/nl/themas/ondernemingen/kruispuntbank-van/inschrijving-de-kruispuntbank
     */
    static isValid(kboNrInput) {
        const VALID_KBONR_REGEX = /^[0|1]{1}!*([0-9]!*){9}$/;
        return VALID_KBONR_REGEX.test(kboNrInput);
    }
}

/**
 * https://nl.wikipedia.org/wiki/Rijksregisternummer
 */
const AGE_LEGAL_ADULT = 18;
const LENGTH_VALID_NRN = 11; // Eg. 86081441359
const matchesNrnInterface = (nrn) => Boolean(nrn && nrn.birthDate && nrn.serial && nrn.checksum);
const mod97 = (input) => String(97 - (Number(input) % 97)).padStart(2, '0');
class AnbRijksregisternummerUtils {
    static getAge(nrn) {
        const birthDate = this.getBirthDate(nrn);
        return differenceInYears(new Date(), birthDate);
    }
    static getBirthDate(nrn) {
        const { birthDate, serial, checksum } = this.parse(nrn);
        const partialYear = birthDate.slice(0, 2); // Eg. '86' from '860814'
        const month = Number(birthDate.slice(2, 4)); // Eg. 8 from '860814'
        const day = Number(birthDate.slice(4, 6)); // Eg. 14 from '860814'
        let year;
        const checksum19 = mod97(`${birthDate}${serial}`);
        const checksum20 = mod97(`2${birthDate}${serial}`);
        if (checksum19 === checksum) {
            year = Number(`19${partialYear}`);
        }
        else if (checksum20 === checksum) {
            year = Number(`20${partialYear}`);
        }
        else {
            throw new Error(`Could not calculate birthDate with invalid checksum of "${checksum}", expected "${checksum19}" for 1900 or "${checksum20}" for 2000`);
        }
        const result = parse(`${year}-${month}-${day}`, 'yyyy-MM-dd', new Date());
        return result;
    }
    static isBiologicalFemale(nrnInput) {
        const { serial } = this.parse(nrnInput);
        return Number(serial) % 2 === 0;
    }
    static isBiologicalMale(nrnInput) {
        const { serial } = this.parse(nrnInput);
        return Number(serial) % 2 === 1;
    }
    static isEqual(nrn1, nrn2) {
        return this.normalize(nrn1) === this.normalize(nrn2);
    }
    static isLegalAdult(nrn) {
        return this.getAge(nrn) >= AGE_LEGAL_ADULT;
    }
    static normalize(nrn) {
        if (typeof nrn === 'string') {
            return nrn.replace(/[^\d]+/g, '');
        }
        if (matchesNrnInterface(nrn)) {
            return `${nrn.birthDate}${nrn.serial}${nrn.checksum}`;
        }
        throw new Error('Could not normalize nrn of invalid type');
    }
    static isValid(nrnInput) {
        try {
            AnbRijksregisternummerUtils.getBirthDate(nrnInput);
            return true;
        }
        catch (error) {
            return false;
        }
    }
    static parse(nrnInput) {
        if (typeof nrnInput === 'string') {
            const normalizedNrn = this.normalize(nrnInput);
            if (normalizedNrn.length !== LENGTH_VALID_NRN) {
                throw new Error('Could not parse nrn of invalid length');
            }
            const birthDate = normalizedNrn.slice(0, 6); // Eg. '860814' from '86081441359'
            const serial = normalizedNrn.slice(6, 9); // Eg. '413' from '86081441359'
            const checksum = normalizedNrn.slice(9, 11); // Eg. '59' from '86081441359'
            return { birthDate, serial, checksum };
        }
        if (matchesNrnInterface(nrnInput)) {
            return nrnInput;
        }
        throw new Error('Could not parse nrn of invalid type');
    }
}

class AnbExceptionModalService {
    constructor(anbModal) {
        this.anbModal = anbModal;
        this.open = false;
    }
    showException(value) {
        if (this.open) {
            return;
        }
        this.open = true;
        this.anbModal.open(AnbExceptionModalComponent, { data: value }).afterClosed.subscribe(() => { this.open = false; });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbExceptionModalService, deps: [{ token: AnbModal }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbExceptionModalService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnbExceptionModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AnbModal }]; } });

class KebabMenuParams {
    constructor() {
        this.icon = 'vl-vi-nav-show-more-vertical';
        this.alignment = KebabMenuAlignment.center;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { ANB_SNACKBAR_DEFAULT_OPTIONS, Alert, AlertService, AlertType, AnbAccordionComponent, AnbAccordionItemComponent, AnbAlertComponent, AnbAppHeaderComponent, AnbBaseHttpInterceptor, AnbBaseStepComponent, AnbBrowserNotSupportedComponent, AnbBrowserSupportedComponent, AnbBrowserSupportedGuard, AnbBurgerprofielFooterComponent, AnbBurgerprofielHeaderComponent, AnbContextButtonComponent, AnbContextButtonItemComponent, AnbDataTableComponent, AnbDeviceNotSupportedComponent, AnbEnvironmentIndicatorComponent, AnbErrorHandlerInterceptor, AnbErrorSummaryComponent, AnbExceptionModalComponent, AnbExceptionModalService, AnbHttpBaseValidationResponse, AnbHttpErrorResponse, AnbHttpUtils, AnbHttpValidationMessage, AnbHttpValidationMessageLevel, AnbHttpValidationMessageType, AnbKboNummerUtils, AnbKebabMenuComponent, AnbKebabMenuItemComponent, AnbLoaderConfig, AnbLoaderInterceptor, AnbLoadingService, AnbModal, AnbModalComponent, AnbModalConfig, AnbModalDialogComponent, AnbModalLoadingComponent, AnbModalPosition, AnbModalRef, AnbPaginationComponent, AnbPopoverComponent, AnbRijksregisternummerUtils, AnbSharepointExplorerBodyComponent, AnbSharepointExplorerComponent, AnbSharepointExplorerHeaderComponent, AnbSnackBarComponent, AnbSnackBarDefaultOptions, AnbSnackBarService, AnbStepComponent, AnbStepperComponent, AnbStepsComponent, AnbToggleButtonComponent, AnbToggleButtonGroupComponent, AnbToggleComponent, AnbUIElementsModule, AnbUIService, AnbUtils, AnbWizardComponent, AnbWizardPaneComponent, BrowserEnum, ColumnEditType, ColumnSetting, DeviceSizeEnum, Dialog, ErrorList, ErrorListItem, ErrorService, FormatCellPipe, HorizontalPosition, KebabMenuAlignment, KebabMenuParams, LoadingModel, RootErrorList, SafePipe, SnackBarAlert, SnackBarOptions, SortSetting, Step, StepperService, UIConfiguration, VerticalPosition };
